
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fYqD0", function(module, exports) {

$parcel$export(module.exports, "routeComponents", () => (parcelRequire("h3nb6")).routeComponents);
$parcel$export(module.exports, "NotFound", () => (parcelRequire("7Snc9")).NotFound);
$parcel$export(module.exports, "LazyRouteToRightEditor", () => (parcelRequire("4H46k")).LazyRouteToRightEditor);
$parcel$export(module.exports, "LazySpaceEditPage", () => (parcelRequire("4H46k")).LazySpaceEditPage);

var $h3nb6 = parcelRequire("h3nb6");

var $7Snc9 = parcelRequire("7Snc9");

var $4H46k = parcelRequire("4H46k");

});
parcelRegister("h3nb6", function(module, exports) {

$parcel$export(module.exports, "routeComponents", () => $c6a4b2258628a516$export$4d9abfe5519d76c6);
/* eslint-disable no-restricted-syntax */ 
var $gwFzn = parcelRequire("gwFzn");

var $64KID = parcelRequire("64KID");

var $kE2cJ = parcelRequire("kE2cJ");

var $17Y6d = parcelRequire("17Y6d");

var $eVA6A = parcelRequire("eVA6A");
parcelRequire("6v2ig");
var $jiFpb = parcelRequire("jiFpb");

var $ffwDS = parcelRequire("ffwDS");

var $dY7Nc = parcelRequire("dY7Nc");

var $d0pTF = parcelRequire("d0pTF");

var $24Erc = parcelRequire("24Erc");

var $3WxEl = parcelRequire("3WxEl");

var $6UoIL = parcelRequire("6UoIL");

var $kSvOq = parcelRequire("kSvOq");

var $isuOo = parcelRequire("isuOo");

var $5Hjge = parcelRequire("5Hjge");

var $4CYpP = parcelRequire("4CYpP");

var $iKMnK = parcelRequire("iKMnK");

var $1b9IW = parcelRequire("1b9IW");

var $byNy2 = parcelRequire("byNy2");

var $8Ue4W = parcelRequire("8Ue4W");

var $f6D9X = parcelRequire("f6D9X");

var $gM2ac = parcelRequire("gM2ac");

var $b46bP = parcelRequire("b46bP");

var $3Bgee = parcelRequire("3Bgee");

var $6QT4V = parcelRequire("6QT4V");

var $g2kt1 = parcelRequire("g2kt1");

var $aGl0i = parcelRequire("aGl0i");

var $6L3RG = parcelRequire("6L3RG");

var $2fP83 = parcelRequire("2fP83");

var $gzxVF = parcelRequire("gzxVF");

var $4jPVU = parcelRequire("4jPVU");

var $dfVB9 = parcelRequire("dfVB9");

var $1RdAz = parcelRequire("1RdAz");

var $gRPTO = parcelRequire("gRPTO");

var $aGq9N = parcelRequire("aGq9N");

var $kDYTs = parcelRequire("kDYTs");

var $6VTQj = parcelRequire("6VTQj");

var $e7w9d = parcelRequire("e7w9d");

var $kn7N3 = parcelRequire("kn7N3");

var $88o5m = parcelRequire("88o5m");

var $lO8N3 = parcelRequire("lO8N3");

var $a9fiu = parcelRequire("a9fiu");

var $bnrhk = parcelRequire("bnrhk");

var $4jOiz = parcelRequire("4jOiz");

var $kfBE6 = parcelRequire("kfBE6");

var $f739q = parcelRequire("f739q");

var $6AwS3 = parcelRequire("6AwS3");

var $1LbgK = parcelRequire("1LbgK");

var $fIJjV = parcelRequire("fIJjV");

var $dXC0J = parcelRequire("dXC0J");

var $4kytX = parcelRequire("4kytX");

var $e1x2n = parcelRequire("e1x2n");

var $bCsEo = parcelRequire("bCsEo");

var $crpJB = parcelRequire("crpJB");

var $c8KH6 = parcelRequire("c8KH6");

var $4oYhL = parcelRequire("4oYhL");

var $jABgD = parcelRequire("jABgD");

var $3fx4Y = parcelRequire("3fx4Y");

var $boeN3 = parcelRequire("boeN3");

var $6xYtK = parcelRequire("6xYtK");

var $tpIej = parcelRequire("tpIej");

var $eLEnw = parcelRequire("eLEnw");

var $7DnqF = parcelRequire("7DnqF");

var $9AAzV = parcelRequire("9AAzV");

var $7Hjeq = parcelRequire("7Hjeq");

var $8plBz = parcelRequire("8plBz");

var $ggmLP = parcelRequire("ggmLP");

var $k0Wco = parcelRequire("k0Wco");

var $2m9tD = parcelRequire("2m9tD");

var $gxgRl = parcelRequire("gxgRl");

var $7w9zb = parcelRequire("7w9zb");

var $cTDal = parcelRequire("cTDal");

var $9SC9O = parcelRequire("9SC9O");

var $blAko = parcelRequire("blAko");

var $6as7N = parcelRequire("6as7N");

var $g1wzK = parcelRequire("g1wzK");

var $eo6PJ = parcelRequire("eo6PJ");

var $br3iV = parcelRequire("br3iV");

var $7YL3H = parcelRequire("7YL3H");

var $5anXn = parcelRequire("5anXn");

var $iWY3L = parcelRequire("iWY3L");

var $fX9iO = parcelRequire("fX9iO");

var $eeFAx = parcelRequire("eeFAx");

var $gNmMt = parcelRequire("gNmMt");

var $a7Ld6 = parcelRequire("a7Ld6");

var $9IOVR = parcelRequire("9IOVR");

var $xgs7O = parcelRequire("xgs7O");

var $3rtEO = parcelRequire("3rtEO");

var $1jVVc = parcelRequire("1jVVc");

var $hgiBo = parcelRequire("hgiBo");

var $i9drS = parcelRequire("i9drS");

var $fwL0r = parcelRequire("fwL0r");

var $fOd6C = parcelRequire("fOd6C");

var $94xqy = parcelRequire("94xqy");

var $ixCU2 = parcelRequire("ixCU2");

var $4AQPd = parcelRequire("4AQPd");

var $l7qKm = parcelRequire("l7qKm");

var $fUWTS = parcelRequire("fUWTS");

var $eQpkq = parcelRequire("eQpkq");

var $gX83r = parcelRequire("gX83r");

var $9eYom = parcelRequire("9eYom");

var $4Qsqj = parcelRequire("4Qsqj");

var $8MIZj = parcelRequire("8MIZj");

var $lC063 = parcelRequire("lC063");

var $gFtFZ = parcelRequire("gFtFZ");

var $lp83g = parcelRequire("lp83g");

var $d7BQI = parcelRequire("d7BQI");

var $jPkZL = parcelRequire("jPkZL");

var $g2ENM = parcelRequire("g2ENM");

var $bNttk = parcelRequire("bNttk");

var $4GGFl = parcelRequire("4GGFl");

var $7mgbk = parcelRequire("7mgbk");

var $lDUJq = parcelRequire("lDUJq");

var $6pqj5 = parcelRequire("6pqj5");

var $jZAYF = parcelRequire("jZAYF");

var $8tCRO = parcelRequire("8tCRO");

var $b4Fyf = parcelRequire("b4Fyf");

var $2Kk8c = parcelRequire("2Kk8c");

var $8YXSL = parcelRequire("8YXSL");

var $5aYM8 = parcelRequire("5aYM8");

var $4ipZd = parcelRequire("4ipZd");
function $c6a4b2258628a516$var$redirect(name) {
    const redirectComponent = ({ params: params = {} })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
            name: name,
            params: params
        });
    redirectComponent.NAVIGATION_PARAMS = ()=>false;
    return redirectComponent;
}
const $c6a4b2258628a516$export$4d9abfe5519d76c6 = (0, $jiFpb.processNavigationParams)({
    [(0, $64KID.namedRoutes).BASE.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).WIKI.name),
    [(0, $64KID.namedRoutes).WIKI.name]: (0, $e1x2n.WikiRoute),
    [(0, $64KID.namedRoutes).HOME.name]: (0, $bCsEo.HomeRoute),
    [(0, $64KID.namedRoutes).MOBILE_TAKEOVER_PAGE.name]: (0, $4kytX.MobileTakeoverPageRoute),
    [(0, $64KID.namedRoutes).TEMPLATE_GALLERY.name]: (0, $dXC0J.TemplateGalleryRoute),
    [(0, $64KID.namedRoutes).EDIT_PAGE.name]: (0, $4oYhL.EditPageRoute),
    [(0, $64KID.namedRoutes).EDIT_BLOG.name]: (0, $jABgD.EditBlogRoute),
    [(0, $64KID.namedRoutes).EDIT_PAGE_V2.name]: (0, $3fx4Y.EditPageOrBlogV2Route),
    [(0, $64KID.namedRoutes).EDIT_BLOG_V2.name]: (0, $3fx4Y.EditPageOrBlogV2Route),
    [(0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name]: (0, $boeN3.EditPageEmbedRoute),
    [(0, $64KID.namedRoutes).CREATE_CONTENT.name]: (0, $lC063.CreateContentRoute),
    [(0, $64KID.namedRoutes).CREATE_PAGE.name]: (0, $c8KH6.CreatePageRoute),
    [(0, $64KID.namedRoutes).CREATE_BLOG.name]: (0, $crpJB.CreateBlogRoute),
    [(0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name]: (0, $ffwDS.RedirectOldCreatePage),
    [(0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name]: (0, $ffwDS.RedirectOldCreatePage),
    [(0, $64KID.namedRoutes).CREATE_PAGE_VARIABLES_ACTION_LEGACY.name]: (0, $ffwDS.RedirectOldCreatePage),
    [(0, $64KID.namedRoutes).RESUME_DRAFT_LEGACY.name]: (0, $l7qKm.ResumeDraftLegacyRoute),
    [(0, $64KID.namedRoutes).COPY_PAGE_LEGACY.name]: (0, $17Y6d.RedirectLegacyCopyPageLoader),
    [(0, $64KID.namedRoutes).DASHBOARD_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    [(0, $64KID.namedRoutes).SPA_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    [(0, $64KID.namedRoutes).INDEX_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    [(0, $64KID.namedRoutes).VIEW_PAGE_ACTION_LEGACY.name]: (0, $eVA6A.RedirectLegacyViewPageLoader),
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW_INDEX_ACTION_LEGACY.name]: (0, $94xqy.RedirectToSpaceOverview),
    [(0, $64KID.namedRoutes).SPACE_INDEX_ACTION_LEGACY.name]: (0, $94xqy.RedirectToSpaceOverview),
    // it should be after "INDEX_ACTION_LEGACY", and can't be the last one, as it will brake navigation to space settings
    [(0, $64KID.namedRoutes).ACTION_REDIRECT_LEGACY.name]: (0, $4AQPd.ActionRedirectLegacyRoute),
    [(0, $64KID.namedRoutes).SPACE_DIRECTORY.name]: (0, $kDYTs.SpaceDirectoryRoute),
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW_REDIRECT_LEGACY.name]: (0, $94xqy.RedirectToSpaceOverview),
    [(0, $64KID.namedRoutes).SPACE_INDEX.name]: (0, $8MIZj.SpaceIndexRoute),
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW.name]: (0, $e7w9d.SpaceOverviewRoute),
    [(0, $64KID.namedRoutes).COMPANY_HUB.name]: (0, $kn7N3.CompanyHubRoute),
    [(0, $64KID.namedRoutes).COMPANY_HUB_ANALYTICS.name]: (0, $88o5m.CompanyHubAnalyticsRoute),
    [(0, $64KID.namedRoutes).COMPANY_HUB_EDIT.name]: (0, $lO8N3.CompanyHubEditRoute),
    [(0, $64KID.namedRoutes).COMPANY_HUB_SETTINGS.name]: (0, $a9fiu.CompanyHubSettingsRoute),
    [(0, $64KID.namedRoutes).GLOBAL_PAGE_FORGE.name]: (0, $6UoIL.GlobalPageForgeAppsRoute),
    [(0, $64KID.namedRoutes).SPACE_PAGES.name]: (0, $bnrhk.SpacePagesRoute),
    [(0, $64KID.namedRoutes).VIEW_PAGE.name]: (0, $gFtFZ.ViewPageOrBlogRoute),
    [(0, $64KID.namedRoutes).BLOG_HOME.name]: (0, $4jOiz.BlogHomeRoute),
    [(0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name]: (0, $gFtFZ.ViewPageOrBlogRoute),
    [(0, $64KID.namedRoutes).VIEW_BLOG.name]: (0, $gFtFZ.ViewPageOrBlogRoute),
    [(0, $64KID.namedRoutes).WHITEBOARD_HOME.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).SPACE_PAGES.name),
    [(0, $64KID.namedRoutes).WHITEBOARD_BOARD.name]: (0, $fUWTS.WhiteboardRoute),
    [(0, $64KID.namedRoutes).DATABASE_VIEW.name]: (0, $4Qsqj.DatabaseViewRoute),
    [(0, $64KID.namedRoutes).EMBED_VIEW.name]: (0, $9eYom.EmbedViewRoute),
    [(0, $64KID.namedRoutes).FOLDER_VIEW.name]: (0, $gX83r.FolderViewRoute),
    [(0, $64KID.namedRoutes).CONTACT_ADMINISTRATOR.name]: (0, $7Hjeq.ContactAdministratorRoute),
    [(0, $64KID.namedRoutes).SPACE_CALENDARS.name]: (0, $gRPTO.SpaceTeamCalendarsRoute),
    [(0, $64KID.namedRoutes).SPACE_CALENDARS_SUBCALENDAR.name]: (0, $gRPTO.SpaceTeamCalendarsRoute),
    [(0, $64KID.namedRoutes).SPACE_EMBEDDED_SUBCALENDAR.name]: (0, $aGq9N.SpaceEmbeddedSubcalendarRoute),
    [(0, $64KID.namedRoutes).DISCOVER.name]: (0, $ixCU2.RedirectToHomeWithQuery)({
        feed: ''
    }),
    [(0, $64KID.namedRoutes).ALL_UPDATES.name]: (0, $ixCU2.RedirectToHomeWithQuery)({
        feed: 0
    }),
    [(0, $64KID.namedRoutes).POPULAR.name]: (0, $ixCU2.RedirectToHomeWithQuery)({
        feed: 1,
        feedType: 'POPULAR'
    }),
    [(0, $64KID.namedRoutes).MY_WORK_HOME.name]: (0, $ixCU2.RedirectToHomeWithQuery)({
        recentTab: 1
    }),
    [(0, $64KID.namedRoutes).MY_WORK_DRAFTS.name]: (0, $ixCU2.RedirectToHomeWithQuery)({
        recentTab: 2
    }),
    [(0, $64KID.namedRoutes).RECENT_DRAFTS.name]: (0, $ixCU2.RedirectToHomeWithQuery)({
        recentTab: 2
    }),
    [(0, $64KID.namedRoutes).MY_WORK_RECENT.name]: (0, $ixCU2.RedirectToHomeWithQuery)({
        recentTab: 1,
        filter: 'WORKED_ON'
    }),
    [(0, $64KID.namedRoutes).RECENT_PAGES.name]: (0, $ixCU2.RedirectToHomeWithQuery)({
        recentTab: 1
    }),
    [(0, $64KID.namedRoutes).MY_RECENTLY_VISITED.name]: (0, $ixCU2.RedirectToHomeWithQuery)({
        recentTab: 0
    }),
    [(0, $64KID.namedRoutes).RECENT_VISITED.name]: (0, $ixCU2.RedirectToHomeWithQuery)({
        recentTab: 0
    }),
    [(0, $64KID.namedRoutes).MY_SAVED_FOR_LATER.name]: (0, $ixCU2.RedirectToHomeWithQuery)({
        recentTab: 3
    }),
    [(0, $64KID.namedRoutes).RECENT_SAVED.name]: (0, $ixCU2.RedirectToHomeWithQuery)({
        recentTab: 3
    }),
    [(0, $64KID.namedRoutes).TEMPLATE_MIGRATION_PREVIEW.name]: (0, $f739q.TemplateMigrationPreviewRoute),
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE.name]: (0, $6AwS3.TemplateEditorRoute),
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE_BLUEPRINT.name]: (0, $6AwS3.TemplateEditorRoute),
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE_SPACE.name]: (0, $6AwS3.TemplateEditorRoute),
    [(0, $64KID.namedRoutes).CREATE_TEMPLATE.name]: (0, $6AwS3.TemplateEditorRoute),
    [(0, $64KID.namedRoutes).CREATE_TEMPLATE_SPACE.name]: (0, $6AwS3.TemplateEditorRoute),
    [(0, $64KID.namedRoutes).ADVANCED_SEARCH.name]: (0, $d0pTF.AdvancedSearchRoute),
    [(0, $64KID.namedRoutes).EXTERNAL_SHARE.name]: (0, $3WxEl.ExternalShareRoute),
    [(0, $64KID.namedRoutes).PEOPLE_DIRECTORY.name]: (0, $8Ue4W.PeopleDirectoryRoute),
    [(0, $64KID.namedRoutes).MARKETPLACE_APP_REQUESTS.name]: (0, $f6D9X.MarketplaceRoute),
    [(0, $64KID.namedRoutes).MARKETPLACE_MANAGE_PROMOTIONS.name]: (0, $f6D9X.MarketplaceRoute),
    [(0, $64KID.namedRoutes).MARKETPLACE_FIND_APPS.name]: (0, $f6D9X.MarketplaceRoute),
    [(0, $64KID.namedRoutes).CONTENT_HISTORY.name]: (0, $fIJjV.ContentHistoryRoute),
    [(0, $64KID.namedRoutes).ONBOARDING.name]: (0, $1LbgK.OnboardingRoute),
    [(0, $64KID.namedRoutes).ADMIN_GLOBAL_AUTOMATION.name]: (0, $4CYpP.GlobalAutomationRoute),
    [(0, $64KID.namedRoutes).ADMIN_NEW_GLOBAL_PERMISSIONS.name]: (0, $kSvOq.GlobalPermissionRoute),
    [(0, $64KID.namedRoutes).ADMIN_COMPANY_HUB_PERMISSIONS.name]: (0, $isuOo.AdminCompanyHubPermissionsRoute),
    [(0, $64KID.namedRoutes).ADMIN_COMPANY_HOME_BUILDER.name]: (0, $5Hjge.CompanyHomeBuilderRoute),
    [(0, $64KID.namedRoutes).ADMIN_CUSTOMIZE_NAVIGATION.name]: (0, $5Hjge.CustomizeNavigationRoute),
    [(0, $64KID.namedRoutes).ADMIN_NEW_GLOBAL_PERMISSIONS_USER_DETAILS.name]: (0, $iKMnK.GlobalPermissionUserDetailsRoute),
    [(0, $64KID.namedRoutes).ADMIN_EDIT_EXTERNAL_SHARING.name]: (0, $9AAzV.PublicLinksSettingsPageRoute),
    [(0, $64KID.namedRoutes).ADMIN_FORGE_APPS.name]: (0, $dY7Nc.AdminForgeAppsRoute),
    [(0, $64KID.namedRoutes).ADMIN_BETA_FEATURES.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).ADMIN_NEW_FEATURES.name),
    [(0, $64KID.namedRoutes).ADMIN_NEW_FEATURES.name]: (0, $24Erc.BetaFeaturesRoute),
    [(0, $64KID.namedRoutes).ADMIN_NOTIFICATIONS.name]: (0, $br3iV.AdminNotificationsRoute),
    [(0, $64KID.namedRoutes).SITE_ANALYTICS.name]: (0, $g2ENM.SiteAnalyticsRoute),
    [(0, $64KID.namedRoutes).SITE_ANALYTICS_PERMISSIONS.name]: (0, $bNttk.SiteAnalyticsPermissionsRoute),
    [(0, $64KID.namedRoutes).SPACE_ANALYTICS.name]: (0, $7mgbk.SpaceAnalyticsRoute),
    [(0, $64KID.namedRoutes).SPACE_ANALYTICS_PERMISSIONS.name]: (0, $lDUJq.SpaceAnalyticsPermissionsRoute),
    [(0, $64KID.namedRoutes).PAGE_ANALYTICS.name]: (0, $4GGFl.PageAnalyticsRoute),
    [(0, $64KID.namedRoutes).SPACE_ARCHIVED_PAGES.name]: (0, $4jPVU.SpaceArchivedPagesRoute),
    [(0, $64KID.namedRoutes).SPACE_BULK_TOOLS.name]: (0, $kfBE6.SpaceBulkToolsRoute),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE.name]: (0, $6VTQj.SpaceSettingsLandingPageRoute),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE_ALT.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE.name),
    [(0, $64KID.namedRoutes).SPACE_FORGE_APPS.name]: (0, $gM2ac.SpaceForgeAppsRoute),
    [(0, $64KID.namedRoutes).SPACE_CUSTOM_CONTENT_LIST.name]: (0, $tpIej.SpaceCustomContentListRoute),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_FORGE_APPS.name]: (0, $b46bP.SpaceSettingsForgeAppsRoute),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_ARCHIVE_SPACE.name]: (0, $3Bgee.SpaceSettingsArchiveSpaceRoute),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EDITOR_CONVERSION.name]: (0, $6QT4V.SpaceSettingsEditorConversionRoute),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AUTOMATION.name]: (0, $6xYtK.SpaceSettingsAutomationRoute),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AVATARS_AND_STATUS.name]: (0, $g2kt1.SpaceSettingsContentStateRoute),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_CONTENT_STATE.name]: (0, $g2kt1.SpaceSettingsContentStateRoute),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_DATA_CLASSIFICATION.name]: (0, $dfVB9.SpaceSettingsDataClassificationRoute),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE.name]: (0, $7w9zb.SpaceSettingsExportSpaceUnavailableRoute),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EXPORT.name]: (0, $8tCRO.LazyExportSpaceRoute),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_RELATED_PAGES.name]: (0, $aGl0i.SpaceSettingsRelatedPagesRoute),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EDIT_FEATURES.name]: (0, $6L3RG.SpaceSettingsEditFeaturesRoute),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_DETAILS.name]: (0, $2fP83.SpaceSettingsDetailsRoute),
    [(0, $64KID.namedRoutes).SPACE_QUESTIONS_NATIVE.name]: (0, $d7BQI.QuestionsRoute),
    [(0, $64KID.namedRoutes).SPACE_QUESTION_NATIVE.name]: (0, $jPkZL.QuestionRoute),
    [(0, $64KID.namedRoutes).QUESTIONS_NATIVE.name]: (0, $b4Fyf.GlobalQuestionsRoute),
    [(0, $64KID.namedRoutes).QUESTION_NATIVE.name]: (0, $2Kk8c.GlobalQuestionRoute),
    [(0, $64KID.namedRoutes).MY_CALENDAR.name]: (0, $1RdAz.MyCalendarRoute),
    [(0, $64KID.namedRoutes).PDF_EXPORT_PAGE.name]: (0, $1b9IW.PdfExportPageRoute),
    [(0, $64KID.namedRoutes).PDF_EXPORT_SPACE.name]: (0, $byNy2.PdfExportSpaceRoute),
    [(0, $64KID.namedRoutes).CUSTOM_CONTENTS_ON_PAGE_LIST.name]: (0, $eLEnw.CustomContentOnPageRoute),
    [(0, $64KID.namedRoutes).CUSTOM_CONTENT_VIEW.name]: (0, $7DnqF.CustomContentViewRoute),
    [(0, $64KID.namedRoutes).SPACE_PERMISSIONS_SETTINGS.name]: (0, $8plBz.SpacePermissionsSettingsRoute),
    [(0, $64KID.namedRoutes).SPACE_LOOK_AND_FEEL_SETTINGS.name]: (0, $gzxVF.SpaceLookAndFeelSettingsRoute),
    [(0, $64KID.namedRoutes).ADMIN_ANNOUNCEMENT_BANNER_RENDERER.name]: (0, $ggmLP.AdminAnnouncementBannerRendererRoute),
    [(0, $64KID.namedRoutes).SPACE_MANAGER.name]: (0, $i9drS.SpaceManagerRoute),
    [(0, $64KID.namedRoutes).USER_ACCESS.name]: (0, $6pqj5.UserAccessRoute),
    [(0, $64KID.namedRoutes).ADMIN_CENTER.name]: (0, $k0Wco.AdminCenterRoute),
    [(0, $64KID.namedRoutes).ADMIN_CENTER_SPACE.name]: (0, $2m9tD.AdminCenterSpaceRoute),
    [(0, $64KID.namedRoutes).ADMIN_SETTINGS.name]: (0, $gxgRl.AdminSettingsRoute),
    [(0, $64KID.namedRoutes).ADMIN_BULK_PERMISSIONS.name]: (0, $cTDal.BulkSpacePermissionsRoute),
    [(0, $64KID.namedRoutes).ADMIN_SITE_SPACE_PERMISSIONS.name]: (0, $fOd6C.AdminSiteSpacePermissionsRoute),
    [(0, $64KID.namedRoutes).ADMIN_TEAM_CALENDARS.name]: (0, $9SC9O.AdminTeamCalendarsRoute),
    [(0, $64KID.namedRoutes).ADMIN_CONFIGURATION.name]: (0, $blAko.AdminConfigurationRoute),
    [(0, $64KID.namedRoutes).ADMIN_DEFAULT_SPACE_LOGO.name]: (0, $6as7N.AdminDefaultSpaceLogoConfigRoute),
    [(0, $64KID.namedRoutes).ADMIN_HEADER_AND_FOOTER.name]: (0, $g1wzK.AdminHeaderAndFooterRoute),
    [(0, $64KID.namedRoutes).ADMIN_TEMPLATES_AND_BLUEPRINTS.name]: (0, $eo6PJ.AdminTemplatesAndBlueprintsRoute),
    [(0, $64KID.namedRoutes).ADMIN_CODE_MACRO_CONFIGURATION.name]: (0, $5anXn.AdminCodeMacroConfigurationRoute),
    [(0, $64KID.namedRoutes).ADMIN_COLOR_SCHEME.name]: (0, $iWY3L.AdminColorSchemeRoute),
    [(0, $64KID.namedRoutes).ADMIN_SECURITY_CONFIGURATION.name]: (0, $fX9iO.AdminSecurityConfigurationRoute),
    [(0, $64KID.namedRoutes).ADMIN_SPACE_REPORTS.name]: (0, $7YL3H.AdminSpaceReportsRoute),
    [(0, $64KID.namedRoutes).ADMIN_APPLICATION_NAVIGATOR.name]: (0, $eeFAx.AdminApplicationNavigatorRoute),
    [(0, $64KID.namedRoutes).ADMIN_TRASHED_SPACES.name]: (0, $a7Ld6.AdminTrashedSpacesRoute),
    [(0, $64KID.namedRoutes).ADMIN_IMPORT_SPACES.name]: (0, $9IOVR.AdminImportSpacesRoute),
    [(0, $64KID.namedRoutes).ADMIN_JIRA_MACRO_REPAIR.name]: (0, $xgs7O.AdminJiraMacroRepairRoute),
    [(0, $64KID.namedRoutes).ADMIN_MACRO_USAGE.name]: (0, $gNmMt.AdminMacroUsageRoute),
    [(0, $64KID.namedRoutes).ADMIN_THEMES.name]: (0, $3rtEO.AdminThemesRoute),
    [(0, $64KID.namedRoutes).ADMIN_PDF_EXPORT.name]: (0, $1jVVc.AdminPdfExportRoute),
    [(0, $64KID.namedRoutes).ADMIN_WORKFLOWS.name]: (0, $hgiBo.AdminWorkflowsRoute),
    [(0, $64KID.namedRoutes).SPACE_JIRA_PROJECT_BOARD.name]: (0, $eQpkq.SpaceJiraProjectBoardRoute),
    [(0, $64KID.namedRoutes).SPACE_MEMBERS.name]: (0, $fwL0r.SpaceMembersRoute),
    [(0, $64KID.namedRoutes).TOPICS.name]: (0, $lp83g.TopicsRoute),
    [(0, $64KID.namedRoutes).WORKFLOWS.name]: (0, $jZAYF.WorkflowsRoute),
    [(0, $64KID.namedRoutes).SMART_CREATE_PROMPT.name]: (0, $8YXSL.SmartCreateRoute),
    [(0, $64KID.namedRoutes).PREMIUM_ADMIN_FEATURES_EXPERIMENT.name]: (0, $5aYM8.PremiumAdminFeaturesRoute),
    [(0, $64KID.namedRoutes).SMART_CREATE_SESSION.name]: (0, $4ipZd.SmartCreateSessionRoute)
});

});
parcelRegister("17Y6d", function(module, exports) {

$parcel$export(module.exports, "RedirectLegacyCopyPageLoader", () => $e9270d50e13c4524$export$58ad04e57ec143c3);

var $jmjWc = parcelRequire("jmjWc");

const $e9270d50e13c4524$export$58ad04e57ec143c3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "DOtt7",
    name: "RedirectLegacyCopyPageLoader",
    loader: async ()=>(await (parcelRequire("crKFl"))).RedirectLegacyCopyPage
});
$e9270d50e13c4524$export$58ad04e57ec143c3.NAVIGATION_PARAMS = ()=>false;

});
parcelRegister("crKFl", function(module, exports) {

let $90fc347e4a002c78$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $90fc347e4a002c78$var$load("5zLU3").then(()=>parcelRequire('6nGVD'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("eVA6A", function(module, exports) {

$parcel$export(module.exports, "RedirectLegacyViewPageLoader", () => $1547fdfac1788133$export$70a5a4ee184a1106);

var $jmjWc = parcelRequire("jmjWc");

const $1547fdfac1788133$export$70a5a4ee184a1106 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "hF4WF",
    name: "RedirectLegacyViewPageLoader",
    loader: async ()=>(await (parcelRequire("i5Glc"))).RedirectLegacyViewPage
});
$1547fdfac1788133$export$70a5a4ee184a1106.NAVIGATION_PARAMS = ()=>false;

});
parcelRegister("i5Glc", function(module, exports) {

let $d2b989a850c774cb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d2b989a850c774cb$var$load("9dZCH").then(()=>parcelRequire('ghOyy'));

});


parcelRegister("6v2ig", function(module, exports) {

$parcel$export(module.exports, "processNavigationParams", () => (parcelRequire("jiFpb")).processNavigationParams);
$parcel$export(module.exports, "getSpaceOverviewRoute", () => (parcelRequire("4lJOK")).getSpaceOverviewRoute);
$parcel$export(module.exports, "getCompanyHubRoute", () => (parcelRequire("hDf9e")).getCompanyHubRoute);
$parcel$export(module.exports, "getCompanyHubEditRoute", () => (parcelRequire("hkCxu")).getCompanyHubEditRoute);
// These are routes shared between SSR and SPA

var $jiFpb = parcelRequire("jiFpb");

var $4lJOK = parcelRequire("4lJOK");

var $hDf9e = parcelRequire("hDf9e");

var $hkCxu = parcelRequire("hkCxu");

});
parcelRegister("jiFpb", function(module, exports) {

$parcel$export(module.exports, "processNavigationParams", () => $6a421125f8ad1b8e$export$5ce5fb2a75a2a873);

var $gwFzn = parcelRequire("gwFzn");

var $iJ8K8 = parcelRequire("iJ8K8");

var $5gmpn = parcelRequire("5gmpn");

var $8dwdz = parcelRequire("8dwdz");

var $3PXtn = parcelRequire("3PXtn");

var $gz8ZY = parcelRequire("gz8ZY");
const $6a421125f8ad1b8e$var$routeWithNavigationMapping = new Map();
function $6a421125f8ad1b8e$export$658b4fa209be6b36(match) {
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    // We need to ensure all the entries calling processNavigationParams are returning the same RouteWithNavigation instance
    // So that they won't get re-mounted when switching between routes
    const RouteWithNavParams = $6a421125f8ad1b8e$var$routeWithNavigationMapping.get(match.name);
    if (!RouteWithNavParams) return null;
    const { NAVIGATION_PARAMS: NAVIGATION_PARAMS } = RouteWithNavParams;
    if (typeof NAVIGATION_PARAMS !== 'function') return null;
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    const spaceNavParams = NAVIGATION_PARAMS(match, isNav4Enabled);
    const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(RouteWithNavParams, match);
    if (spaceNavParams === false) return element;
    const { Screen: screen, MainLayout: mainLayout, BannerContext: bannerContext } = spaceNavParams;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iJ8K8.Screen), screen, mainLayout === false ? element : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5gmpn.MainLayout), {
        enableNavigation: !isMobile,
        ...mainLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3PXtn.BannerContextProvider), {
        includeTopNav: bannerContext?.includeTopNav
    }, element)));
}
function $6a421125f8ad1b8e$export$5ce5fb2a75a2a873(routes) {
    for(const name in routes){
        const RouteWithNavParams = routes[name];
        if (typeof RouteWithNavParams.NAVIGATION_PARAMS !== 'function') throw new Error(`Route must define a static NAVIGATION_PARAMS function. ${name} is missing the NAVIGATION_PARAMS function. Please read patterns/routing.md`);
        $6a421125f8ad1b8e$var$routeWithNavigationMapping.set(name, RouteWithNavParams);
        routes[name] = $6a421125f8ad1b8e$export$658b4fa209be6b36;
    }
    return routes;
}

});
parcelRegister("5gmpn", function(module, exports) {

$parcel$export(module.exports, "MainLayout", () => $f6b55c9cc88888b7$export$93af822566053b3e);

var $jmjWc = parcelRequire("jmjWc");

const $f6b55c9cc88888b7$export$93af822566053b3e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "GCw5R",
    _reactTreeRootForServerPlaceholderId: true,
    name: 'MainLayout',
    loader: async ()=>(await (parcelRequire("ilnoK"))).MainLayout
});

});
parcelRegister("ilnoK", function(module, exports) {

let $d5ac568d2a435449$var$load = (parcelRequire("lhnSv"))(5);



module.exports = Promise.all([
    $d5ac568d2a435449$var$load("j2GwS"),
    $d5ac568d2a435449$var$load("e9stW"),
    (parcelRequire("di5rn"))((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve("cd7QD"), 5)),
    $d5ac568d2a435449$var$load("4GE9S")
]).then(()=>parcelRequire('cmkWO'));

});
parcelRegister("di5rn", function(module, exports) {
"use strict";

var $jDpSy = parcelRequire("jDpSy");
module.exports = $jDpSy(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("jDpSy", function(module, exports) {
"use strict";
let $e4b5bbdb98dce921$var$cachedBundles = {};
let $e4b5bbdb98dce921$var$cachedPreloads = {};
let $e4b5bbdb98dce921$var$cachedPrefetches = {};
function $e4b5bbdb98dce921$var$getCache(type) {
    switch(type){
        case 'preload':
            return $e4b5bbdb98dce921$var$cachedPreloads;
        case 'prefetch':
            return $e4b5bbdb98dce921$var$cachedPrefetches;
        default:
            return $e4b5bbdb98dce921$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        let cache = $e4b5bbdb98dce921$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});





parcelRegister("4lJOK", function(module, exports) {

$parcel$export(module.exports, "getSpaceOverviewRoute", () => $3dad7419d64a8662$export$3731f94d374dc29b);

var $gwFzn = parcelRequire("gwFzn");

var $cEgMD = parcelRequire("cEgMD");

var $kE2cJ = parcelRequire("kE2cJ");

var $iJ8K8 = parcelRequire("iJ8K8");

var $4NvKO = parcelRequire("4NvKO");

var $4l6Wo = parcelRequire("4l6Wo");

var $1NBp8 = parcelRequire("1NBp8");

var $dEBDF = parcelRequire("dEBDF");

var $iqPBi = parcelRequire("iqPBi");

var $9wGTI = parcelRequire("9wGTI");
function $3dad7419d64a8662$export$3731f94d374dc29b(Component) {
    const SpaceOverviewRoute = (match)=>{
        const { params: { spaceKey: spaceKey = '', contentId: contentId = '' }, query: query } = match;
        if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.COMPANY_HUB).name
        });
        if ((0, $9wGTI.fg)('confluence_frontend_ssr_space_base')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqPBi.SpaceBase), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
            spaceKey: spaceKey,
            contentId: contentId,
            query: query
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
            spaceKey: spaceKey,
            contentId: contentId,
            query: query
        });
    };
    SpaceOverviewRoute.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey = '' }, query: { mode: mode = '' } })=>({
            Screen: {
                screenEvent: {
                    name: 'spaceOverviewScreen',
                    id: spaceKey,
                    attributes: {
                        isGlobalMode: mode === 'global',
                        navdexPointType: (0, $dEBDF.START_TOUCH)
                    }
                },
                pageState: {
                    spaceKey: spaceKey,
                    contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                    routeName: (0, $1NBp8.SPACE_OVERVIEW).name,
                    contentType: 'page'
                }
            },
            MainLayout: {
                navView: (0, $4l6Wo.CONTAINER_HOME_ID),
                spaceKey: spaceKey,
                isViewPage: true
            }
        });
    return SpaceOverviewRoute;
}
const $3dad7419d64a8662$export$2df060b942be85a7 = $3dad7419d64a8662$export$3731f94d374dc29b((0, $4NvKO.SpaceOverviewLoader));

});

parcelRegister("hDf9e", function(module, exports) {

$parcel$export(module.exports, "getCompanyHubRoute", () => $8d67d674949172ba$export$d135e6fd61f0ae86);

var $gwFzn = parcelRequire("gwFzn");

var $98e6j = parcelRequire("98e6j");

var $4l6Wo = parcelRequire("4l6Wo");

var $9HNv5 = parcelRequire("9HNv5");

var $8NC5Z = parcelRequire("8NC5Z");

var $7CeAz = parcelRequire("7CeAz");

var $1NBp8 = parcelRequire("1NBp8");

var $dEBDF = parcelRequire("dEBDF");

var $cEgMD = parcelRequire("cEgMD");

var $kE2cJ = parcelRequire("kE2cJ");

var $iJ8K8 = parcelRequire("iJ8K8");

var $1ytiN = parcelRequire("1ytiN");

var $4NvKO = parcelRequire("4NvKO");

var $eqNP8 = parcelRequire("eqNP8");

var $dPJCf = parcelRequire("dPJCf");

var $jKzCD = parcelRequire("jKzCD");

var $e4o8D = parcelRequire("e4o8D");

var $9wGTI = parcelRequire("9wGTI");

var $eCfJ3 = parcelRequire("eCfJ3");

var $2Uf3N = parcelRequire("2Uf3N");
function $8d67d674949172ba$export$d135e6fd61f0ae86(Component) {
    const CompanyHubRoute = ()=>{
        const { isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled, isCompanyHubPublished: isCompanyHubPublished } = (0, $7CeAz.useIsCompanyHubEnabled)();
        const { isSiteAdmin: isSiteAdmin, loading: loading } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
        const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
        const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
        const { push: push } = (0, $dPJCf.useRouteActions)();
        const { isCreatingHub: isCreatingHub, creationError: creationError } = (0, $jKzCD.useCompanyHubOnRouteCreationFlow)({
            onSuccess: (homepageId)=>{
                push((0, $1NBp8.COMPANY_HUB_EDIT).toUrl({}, {
                    query: {
                        redirect: 'first-time',
                        contentId: homepageId
                    }
                }));
            },
            route: (0, $1NBp8.COMPANY_HUB).pattern
        });
        if (isCreatingHub || loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
        screenEventAttributes.publishedCompanyHub = isCompanyHubPublished;
        if (shouldShowPremiumUpsell) {
            if (isSiteAdmin || (0, $9wGTI.fg)('company-hub-pseudo-app')) {
                /**
				 * SSR compatibility: CompanyHomeBuilderUpsellPage uses UpsellLooknFeel/SectionMessage
				 * which lacks SSR support. Rendering during SSR would cause:
				 * - Hydration mismatches between server/client renders
				 * - Visible layout shift (CLS) during client hydration since SectionMessage
				 *   appears at the top of the content area
				 *
				 * For now, client-side rendering only, until components are refactored for SSR support.
				 */ if (renderServerPlaceholder) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
                    featureName: "companyHub"
                });
            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
                name: (0, $1NBp8.HOME).name
            });
        }
        if (creationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eCfJ3.HubErrorPageComponent), {
            error: creationError
        });
        if (!isCompanyHubEntryPointEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.HOME).name
        });
        // The only different between SPA and SSR is we don't render space base in SSR
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $98e6j.CompanyHubAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
            spaceKey: spaceKey,
            contentId: ""
        }));
    };
    const screenEventAttributes = {
        navdexPointType: (0, $dEBDF.START_TOUCH),
        // Company Hub hides its space from the user, doesn't refer to its page
        // as such, is rather presented to the user as "a new surface", and thus
        // doesn't constitute space usage from the perspective of the user.
        screenIsInSpace: false
    };
    /**
	 * Warning: Though the function NAVIGATION_PARAMS is invoked during render,
	 * each route has its own implementation. Consequently, it cannot invoke
	 * hooks or, during route transitions between implementations that invoke
	 * different hooks, the rule of hooks to invoke a hook the same number of
	 * times during each render would be violated and an error would be thrown
	 * by React that would damage the DOM.
	 */ CompanyHubRoute.NAVIGATION_PARAMS = ()=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return {
            Screen: {
                screenEvent: {
                    name: 'companyHub',
                    id: spaceKey,
                    // Warning: The value of the analytics event attribute
                    // publishedCompanyHub that ScreenEvent sends will be
                    // inaccurate on initial SPA load without SSR, because
                    // ScreenEvent sends before SPAViewContext has loaded.
                    attributes: screenEventAttributes
                },
                pageState: {
                    spaceKey: spaceKey,
                    contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                    routeName: (0, $1NBp8.COMPANY_HUB).name
                }
            },
            MainLayout: {
                navView: (0, $4l6Wo.PRODUCT_HOME_ID),
                spaceKey: spaceKey,
                isViewPage: true
            }
        };
    };
    return (0, $2Uf3N.getCompanyHubPseudoAppRoute)(CompanyHubRoute);
}
const $8d67d674949172ba$export$ea13ab632841088 = $8d67d674949172ba$export$d135e6fd61f0ae86((0, $4NvKO.SpaceOverviewLoader));

});
parcelRegister("98e6j", function(module, exports) {

$parcel$export(module.exports, "CompanyHubAnalyticsWrapper", () => $0d72b6e269966c48$export$83316d703678f96f);

var $gwFzn = parcelRequire("gwFzn");

var $kDuN4 = parcelRequire("kDuN4");
var $inPa6 = parcelRequire("inPa6");

var $1NBp8 = parcelRequire("1NBp8");

var $dPJCf = parcelRequire("dPJCf");

var $bQm3c = parcelRequire("bQm3c");

var $7QM6o = parcelRequire("7QM6o");
const $0d72b6e269966c48$var$isOnCompanyHubRouteArgs = {
    selector: (routeName)=>(0, $1NBp8.COMPANY_HUB).name === routeName
};

const $0d72b6e269966c48$export$83316d703678f96f = ({ children: children })=>{
    const isOnCompanyHubRoute = (0, $dPJCf.useRouteName)($0d72b6e269966c48$var$isOnCompanyHubRouteArgs);
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleAnalyticCaught = (0, $gwFzn.useCallback)(async (event, channel)=>{
        if (event?.payload?.action === 'clicked' || event?.payload?.actionSubject === 'smartLink' && event?.payload?.action === 'renderSuccess') await (parcelRequire("eSNrM")).then(async ({ handleEventCaught: handleEventCaught })=>{
            await handleEventCaught(activationId, cloudId, createAnalyticsEvent, event, !!isOnCompanyHubRoute, channel, spaceId);
        });
    }, [
        activationId,
        cloudId,
        createAnalyticsEvent,
        isOnCompanyHubRoute,
        spaceId
    ]);
    if (!isOnCompanyHubRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kDuN4.default), {
        channel: "*",
        onEvent: handleAnalyticCaught
    }, children);
};

});
parcelRegister("eSNrM", function(module, exports) {

let $ad5c76fe74b35854$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ad5c76fe74b35854$var$load("fp9cm").then(()=>parcelRequire('9ehFI'));

});


parcelRegister("9HNv5", function(module, exports) {

$parcel$export(module.exports, "CompanyHomeBuilderUpsellPage", () => $d561062df6e47d30$export$4047609c83584c4b);

var $jmjWc = parcelRequire("jmjWc");

const $d561062df6e47d30$export$4047609c83584c4b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "nCrwB",
    name: "CompanyHomeBuilderUpsellPage",
    loader: async ()=>(await (parcelRequire("f3sUl"))).CompanyHomeBuilderUpsellPage
});

});
parcelRegister("f3sUl", function(module, exports) {

let $af5d8f53bfaecbdf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $af5d8f53bfaecbdf$var$load("22Xly").then(()=>parcelRequire('kQJNb'));

});


parcelRegister("jKzCD", function(module, exports) {

$parcel$export(module.exports, "useCompanyHubOnRouteCreationFlow", () => $6d8995f9c98e457c$export$567b73f497a151cb);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $dIouf = parcelRequire("dIouf");

var $cEgMD = parcelRequire("cEgMD");

var $1ytiN = parcelRequire("1ytiN");

var $9wGTI = parcelRequire("9wGTI");

var $irVI7 = parcelRequire("irVI7");
var $aJPUt = parcelRequire("aJPUt");
var $1kHsc = parcelRequire("1kHsc");

var $8NC5Z = parcelRequire("8NC5Z");

var $gi8UL = parcelRequire("gi8UL");
function $6d8995f9c98e457c$export$567b73f497a151cb({ onSuccess: onSuccess, onExists: onExists, route: route }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isCreatingHub, setIsCreatingHub] = (0, $gwFzn.useState)(false);
    const [creationError, setCreationError] = (0, $gwFzn.useState)(null);
    const { isSiteAdmin: isSiteAdmin, frontCoverState: frontCoverState } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)({
        skip: !(0, $9wGTI.fg)('company-hub-pseudo-app')
    });
    const isCompanyHubUnset = frontCoverState === (0, $cEgMD.FrontCoverStateEnum).UNSET;
    const hasCreatedHub = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (!hasCreatedHub.current && (0, $9wGTI.fg)('company-hub-pseudo-app')) {
            const shouldCreateHub = isCompanyHubUnset && isSiteAdmin && !shouldShowPremiumUpsell && !isCreatingHub;
            if (shouldCreateHub) {
                let wasHubCreated = false;
                setIsCreatingHub(true);
                hasCreatedHub.current = true;
                experienceTracker.start({
                    name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
                });
                (0, $gi8UL.createCompanyHubSpace)().then(({ didCreateSpace: didCreateSpace, homepageId: homepageId })=>{
                    if (didCreateSpace) {
                        experienceTracker.succeed({
                            name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE)
                        });
                        wasHubCreated = true;
                        onSuccess?.(homepageId);
                    } else {
                        experienceTracker.abort({
                            name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                            reason: 'Hub space already exists. Handled by redirecting user to Hub editor without first time experience'
                        });
                        onExists?.(homepageId);
                    }
                }).catch((error)=>{
                    if ((0, $9wGTI.fg)('company-hub-pseudo-app')) setCreationError(error);
                    if ((0, $gi8UL.hasStalePermissionsErrorMessage)(error)) experienceTracker.abort({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        reason: 'User has stale admin permissions'
                    });
                    else if ((0, $dIouf.isUnauthorizedError)(error)) experienceTracker.abort({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        reason: 'User is not authenticated'
                    });
                    else experienceTracker.fail({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        error: error
                    });
                }).finally(()=>{
                    setIsCreatingHub(false);
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            source: 'companyHub',
                            action: 'created',
                            actionSubject: 'onRouteStart',
                            actionSubjectId: 'companyHubOnRouteCreation',
                            attributes: {
                                created: wasHubCreated,
                                route: route
                            }
                        }
                    }).fire();
                });
            }
        }
    }, [
        isCompanyHubUnset,
        isSiteAdmin,
        createAnalyticsEvent,
        shouldShowPremiumUpsell,
        isCreatingHub,
        experienceTracker,
        onSuccess,
        onExists,
        route
    ]);
    return {
        isCreatingHub: isCreatingHub,
        creationError: creationError
    };
}

});

parcelRegister("eCfJ3", function(module, exports) {

$parcel$export(module.exports, "HubErrorPageComponent", () => $3f49c0dd8d66c83c$export$c09c08db0e42b276);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $abC4X = parcelRequire("abC4X");

var $7p4As = parcelRequire("7p4As");

var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $2Nwuj = parcelRequire("2Nwuj");

var $1NBp8 = parcelRequire("1NBp8");

var $dIouf = parcelRequire("dIouf");

var $gi8UL = parcelRequire("gi8UL");

var $364kx = parcelRequire("364kx");

var $eDEWW = parcelRequire("eDEWW");
const $3f49c0dd8d66c83c$var$containerStyles = (0, $ecnYn.xcss)({
    height: '90vh',
    paddingInline: 'space.200'
});
const $3f49c0dd8d66c83c$export$c09c08db0e42b276 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const errorConfig = (0, $gwFzn.useMemo)(()=>{
        if ((0, $gi8UL.hasStalePermissionsErrorMessage)(error)) return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($eDEWW))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceStalePermissionsErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceStalePermissionsErrorFlagDescription, {
                a: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
                        href: "https://support.atlassian.com/confluence-cloud/docs/create-and-customize-a-company-hub",
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, chunks)
            })
        };
        if ((0, $dIouf.isUnauthorizedError)(error)) return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($eDEWW))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagDescription, {
                b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks)
            }),
            buttonLabel: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagButton),
            buttonLink: (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).toUrl()
        };
        return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($364kx))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceErrorFlagDescription)
        };
    }, [
        error,
        formatMessage
    ]);
    const { imageUrl: imageUrl, title: title, description: description, buttonLabel: buttonLabel, buttonLink: buttonLink } = errorConfig;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $3f49c0dd8d66c83c$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $abC4X.default), {
        header: title,
        description: description,
        primaryAction: buttonLabel && buttonLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7p4As.default), {
            appearance: "primary",
            href: buttonLink
        }, buttonLabel) : undefined,
        imageUrl: imageUrl
    }));
};

});
parcelRegister("364kx", function(module, exports) {
module.exports = new URL("GenericError.cd21964e.svg", import.meta.url).toString();

});

parcelRegister("eDEWW", function(module, exports) {
module.exports = new URL("RestrictedError.e0fef1fb.svg", import.meta.url).toString();

});


parcelRegister("2Uf3N", function(module, exports) {

$parcel$export(module.exports, "getCompanyHubPseudoAppRoute", () => $13aed4a881b0bcc1$export$f5fe5ef796a4c528);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $2Jtfo = parcelRequire("2Jtfo");
function $13aed4a881b0bcc1$export$f5fe5ef796a4c528(Wrapped, routeMatchPredicate = ()=>true) {
    const CompanyHubPseudoAppRoute = (props)=>{
        const wrapped = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Wrapped, props);
        if (routeMatchPredicate(props) && (0, $9wGTI.fg)('company-hub-pseudo-app')) // The Company Hub app-like experience uses its own, doesn't use Confluence's `MainLayout`:
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Jtfo.CompanyHubMainLayout), null, wrapped);
        return wrapped;
    };
    CompanyHubPseudoAppRoute.NAVIGATION_PARAMS = (...args)=>{
        const wrappedNavParams = Wrapped.NAVIGATION_PARAMS(...args);
        if (routeMatchPredicate(args[0]) && (0, $9wGTI.fg)('company-hub-pseudo-app')) // The Company Hub app-like experience uses its own, doesn't use Confluence's `MainLayout`:
        return typeof wrappedNavParams === 'object' ? {
            ...wrappedNavParams,
            MainLayout: false
        } : false;
        return wrappedNavParams;
    };
    return CompanyHubPseudoAppRoute;
}

});
parcelRegister("2Jtfo", function(module, exports) {

$parcel$export(module.exports, "CompanyHubMainLayout", () => $44a1291d5f4bf190$export$bbf3d8e57337c75);

var $jmjWc = parcelRequire("jmjWc");

const $44a1291d5f4bf190$export$bbf3d8e57337c75 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xoU6a",
    _reactTreeRootForServerPlaceholderId: true,
    name: 'CompanyHubMainLayout',
    loader: async ()=>(await (parcelRequire("8xu1V"))).CompanyHubMainLayout
});

});
parcelRegister("8xu1V", function(module, exports) {

let $6378b328a5783e34$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6378b328a5783e34$var$load("cZgEZ"),
    $6378b328a5783e34$var$load("3hm97"),
    $6378b328a5783e34$var$load("3XMOA"),
    $6378b328a5783e34$var$load("5i7Tn"),
    $6378b328a5783e34$var$load("aodp5"),
    $6378b328a5783e34$var$load("6zHfc"),
    $6378b328a5783e34$var$load("eYcaz"),
    $6378b328a5783e34$var$load("5epKi"),
    $6378b328a5783e34$var$load("kq5g1"),
    $6378b328a5783e34$var$load("4zTgj"),
    $6378b328a5783e34$var$load("cJdPE"),
    $6378b328a5783e34$var$load("HLeeR"),
    $6378b328a5783e34$var$load("bZWqy"),
    $6378b328a5783e34$var$load("bkOZu"),
    $6378b328a5783e34$var$load("7ZpqL"),
    $6378b328a5783e34$var$load("f1WN5"),
    $6378b328a5783e34$var$load("dH2J7"),
    $6378b328a5783e34$var$load("iBm1B"),
    $6378b328a5783e34$var$load("do9PF"),
    $6378b328a5783e34$var$load("iAspJ"),
    $6378b328a5783e34$var$load("ftJgg"),
    $6378b328a5783e34$var$load("6OarG"),
    $6378b328a5783e34$var$load("ePOyH"),
    $6378b328a5783e34$var$load("c5krk"),
    $6378b328a5783e34$var$load("cUIjD"),
    $6378b328a5783e34$var$load("joJy8"),
    $6378b328a5783e34$var$load("aHE9G"),
    $6378b328a5783e34$var$load("cMlHc"),
    $6378b328a5783e34$var$load("eVYW1"),
    $6378b328a5783e34$var$load("ls0Um"),
    $6378b328a5783e34$var$load("020xd"),
    $6378b328a5783e34$var$load("eTBsW"),
    $6378b328a5783e34$var$load("1oiJ6"),
    $6378b328a5783e34$var$load("dil5i"),
    $6378b328a5783e34$var$load("2fk6g"),
    $6378b328a5783e34$var$load("hPalR"),
    $6378b328a5783e34$var$load("8059b"),
    $6378b328a5783e34$var$load("3wmvj"),
    $6378b328a5783e34$var$load("jDjSj"),
    $6378b328a5783e34$var$load("kjZZD"),
    $6378b328a5783e34$var$load("aQp8v"),
    $6378b328a5783e34$var$load("2jsRt"),
    $6378b328a5783e34$var$load("c6MKV"),
    $6378b328a5783e34$var$load("ffEVr"),
    $6378b328a5783e34$var$load("6qah4"),
    $6378b328a5783e34$var$load("ltGSX"),
    $6378b328a5783e34$var$load("1tgwx"),
    $6378b328a5783e34$var$load("i0gb6"),
    $6378b328a5783e34$var$load("g7QTt"),
    $6378b328a5783e34$var$load("cYP30")
]).then(()=>parcelRequire('35RMv'));

});




parcelRegister("hkCxu", function(module, exports) {

$parcel$export(module.exports, "getCompanyHubEditRoute", () => $aa6dab5502f2e37f$export$39a78a0252c20555);

var $gwFzn = parcelRequire("gwFzn");

var $cEgMD = parcelRequire("cEgMD");

var $4l6Wo = parcelRequire("4l6Wo");

var $jKzCD = parcelRequire("jKzCD");

var $8NC5Z = parcelRequire("8NC5Z");

var $1NBp8 = parcelRequire("1NBp8");

var $9HNv5 = parcelRequire("9HNv5");

var $eqNP8 = parcelRequire("eqNP8");

var $ep3mz = parcelRequire("ep3mz");

var $dPJCf = parcelRequire("dPJCf");

var $dEBDF = parcelRequire("dEBDF");

var $eCfJ3 = parcelRequire("eCfJ3");

var $a7s02 = parcelRequire("a7s02");

var $2Uf3N = parcelRequire("2Uf3N");
function $aa6dab5502f2e37f$export$39a78a0252c20555(component) {
    const CompanyHubEditRoute = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const [queriedContentId, setQueriedContentId] = (0, $gwFzn.useState)(null);
        const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
        const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
        const { isCreatingHub: isCreatingHub, creationError: creationError } = (0, $jKzCD.useCompanyHubOnRouteCreationFlow)({
            onSuccess: (homepageId)=>{
                setQueriedContentId(homepageId);
                setQueryParams({
                    redirect: 'first-time'
                });
            },
            onExists: (homepageId)=>{
                setQueriedContentId(homepageId);
            },
            route: (0, $1NBp8.COMPANY_HUB_EDIT).pattern
        });
        if (creationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eCfJ3.HubErrorPageComponent), {
            error: creationError
        });
        if (shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
            featureName: "companyHub"
        });
        // If there is no contentId in SSR then we will just see the FullPageLoadingScreen being rendered
        // So we skip the loading screen component to ensure the EditPageRoute is rendered instead
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if ((isCreatingHub || !queriedContentId && !contentId) && true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
        const Component = component;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
            ...routeProps,
            params: {
                contentId: contentId ?? (queriedContentId || ''),
                spaceKey: spaceKey,
                contentType: 'pages'
            }
        });
    };
    CompanyHubEditRoute.NAVIGATION_PARAMS = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return {
            Screen: {
                screenEvent: {
                    name: 'companyHubEditScreen',
                    id: spaceKey,
                    attributes: {
                        navdexPointType: (0, $dEBDF.END),
                        // Company Hub hides its space from the user, doesn't refer to its page
                        // as such, is rather presented to the user as "a new surface", and thus
                        // doesn't constitute space usage from the perspective of the user.
                        screenIsInSpace: false
                    }
                },
                // When no contentId is passed, Screen.js handles querying it and updating pageState with it.
                // usually, this is done by the Screen.js component, but in this case, we need to do it here
                // because contentId is not getting queried properly on route creation.
                pageState: {
                    spaceKey: spaceKey,
                    contentId: routeProps?.query?.contentId
                }
            },
            MainLayout: {
                navView: (0, $4l6Wo.PRODUCT_HOME_ID)
            }
        };
    };
    return (0, $2Uf3N.getCompanyHubPseudoAppRoute)(CompanyHubEditRoute);
}
const $aa6dab5502f2e37f$export$31ce72eecdb1dd8 = $aa6dab5502f2e37f$export$39a78a0252c20555((0, $a7s02.EditPageRoute));

});
parcelRegister("a7s02", function(module, exports) {

$parcel$export(module.exports, "EditPageRoute", () => $ec45f4b8e7cc34aa$export$6a3218472cdf374a);

var $gwFzn = parcelRequire("gwFzn");

var $8NC5Z = parcelRequire("8NC5Z");

var $5gmpn = parcelRequire("5gmpn");

var $iJ8K8 = parcelRequire("iJ8K8");

var $bA0Rg = parcelRequire("bA0Rg");

var $8dwdz = parcelRequire("8dwdz");

var $4l6Wo = parcelRequire("4l6Wo");

var $1NBp8 = parcelRequire("1NBp8");

var $cEgMD = parcelRequire("cEgMD");

var $3PXtn = parcelRequire("3PXtn");

var $1fvxC = parcelRequire("1fvxC");
const $ec45f4b8e7cc34aa$export$6a3218472cdf374a = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey }, query: query })=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)({
        skip: !isCompanyHub
    });
    const contentType = name === (0, $1NBp8.EDIT_PAGE_V2).name || name === (0, $1NBp8.COMPANY_HUB_EDIT).name ? 'page' : 'blogpost';
    const draftShareId = (0, $1fvxC.parseDraftId)(query);
    const children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3PXtn.BannerContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bA0Rg.EditPageLoaderServer), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType
    }));
    //
    // navView
    //
    let navView = (0, $4l6Wo.CONTAINER_HOME_ID);
    if (isCompanyHub) {
        if (shouldShowPremiumUpsell) return null;
        else if (name === (0, $1NBp8.COMPANY_HUB_EDIT).name) // CompanyHubEditRoute provides its own Screen and MainLayout.
        return children;
        navView = (0, $4l6Wo.PRODUCT_HOME_ID);
    } else if (contentType === 'blogpost') navView = (0, $4l6Wo.CONTAINER_BLOG_ID);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iJ8K8.Screen), {
        showPremiumOnboarding: false,
        pageState: {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType
        },
        screenEvent: {
            name: 'editPageScreen',
            id: contentId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5gmpn.MainLayout), {
        enableNavigation: !(0, $8dwdz.shouldShowMobileWeb)(),
        spaceKey: spaceKey,
        navView: navView,
        isViewPage: true
    }, children));
};

});
parcelRegister("bA0Rg", function(module, exports) {

$parcel$export(module.exports, "EditPageLoaderServer", () => $e7545f5dec589966$export$99fa8db8497fb663);

var $jmjWc = parcelRequire("jmjWc");
var $2w2Hu = parcelRequire("2w2Hu");

const $e7545f5dec589966$export$99fa8db8497fb663 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "rBMHt",
    name: 'EditPageLoaderServer',
    loader: async ()=>(await (parcelRequire("4A7kQ"))).EditPageLoaderServer,
    _mustPreloadWhenRenderingSPA: [
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicEditorContextProviderLoader,
        (0, $2w2Hu.MustPreloadLoadableNames).NativeCollabLoader,
        (0, $2w2Hu.MustPreloadLoadableNames).FullPageEditorLoader
    ]
});

});
parcelRegister("4A7kQ", function(module, exports) {

let $356036d045bd6607$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $356036d045bd6607$var$load("6u1HZ").then(()=>parcelRequire('el3Ev'));

});


parcelRegister("1fvxC", function(module, exports) {

$parcel$export(module.exports, "parseDraftId", () => $ef4380efcf1da8eb$export$4ceedc3d36a46889);
function $ef4380efcf1da8eb$export$b5c57a98f1ddfa55(uri) {
    return uri.includes('/edit-v2/');
}
function $ef4380efcf1da8eb$export$4ceedc3d36a46889(query) {
    const draftShareId = query?.draftShareId;
    return Array.isArray(draftShareId) ? draftShareId?.[0] : draftShareId;
}

});




parcelRegister("ffwDS", function(module, exports) {

$parcel$export(module.exports, "RedirectOldCreatePage", () => $8012954d5e28a430$export$33ab8fb3f76d8b14);

var $jiJCD = parcelRequire("jiJCD");

var $gwFzn = parcelRequire("gwFzn");

var $cKyDI = parcelRequire("cKyDI");

var $kJOOQ = parcelRequire("kJOOQ");
parcelRequire("lwdd5");

var $aTWRz = parcelRequire("aTWRz");
var $iyEDi = parcelRequire("iyEDi");
const $8012954d5e28a430$export$33ab8fb3f76d8b14 = ()=>{
    const location = (0, $cKyDI.useSelector)((0, $iyEDi.getLocation));
    const dispatch = (0, $cKyDI.useDispatch)();
    (0, $gwFzn.useEffect)(()=>{
        const { query: query, pathname: pathname } = location;
        let contentType;
        if (pathname.indexOf('/createpage.action') !== -1 || pathname.indexOf('/createpage-entervariables.action') !== -1) contentType = 'pages';
        else if (pathname.indexOf('/createblogpost.action') !== -1) contentType = 'blog';
        else {
            dispatch((0, $kJOOQ.replace)({
                pathname: (0, $aTWRz.CONTEXT_PATH)
            }));
            return;
        }
        let spaceKey;
        if (typeof query.spaceKey !== 'undefined' && query.spaceKey) spaceKey = query.spaceKey;
        else if (typeof query.draftId !== 'undefined' && /^[0-9]+$/.test(query.draftId)) spaceKey = 'byDraft';
        else {
            dispatch((0, $kJOOQ.replace)({
                pathname: (0, $aTWRz.CONTEXT_PATH)
            }));
            return;
        }
        const newQuery = {};
        Object.keys(query).filter((param)=>param !== 'spaceKey').forEach((param)=>newQuery[param] = query[param]);
        const nextLocation = {
            ...location,
            pathname: `${(0, $aTWRz.CONTEXT_PATH)}/spaces/${spaceKey}/${contentType}/create`,
            query: newQuery,
            search: (0, $jiJCD.format)({
                query: newQuery
            })
        };
        dispatch((0, $kJOOQ.replace)(nextLocation));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
$8012954d5e28a430$export$33ab8fb3f76d8b14.NAVIGATION_PARAMS = ()=>false;

});

parcelRegister("dY7Nc", function(module, exports) {

$parcel$export(module.exports, "AdminForgeAppsRoute", () => $d553d8b4da7f3160$export$25552d6a584e1fb8);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $aVKfT = parcelRequire("aVKfT");
const $d553d8b4da7f3160$export$25552d6a584e1fb8 = ({ params: { id: id } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aVKfT.ForgeGlobalSettingsExtensionPoint), {
        key: id,
        id: id
    });
$d553d8b4da7f3160$export$25552d6a584e1fb8.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminForgeApps'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});
parcelRegister("aVKfT", function(module, exports) {

$parcel$export(module.exports, "ForgeGlobalSettingsExtensionPoint", () => $c1cdb40c21dd0ca3$export$6e2f6a8db94682b4);

var $jmjWc = parcelRequire("jmjWc");

const $c1cdb40c21dd0ca3$export$6e2f6a8db94682b4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "93O33",
    name: "ForgeGlobalSettingsExtensionPoint",
    loader: async ()=>(await (parcelRequire("cfU3A"))).GlobalSettings
});

});
parcelRegister("cfU3A", function(module, exports) {

let $8ec25e77c18b643c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8ec25e77c18b643c$var$load("joJy8"),
    $8ec25e77c18b643c$var$load("aHE9G"),
    $8ec25e77c18b643c$var$load("c6fAG")
]).then(()=>parcelRequire('jOztW'));

});



parcelRegister("d0pTF", function(module, exports) {

$parcel$export(module.exports, "AdvancedSearchRoute", () => $f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $aF1vZ = parcelRequire("aF1vZ");

var $9wGTI = parcelRequire("9wGTI");
const $f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aF1vZ.AdvancedSearch), null);
$f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: (0, $9wGTI.fg)('unified_search_in_confluence') ? null : {
            screenEvent: {
                name: 'advancedSearchScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    };
};

});
parcelRegister("aF1vZ", function(module, exports) {

$parcel$export(module.exports, "AdvancedSearch", () => $47940fef216e9562$export$2709da4acd7d0aec);

var $jmjWc = parcelRequire("jmjWc");

const $47940fef216e9562$export$2709da4acd7d0aec = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Q3Ruy",
    name: "AdvancedSearch",
    loader: async ()=>(await (parcelRequire("fLlMD"))).AdvancedSearch
});

});
parcelRegister("fLlMD", function(module, exports) {

let $b79c2488885ab66d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b79c2488885ab66d$var$load("4tWDP"),
    $b79c2488885ab66d$var$load("6OarG"),
    $b79c2488885ab66d$var$load("7vwsA"),
    $b79c2488885ab66d$var$load("aodp5"),
    $b79c2488885ab66d$var$load("6zHfc"),
    $b79c2488885ab66d$var$load("dH2J7"),
    $b79c2488885ab66d$var$load("c7DhJ"),
    $b79c2488885ab66d$var$load("ej4rO"),
    $b79c2488885ab66d$var$load("6Nh0d"),
    $b79c2488885ab66d$var$load("do9PF"),
    $b79c2488885ab66d$var$load("g7pmM"),
    $b79c2488885ab66d$var$load("3hm97"),
    $b79c2488885ab66d$var$load("emd3r"),
    $b79c2488885ab66d$var$load("9zZJj"),
    $b79c2488885ab66d$var$load("jCu7l"),
    $b79c2488885ab66d$var$load("ftJgg"),
    $b79c2488885ab66d$var$load("hYWtF"),
    $b79c2488885ab66d$var$load("cUIjD"),
    $b79c2488885ab66d$var$load("dUEf9"),
    $b79c2488885ab66d$var$load("joJy8"),
    $b79c2488885ab66d$var$load("aHE9G"),
    $b79c2488885ab66d$var$load("dTsOE"),
    $b79c2488885ab66d$var$load("eVYW1"),
    $b79c2488885ab66d$var$load("ls0Um"),
    $b79c2488885ab66d$var$load("020xd"),
    $b79c2488885ab66d$var$load("eTBsW"),
    $b79c2488885ab66d$var$load("1oiJ6"),
    $b79c2488885ab66d$var$load("dil5i"),
    $b79c2488885ab66d$var$load("2fk6g"),
    $b79c2488885ab66d$var$load("hPalR"),
    $b79c2488885ab66d$var$load("8059b"),
    $b79c2488885ab66d$var$load("3wmvj"),
    $b79c2488885ab66d$var$load("jDjSj"),
    $b79c2488885ab66d$var$load("kjZZD"),
    $b79c2488885ab66d$var$load("5i7Tn"),
    $b79c2488885ab66d$var$load("c6MKV"),
    $b79c2488885ab66d$var$load("ZJtkJ"),
    $b79c2488885ab66d$var$load("6qah4"),
    $b79c2488885ab66d$var$load("aZinD"),
    $b79c2488885ab66d$var$load("kFF5s"),
    $b79c2488885ab66d$var$load("gWoEm"),
    $b79c2488885ab66d$var$load("ffEVr"),
    $b79c2488885ab66d$var$load("6Z8WE"),
    $b79c2488885ab66d$var$load("i0gb6"),
    $b79c2488885ab66d$var$load("g7QTt"),
    $b79c2488885ab66d$var$load("mK22p")
]).then(()=>parcelRequire('luNAU'));

});



parcelRegister("24Erc", function(module, exports) {

$parcel$export(module.exports, "BetaFeaturesRoute", () => $7949c11e9e78d917$export$39279dc1d0cb138f);
/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $lyQ2L = parcelRequire("lyQ2L");
const $7949c11e9e78d917$export$39279dc1d0cb138f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lyQ2L.BetaFeaturesSiteSettingsPageLoader), null);
$7949c11e9e78d917$export$39279dc1d0cb138f.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'betaFeaturesScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});
parcelRegister("lyQ2L", function(module, exports) {

$parcel$export(module.exports, "BetaFeaturesSiteSettingsPageLoader", () => $f9284ca1d97b2b7a$export$32926c3a37851958);

var $jmjWc = parcelRequire("jmjWc");

const $f9284ca1d97b2b7a$export$32926c3a37851958 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Rr_Hq",
    name: "BetaFeaturesSiteSettingsPageLoader",
    loader: async ()=>(await (parcelRequire("hB0jJ"))).BetaFeaturesSiteSettingsPage
});

});
parcelRegister("hB0jJ", function(module, exports) {

let $ccf62362dfd8667a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ccf62362dfd8667a$var$load("j2GwS"),
    $ccf62362dfd8667a$var$load("e9stW"),
    $ccf62362dfd8667a$var$load("ffEVr"),
    $ccf62362dfd8667a$var$load("hDfPU")
]).then(()=>parcelRequire('2mD8T'));

});



parcelRegister("3WxEl", function(module, exports) {

$parcel$export(module.exports, "ExternalShareRoute", () => $b4ceb88d52b227e6$export$2f64eafbbfb5bb9f);

var $gwFzn = parcelRequire("gwFzn");

var $8g7sM = parcelRequire("8g7sM");

var $78QFu = parcelRequire("78QFu");

var $jmjWc = parcelRequire("jmjWc");

const $b4ceb88d52b227e6$var$ExternalSharePageLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "d8xw-",
    name: "ExternalSharePageLoader",
    loader: async ()=>(await (parcelRequire("ajC1K"))).ExternalSharePage
});
const $b4ceb88d52b227e6$export$2f64eafbbfb5bb9f = ({ params: { contentId: contentId, externalToken: externalToken }, hash: hash })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b4ceb88d52b227e6$var$ExternalSharePageLoader, {
        siteUrl: window.location.hostname,
        contentId: contentId === 'undefined' ? undefined : contentId,
        shareToken: externalToken,
        queryHash: hash,
        ContentRenderer: (0, $8g7sM.default)
    });
$b4ceb88d52b227e6$export$2f64eafbbfb5bb9f.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId } })=>({
        Screen: {
            screenEvent: {
                name: 'viewPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: true,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                routeName: name
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });

});
parcelRegister("8g7sM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f88486f5953222$export$2e2bcd8739ae039);

var $jmjWc = parcelRequire("jmjWc");

var $kb9X9 = parcelRequire("kb9X9");
const $c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD = `confluence.fabric.content.renderer.download`;

var $c3f88486f5953222$export$2e2bcd8739ae039 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cDY9-",
    name: 'ClassicContentRendererLoader',
    loader: async ()=>{
        (0, $kb9X9.performanceMarkInProd)(`${$c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD}.start`);
        const module = await (parcelRequire("7ZRNE"));
        (0, $kb9X9.performanceMarkInProd)(`${$c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD}.end`);
        return module;
    }
});

});
parcelRegister("7ZRNE", function(module, exports) {

let $5d27f66f92636cef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $5d27f66f92636cef$var$load("aodp5"),
    $5d27f66f92636cef$var$load("6zHfc"),
    $5d27f66f92636cef$var$load("dMWJp")
]).then(()=>parcelRequire('eTW2b'));

});


parcelRegister("ajC1K", function(module, exports) {

let $78292d1fdfcd4c58$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $78292d1fdfcd4c58$var$load("3v5bN"),
    $78292d1fdfcd4c58$var$load("cx5X5"),
    $78292d1fdfcd4c58$var$load("c0RpY"),
    $78292d1fdfcd4c58$var$load("1Zo7q"),
    $78292d1fdfcd4c58$var$load("1uT6p"),
    $78292d1fdfcd4c58$var$load("7jBYv"),
    $78292d1fdfcd4c58$var$load("eI3Gm"),
    $78292d1fdfcd4c58$var$load("i3TSs"),
    $78292d1fdfcd4c58$var$load("4Oj5y"),
    $78292d1fdfcd4c58$var$load("58UdM"),
    $78292d1fdfcd4c58$var$load("4Qstt"),
    $78292d1fdfcd4c58$var$load("5odbj"),
    $78292d1fdfcd4c58$var$load("affRy"),
    $78292d1fdfcd4c58$var$load("i5Fj1"),
    $78292d1fdfcd4c58$var$load("dH2J7"),
    $78292d1fdfcd4c58$var$load("2u53D"),
    $78292d1fdfcd4c58$var$load("dLkMK"),
    $78292d1fdfcd4c58$var$load("3hm97"),
    $78292d1fdfcd4c58$var$load("emd3r"),
    $78292d1fdfcd4c58$var$load("8NLae"),
    $78292d1fdfcd4c58$var$load("4tWDP"),
    $78292d1fdfcd4c58$var$load("dA1E5"),
    $78292d1fdfcd4c58$var$load("ePOyH"),
    $78292d1fdfcd4c58$var$load("2F69B"),
    $78292d1fdfcd4c58$var$load("daCl8"),
    $78292d1fdfcd4c58$var$load("leIbB"),
    $78292d1fdfcd4c58$var$load("bdLqi"),
    $78292d1fdfcd4c58$var$load("iAspJ"),
    $78292d1fdfcd4c58$var$load("aGZFn"),
    $78292d1fdfcd4c58$var$load("k0WnS"),
    $78292d1fdfcd4c58$var$load("joJy8"),
    $78292d1fdfcd4c58$var$load("aHE9G"),
    $78292d1fdfcd4c58$var$load("dTsOE"),
    $78292d1fdfcd4c58$var$load("7jSfd"),
    $78292d1fdfcd4c58$var$load("4HZlX"),
    $78292d1fdfcd4c58$var$load("kDqHr"),
    $78292d1fdfcd4c58$var$load("kjZZD"),
    $78292d1fdfcd4c58$var$load("5i7Tn"),
    $78292d1fdfcd4c58$var$load("c6MKV"),
    $78292d1fdfcd4c58$var$load("ZJtkJ"),
    $78292d1fdfcd4c58$var$load("6qah4"),
    $78292d1fdfcd4c58$var$load("aZinD"),
    $78292d1fdfcd4c58$var$load("kFF5s"),
    $78292d1fdfcd4c58$var$load("gWoEm"),
    $78292d1fdfcd4c58$var$load("ffEVr"),
    $78292d1fdfcd4c58$var$load("7ylp3"),
    $78292d1fdfcd4c58$var$load("kIPUL"),
    $78292d1fdfcd4c58$var$load("aodp5"),
    $78292d1fdfcd4c58$var$load("6zHfc"),
    $78292d1fdfcd4c58$var$load("jXE7i"),
    $78292d1fdfcd4c58$var$load("2Qrvo"),
    $78292d1fdfcd4c58$var$load("j2GwS"),
    $78292d1fdfcd4c58$var$load("e9stW"),
    $78292d1fdfcd4c58$var$load("6Tuw7"),
    $78292d1fdfcd4c58$var$load("6Z8WE"),
    $78292d1fdfcd4c58$var$load("5rfwb")
]).then(()=>parcelRequire('bUMKD'));

});


parcelRegister("6UoIL", function(module, exports) {

$parcel$export(module.exports, "GlobalPageForgeAppsRoute", () => $88f9531119605f50$export$a0e2b6c59fd25a4e);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jhzhs = parcelRequire("jhzhs");

var $9wGTI = parcelRequire("9wGTI");
const $88f9531119605f50$export$a0e2b6c59fd25a4e = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jhzhs.ForgeGlobalPageExtensionPoint), {
        key: `${appId}-${envId}-${forgeManifestRoute}`,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    });
$88f9531119605f50$export$a0e2b6c59fd25a4e.NAVIGATION_PARAMS = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute } })=>{
    return (0, $9wGTI.fg)('forge-ui-enable-fpa-route') ? false : {
        Screen: {
            screenEvent: {
                name: 'globalPageScreen',
                id: appId,
                attributes: {
                    appId: appId,
                    envId: envId,
                    forgeManifestRoute: forgeManifestRoute
                }
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    };
};

});
parcelRegister("jhzhs", function(module, exports) {

$parcel$export(module.exports, "ForgeGlobalPageExtensionPoint", () => $2a1308b9f924bd74$export$dceb5680f254ba0d);

var $jmjWc = parcelRequire("jmjWc");

const $2a1308b9f924bd74$export$dceb5680f254ba0d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4i8AJ",
    name: "ForgeGlobalPageExtensionPoint",
    loader: async ()=>(await (parcelRequire("62dHY"))).GlobalPage
});

});
parcelRegister("62dHY", function(module, exports) {

let $464d902a51a62677$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $464d902a51a62677$var$load("amygy").then(()=>parcelRequire('iMfxO'));

});



parcelRegister("kSvOq", function(module, exports) {

$parcel$export(module.exports, "GlobalPermissionRoute", () => $5651b1434c6bae88$export$72e24cb8f0330a61);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $5651b1434c6bae88$var$SitePermissions = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "8YbJt",
    name: "SitePermissions",
    loader: async ()=>(await (parcelRequire("1JROr"))).SitePermissions
});
const $5651b1434c6bae88$export$72e24cb8f0330a61 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5651b1434c6bae88$var$SitePermissions, null);
$5651b1434c6bae88$export$72e24cb8f0330a61.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'sitePermissionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});
parcelRegister("1JROr", function(module, exports) {

let $1443bc740b30cd33$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1443bc740b30cd33$var$load("j4POW"),
    $1443bc740b30cd33$var$load("aZinD"),
    $1443bc740b30cd33$var$load("ftJgg"),
    $1443bc740b30cd33$var$load("h4Nf7"),
    $1443bc740b30cd33$var$load("1FHbS"),
    $1443bc740b30cd33$var$load("dPqoW"),
    $1443bc740b30cd33$var$load("3XMOA"),
    $1443bc740b30cd33$var$load("8DoxJ"),
    $1443bc740b30cd33$var$load("ffEVr"),
    $1443bc740b30cd33$var$load("joJy8"),
    $1443bc740b30cd33$var$load("aHE9G"),
    $1443bc740b30cd33$var$load("c6MKV"),
    $1443bc740b30cd33$var$load("hA2SB"),
    $1443bc740b30cd33$var$load("6ExNy")
]).then(()=>parcelRequire('iIJIO'));

});


parcelRegister("isuOo", function(module, exports) {

$parcel$export(module.exports, "AdminCompanyHubPermissionsRoute", () => $ce2a2ee7f6871785$export$eeb7368e8bf944ac);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $ayyKy = parcelRequire("ayyKy");

var $9HNv5 = parcelRequire("9HNv5");

var $2xHWL = parcelRequire("2xHWL");
var $agglT = parcelRequire("agglT");

var $8NC5Z = parcelRequire("8NC5Z");

var $cEgMD = parcelRequire("cEgMD");

var $1ytiN = parcelRequire("1ytiN");
parcelRequire("1SvVY");
var $2Uf3N = parcelRequire("2Uf3N");

var $8plBz = parcelRequire("8plBz");
/**
 * The routes "Company Hub settings > Users" and "Hub permissions" in the Confluence app.
 * `AdminCompanyHubPermissionsRoute` wraps this one to implement the Company Hub pseudo app.
 */ function $ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute({ params: params, ...props }) {
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    if (isSiteAdmin && shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
        featureName: "companyHubPermissions"
    });
    if (!params.tab) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2xHWL.CompanyHubSettingsPage), {
        tab: (0, $agglT.CompanyHubSettingsPageTabsType).USERS
    });
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8plBz.SpacePermissionsSettingsRoute), {
        ...props,
        params: {
            spaceKey: spaceKey,
            ...params
        }
    });
}
$ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute.NAVIGATION_PARAMS = (routeMatch)=>{
    const { name: name, params: params } = routeMatch;
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    const navView = (0, $ayyKy.getCompanyHubSideNav)(routeMatch) ? (0, $4l6Wo.ADMIN_HOME_ID) : (0, $4l6Wo.COMPANY_HUB_SETTINGS_ID);
    return {
        Screen: {
            screenEvent: {
                name: `${params.tab || 'consolidated'}HubPermissionsScreen`,
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: navView,
            spaceKey: spaceKey
        }
    };
};
const $ce2a2ee7f6871785$export$eeb7368e8bf944ac = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute);

});
parcelRegister("2xHWL", function(module, exports) {

$parcel$export(module.exports, "CompanyHubSettingsPage", () => $b11848dc615e604f$export$b212d6e1ccf8d345);
$parcel$export(module.exports, "CompanyHubSettingsPageTabsType", () => (parcelRequire("agglT")).CompanyHubSettingsPageTabsType);

var $jmjWc = parcelRequire("jmjWc");

var $agglT = parcelRequire("agglT");

const $b11848dc615e604f$export$b212d6e1ccf8d345 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uZr6h",
    loader: async ()=>(await (parcelRequire("9Wfbt"))).CompanyHubSettingsPage,
    name: 'CompanyHubSettingsPage'
});

});
parcelRegister("agglT", function(module, exports) {

$parcel$export(module.exports, "CompanyHubSettingsPageTabsType", () => $585d52ec7db54bb4$export$e0a694ad492b37fe);
var $585d52ec7db54bb4$export$e0a694ad492b37fe = /*#__PURE__*/ function(CompanyHubSettingsPageTabsType) {
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["GENERAL"] = 0] = "GENERAL";
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["ANALYTICS"] = 1] = "ANALYTICS";
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["USERS"] = 2] = "USERS";
    return CompanyHubSettingsPageTabsType;
}({});

});

parcelRegister("9Wfbt", function(module, exports) {

let $73c54f107965176c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $73c54f107965176c$var$load("dH2J7"),
    $73c54f107965176c$var$load("3XMOA"),
    $73c54f107965176c$var$load("7vwsA"),
    $73c54f107965176c$var$load("kFF5s"),
    $73c54f107965176c$var$load("gWoEm"),
    $73c54f107965176c$var$load("3Qqx3"),
    $73c54f107965176c$var$load("1giye"),
    $73c54f107965176c$var$load("9z63v"),
    $73c54f107965176c$var$load("c6MKV"),
    $73c54f107965176c$var$load("1fLz7")
]).then(()=>parcelRequire('eBAks'));

});


parcelRegister("1SvVY", function(module, exports) {

$parcel$export(module.exports, "getCompanyHubPseudoAppRoute", () => (parcelRequire("2Uf3N")).getCompanyHubPseudoAppRoute);

var $2Uf3N = parcelRequire("2Uf3N");

});

parcelRegister("8plBz", function(module, exports) {

$parcel$export(module.exports, "SpacePermissionsSettingsRoute", () => $3dace45d43821ccc$export$c4e68572e7b94bc6);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

var $ayyKy = parcelRequire("ayyKy");

var $cEgMD = parcelRequire("cEgMD");

var $kE2cJ = parcelRequire("kE2cJ");

var $1NBp8 = parcelRequire("1NBp8");

var $9wGTI = parcelRequire("9wGTI");

const $3dace45d43821ccc$var$SpacePermissionsSettingsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3C38l",
    name: "SpacePermissionsSettingsRouteComponent",
    loader: async ()=>(parcelRequire("43DtN"))
});
const $3dace45d43821ccc$var$DEFAULT_TAB = 'users';
const $3dace45d43821ccc$export$c4e68572e7b94bc6 = ({ name: routeName, params: { spaceKey: spaceKey, tab: tab = $3dace45d43821ccc$var$DEFAULT_TAB } })=>{
    //
    // Warning:
    // "Hub permissions" is a customization of "Space permissions" predating RBAC so
    // "Hub permissions" is to be used in the Company Hub-type of space and
    // "Space permisisons" or RBAC are to be used in all other types of space!
    //
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    if (isCompanyHub) {
        if (routeName !== (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name,
            params: {
                tab: 'users'
            }
        });
    } else {
        //RBAC Milestone 2 Redirect Logic in case users try to access via url
        const isSpacePermissionsTab = tab === 'users' || tab === 'groups' || tab === 'guests';
        if (isSpacePermissionsTab && (0, $9wGTI.fg)('cc_perms_exp_rbac_fe_milestone_2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.SPACE_MEMBERS).name,
            params: {
                spaceKey: spaceKey
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3dace45d43821ccc$var$SpacePermissionsSettingsRouteComponent, {
        spaceKey: spaceKey,
        tab: tab
    });
};
$3dace45d43821ccc$export$c4e68572e7b94bc6.NAVIGATION_PARAMS = (routeMatch, isNav4Enabled)=>{
    const { name: name, params: { spaceKey: spaceKey, tab: tab = $3dace45d43821ccc$var$DEFAULT_TAB } } = routeMatch;
    return {
        Screen: {
            screenEvent: {
                name: tab === 'public-links' ? 'spacePermissionsPublicLinksScreen' : `${tab}SpacePermissionsScreen`,
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: $3dace45d43821ccc$var$getSideNav(routeMatch, isNav4Enabled),
            spaceKey: spaceKey
        }
    };
};
const $3dace45d43821ccc$var$getSideNav = (routeMatch, isNav4Enabled)=>(0, $cEgMD.isCompanyHubSpaceKey)(routeMatch.params.spaceKey) && (0, $ayyKy.getCompanyHubSideNav)(routeMatch) ? (0, $4l6Wo.ADMIN_HOME_ID) : isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID);

});
parcelRegister("43DtN", function(module, exports) {

let $2f4611111175790d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2f4611111175790d$var$load("gAqnu"),
    $2f4611111175790d$var$load("ll4CQ"),
    $2f4611111175790d$var$load("5cXIN"),
    $2f4611111175790d$var$load("6pZc8"),
    $2f4611111175790d$var$load("amDM8"),
    $2f4611111175790d$var$load("ePOyH"),
    $2f4611111175790d$var$load("6xN9r"),
    $2f4611111175790d$var$load("iQ0Jm"),
    $2f4611111175790d$var$load("joJy8"),
    $2f4611111175790d$var$load("aHE9G"),
    $2f4611111175790d$var$load("dA1E5"),
    $2f4611111175790d$var$load("jkoeR"),
    $2f4611111175790d$var$load("8SLfD"),
    $2f4611111175790d$var$load("3XMOA"),
    $2f4611111175790d$var$load("ffEVr"),
    $2f4611111175790d$var$load("7DSUW")
]).then(()=>parcelRequire('54mQG'));

});



parcelRegister("5Hjge", function(module, exports) {

$parcel$export(module.exports, "CustomizeNavigationRoute", () => $4fa13b181dc663ad$export$3206f56dd9eda6e);
$parcel$export(module.exports, "CompanyHomeBuilderRoute", () => $4fa13b181dc663ad$export$5744f34ed241a45c);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");

const $4fa13b181dc663ad$var$CustomizeNavigation = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Ss1hK",
    name: "CustomizeNavigation",
    loader: async ()=>(await (parcelRequire("bx5My"))).CustomizeNavigation
});
const $4fa13b181dc663ad$export$3206f56dd9eda6e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4fa13b181dc663ad$var$CustomizeNavigation, null);
$4fa13b181dc663ad$export$3206f56dd9eda6e.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'customizeNavigationScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });
const $4fa13b181dc663ad$export$5744f34ed241a45c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name
    });
$4fa13b181dc663ad$export$5744f34ed241a45c.NAVIGATION_PARAMS = ()=>false;

});
parcelRegister("bx5My", function(module, exports) {

let $86574300f3cf6082$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $86574300f3cf6082$var$load("7vwsA"),
    $86574300f3cf6082$var$load("hz56j"),
    $86574300f3cf6082$var$load("ffEVr"),
    $86574300f3cf6082$var$load("5ZaO3")
]).then(()=>parcelRequire('dpLKi'));

});


parcelRegister("4CYpP", function(module, exports) {

$parcel$export(module.exports, "GlobalAutomationRoute", () => $9dff8dc763109b25$export$a4a7c409f3d3e524);

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $9dff8dc763109b25$export$a4a7c409f3d3e524 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LLjB-",
    name: "GlobalAutomationRoute",
    loader: async ()=>(await (parcelRequire("ih8G0"))).Automation
});
$9dff8dc763109b25$export$a4a7c409f3d3e524.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'globalAutomationRoute'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});
parcelRegister("ih8G0", function(module, exports) {

let $d4e08b7e95eb6fbe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d4e08b7e95eb6fbe$var$load("iIfud").then(()=>parcelRequire('fi3dY'));

});


parcelRegister("iKMnK", function(module, exports) {

$parcel$export(module.exports, "GlobalPermissionUserDetailsRoute", () => $3e17cd15ad9a2d77$export$ef0ae9b94af7599);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $3e17cd15ad9a2d77$var$UserDetails = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4otHM",
    name: "UserDetails",
    loader: async ()=>(await (parcelRequire("3sCvM"))).UserDetails
});
const $3e17cd15ad9a2d77$export$ef0ae9b94af7599 = ({ params: { accountId: accountId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3e17cd15ad9a2d77$var$UserDetails, {
        accountId: accountId
    });
$3e17cd15ad9a2d77$export$ef0ae9b94af7599.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'sitePermissionsUserDetailsScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});
parcelRegister("3sCvM", function(module, exports) {

let $2851dc36342ee6f5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2851dc36342ee6f5$var$load("j4POW"),
    $2851dc36342ee6f5$var$load("ffEVr"),
    $2851dc36342ee6f5$var$load("3XMOA"),
    $2851dc36342ee6f5$var$load("4uUio")
]).then(()=>parcelRequire('ayZRr'));

});


parcelRegister("1b9IW", function(module, exports) {

$parcel$export(module.exports, "PdfExportPageRoute", () => $de365c057d45c0f8$export$d4d3fe32e0af1ab9);

var $gwFzn = parcelRequire("gwFzn");

var $iBtwe = parcelRequire("iBtwe");

var $f1JyU = parcelRequire("f1JyU");

var $f5aR2 = parcelRequire("f5aR2");

var $iqZzD = parcelRequire("iqZzD");
const $de365c057d45c0f8$export$d4d3fe32e0af1ab9 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iBtwe.ViewPagePdfExportLoader), {
        contentId: String(contentId),
        spaceKey: String(spaceKey),
        classicComments: (0, $f1JyU.CommentsSectionLoader)
    })));
$de365c057d45c0f8$export$d4d3fe32e0af1ab9.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                contentId: contentId,
                routeName: name,
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'pdfExportScreen'
            }
        },
        MainLayout: {
            enableNavigation: false,
            spaceKey: spaceKey
        }
    });

});
parcelRegister("iBtwe", function(module, exports) {

$parcel$export(module.exports, "ViewPagePdfExportLoader", () => $a311429dbe08f666$export$6b6e4f47fea5bdb9);

var $jmjWc = parcelRequire("jmjWc");

const $a311429dbe08f666$export$6b6e4f47fea5bdb9 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "w4gXW",
    name: "ViewPagePdfExportLoader",
    loader: async ()=>(await (parcelRequire("6VlTn"))).ViewPagePdfExportPage
});

});
parcelRegister("6VlTn", function(module, exports) {

let $50a90c4454cffa14$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $50a90c4454cffa14$var$load("iPz8n"),
    $50a90c4454cffa14$var$load("7jBYv"),
    $50a90c4454cffa14$var$load("eI3Gm"),
    $50a90c4454cffa14$var$load("i3TSs"),
    $50a90c4454cffa14$var$load("4Oj5y"),
    $50a90c4454cffa14$var$load("affRy"),
    $50a90c4454cffa14$var$load("dH2J7"),
    $50a90c4454cffa14$var$load("2u53D"),
    $50a90c4454cffa14$var$load("3hm97"),
    $50a90c4454cffa14$var$load("emd3r"),
    $50a90c4454cffa14$var$load("8NLae"),
    $50a90c4454cffa14$var$load("4tWDP"),
    $50a90c4454cffa14$var$load("dA1E5"),
    $50a90c4454cffa14$var$load("ePOyH"),
    $50a90c4454cffa14$var$load("2F69B"),
    $50a90c4454cffa14$var$load("daCl8"),
    $50a90c4454cffa14$var$load("leIbB"),
    $50a90c4454cffa14$var$load("joJy8"),
    $50a90c4454cffa14$var$load("aHE9G"),
    $50a90c4454cffa14$var$load("dTsOE"),
    $50a90c4454cffa14$var$load("7jSfd"),
    $50a90c4454cffa14$var$load("4HZlX"),
    $50a90c4454cffa14$var$load("kDqHr"),
    $50a90c4454cffa14$var$load("kjZZD"),
    $50a90c4454cffa14$var$load("5i7Tn"),
    $50a90c4454cffa14$var$load("c6MKV"),
    $50a90c4454cffa14$var$load("ZJtkJ"),
    $50a90c4454cffa14$var$load("6qah4"),
    $50a90c4454cffa14$var$load("aZinD"),
    $50a90c4454cffa14$var$load("kFF5s"),
    $50a90c4454cffa14$var$load("gWoEm"),
    $50a90c4454cffa14$var$load("ffEVr"),
    $50a90c4454cffa14$var$load("7ylp3"),
    $50a90c4454cffa14$var$load("kIPUL"),
    $50a90c4454cffa14$var$load("aodp5"),
    $50a90c4454cffa14$var$load("6zHfc"),
    $50a90c4454cffa14$var$load("jXE7i"),
    $50a90c4454cffa14$var$load("2Qrvo"),
    $50a90c4454cffa14$var$load("j2GwS"),
    $50a90c4454cffa14$var$load("e9stW"),
    $50a90c4454cffa14$var$load("6Tuw7"),
    $50a90c4454cffa14$var$load("c0RpY"),
    $50a90c4454cffa14$var$load("6Z8WE"),
    $50a90c4454cffa14$var$load("27cgC")
]).then(()=>parcelRequire('fp8N8'));

});



parcelRegister("byNy2", function(module, exports) {

$parcel$export(module.exports, "PdfExportSpaceRoute", () => $cdc5bb1b4ce25ace$export$f10520cd46ef45dd);

var $gwFzn = parcelRequire("gwFzn");

var $iJ8K8 = parcelRequire("iJ8K8");

var $4NvKO = parcelRequire("4NvKO");

var $f5aR2 = parcelRequire("f5aR2");

var $iqZzD = parcelRequire("iqZzD");
const $cdc5bb1b4ce25ace$export$f10520cd46ef45dd = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4NvKO.SpaceOverviewLoader), {
        spaceKey: String(spaceKey)
    })));
$cdc5bb1b4ce25ace$export$f10520cd46ef45dd.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                routeName: name,
                contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'pdfExportScreen'
            },
            spaceKey: spaceKey
        },
        MainLayout: {
            enableNavigation: false
        }
    });

});

parcelRegister("8Ue4W", function(module, exports) {

$parcel$export(module.exports, "PeopleDirectoryRoute", () => $24a857c7c96255d7$export$c7bf94fd367d52ef);

var $gwFzn = parcelRequire("gwFzn");

var $1wgMJ = parcelRequire("1wgMJ");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

var $dEBDF = parcelRequire("dEBDF");

const $24a857c7c96255d7$var$PeopleDirectory = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zWQBJ",
    name: "PeopleDirectory",
    loader: async ()=>(await (parcelRequire("45k5u"))).PeopleDirectory
});
const $24a857c7c96255d7$export$c7bf94fd367d52ef = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($24a857c7c96255d7$var$PeopleDirectory, {
        statusCodeHandlers: {
            401: (0, $1wgMJ.redirectToLoginPage)
        }
    });
$24a857c7c96255d7$export$c7bf94fd367d52ef.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: {
            name: 'inProdPeopleDirectory',
            attributes: {
                navdexPointType: (0, $dEBDF.START_TOUCH)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    };
};

});
parcelRegister("45k5u", function(module, exports) {

let $2f97360abf3e9cba$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2f97360abf3e9cba$var$load("4tWDP"),
    $2f97360abf3e9cba$var$load("f4ySA"),
    $2f97360abf3e9cba$var$load("kFF5s"),
    $2f97360abf3e9cba$var$load("gWoEm"),
    $2f97360abf3e9cba$var$load("7ylp3"),
    $2f97360abf3e9cba$var$load("kIPUL"),
    $2f97360abf3e9cba$var$load("jSQlw"),
    $2f97360abf3e9cba$var$load("4zTgj"),
    $2f97360abf3e9cba$var$load("fKO1l"),
    $2f97360abf3e9cba$var$load("fNM8r"),
    $2f97360abf3e9cba$var$load("2u53D"),
    $2f97360abf3e9cba$var$load("jCu7l"),
    $2f97360abf3e9cba$var$load("6FSEq"),
    $2f97360abf3e9cba$var$load("erM4f"),
    $2f97360abf3e9cba$var$load("d2yzT"),
    $2f97360abf3e9cba$var$load("kPKOV"),
    $2f97360abf3e9cba$var$load("joJy8"),
    $2f97360abf3e9cba$var$load("aHE9G"),
    $2f97360abf3e9cba$var$load("dTsOE"),
    $2f97360abf3e9cba$var$load("kjZZD"),
    $2f97360abf3e9cba$var$load("ffEVr"),
    $2f97360abf3e9cba$var$load("k1740"),
    $2f97360abf3e9cba$var$load("5i7Tn"),
    $2f97360abf3e9cba$var$load("9SyhI"),
    $2f97360abf3e9cba$var$load("i0gb6"),
    $2f97360abf3e9cba$var$load("g7QTt"),
    $2f97360abf3e9cba$var$load("kksGF"),
    $2f97360abf3e9cba$var$load("ik9rg")
]).then(()=>parcelRequire('dg3UC'));

});


parcelRegister("f6D9X", function(module, exports) {

$parcel$export(module.exports, "MarketplaceRoute", () => $a6aaee7eaacb3bc0$export$1696ac6f866195be);

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

var $1NBp8 = parcelRequire("1NBp8");

const $a6aaee7eaacb3bc0$export$1696ac6f866195be = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "MGscQ",
    name: "MarketplaceRoute",
    loader: async ()=>(await (parcelRequire("2tNRQ"))).Marketplace
});
$a6aaee7eaacb3bc0$export$1696ac6f866195be.NAVIGATION_PARAMS = ({ name: name })=>{
    let eventName = '';
    let navView = (0, $4l6Wo.PRODUCT_HOME_ID);
    if (name === (0, $1NBp8.MARKETPLACE_FIND_APPS).name) {
        eventName = 'marketplaceFindApps';
        navView = (0, $4l6Wo.PRODUCT_HOME_ID);
    } else if (name === (0, $1NBp8.MARKETPLACE_APP_REQUESTS).name) {
        eventName = 'marketplaceAppRequests';
        navView = (0, $4l6Wo.ADMIN_HOME_ID);
    } else if ((0, $1NBp8.MARKETPLACE_MANAGE_PROMOTIONS).name) {
        eventName = 'marketplacePromotions';
        navView = (0, $4l6Wo.ADMIN_HOME_ID);
    }
    return {
        Screen: {
            screenEvent: {
                name: eventName,
                id: eventName
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};

});
parcelRegister("2tNRQ", function(module, exports) {

let $1ce4f8de46cc214d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1ce4f8de46cc214d$var$load("1giye"),
    $1ce4f8de46cc214d$var$load("9z63v"),
    $1ce4f8de46cc214d$var$load("hz56j"),
    $1ce4f8de46cc214d$var$load("6OarG"),
    $1ce4f8de46cc214d$var$load("7vwsA"),
    $1ce4f8de46cc214d$var$load("kFF5s"),
    $1ce4f8de46cc214d$var$load("gWoEm"),
    $1ce4f8de46cc214d$var$load("c0RpY"),
    $1ce4f8de46cc214d$var$load("8myCk"),
    $1ce4f8de46cc214d$var$load("4hOv8"),
    $1ce4f8de46cc214d$var$load("aZinD"),
    $1ce4f8de46cc214d$var$load("joJy8"),
    $1ce4f8de46cc214d$var$load("aHE9G"),
    $1ce4f8de46cc214d$var$load("aQp8v"),
    $1ce4f8de46cc214d$var$load("ffEVr"),
    $1ce4f8de46cc214d$var$load("2jsRt"),
    $1ce4f8de46cc214d$var$load("c6MKV"),
    $1ce4f8de46cc214d$var$load("gvaCb"),
    $1ce4f8de46cc214d$var$load("egrVC"),
    $1ce4f8de46cc214d$var$load("2NBvi"),
    $1ce4f8de46cc214d$var$load("dUXgJ"),
    $1ce4f8de46cc214d$var$load("eVJyV")
]).then(()=>parcelRequire('9yrtR'));

});


parcelRegister("gM2ac", function(module, exports) {

$parcel$export(module.exports, "SpaceForgeAppsRoute", () => $e20a45805838a7c5$export$16cbc228d727cb5e);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $1yDud = parcelRequire("1yDud");

var $iqZzD = parcelRequire("iqZzD");
const $e20a45805838a7c5$export$16cbc228d727cb5e = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1yDud.ForgeSpacePageExtensionPoint), {
        key: appId + envId + forgeManifestRoute,
        spaceKey: spaceKey,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    }));
};
$e20a45805838a7c5$export$16cbc228d727cb5e.NAVIGATION_PARAMS = ({ name: name, params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceForgeApps',
                id: spaceKey,
                attributes: {
                    appId: appId,
                    envId: envId,
                    forgeManifestRoute: forgeManifestRoute
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });

});
parcelRegister("1yDud", function(module, exports) {

$parcel$export(module.exports, "ForgeSpacePageExtensionPoint", () => $3dce15286068fd34$export$f2df3d24f362ca75);

var $jmjWc = parcelRequire("jmjWc");

const $3dce15286068fd34$export$f2df3d24f362ca75 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "QJy0w",
    name: "ForgeSpacePageExtensionPoint",
    loader: async ()=>(await (parcelRequire("lV0S7"))).SpacePage
});

});
parcelRegister("lV0S7", function(module, exports) {

let $ff4f98fa05691718$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ff4f98fa05691718$var$load("8DoxJ"),
    $ff4f98fa05691718$var$load("28vtL"),
    $ff4f98fa05691718$var$load("gFbkL"),
    $ff4f98fa05691718$var$load("lnKog"),
    $ff4f98fa05691718$var$load("9L8th"),
    $ff4f98fa05691718$var$load("gkmZg"),
    $ff4f98fa05691718$var$load("h4Nf7"),
    $ff4f98fa05691718$var$load("i8NEY"),
    $ff4f98fa05691718$var$load("zvjDr"),
    $ff4f98fa05691718$var$load("1FHbS"),
    $ff4f98fa05691718$var$load("dPqoW"),
    $ff4f98fa05691718$var$load("7VwsU"),
    $ff4f98fa05691718$var$load("fsZ6i"),
    $ff4f98fa05691718$var$load("N7HSS"),
    $ff4f98fa05691718$var$load("gFkzm"),
    $ff4f98fa05691718$var$load("b7RD3"),
    $ff4f98fa05691718$var$load("dTsOE"),
    $ff4f98fa05691718$var$load("g9CVe"),
    $ff4f98fa05691718$var$load("6qah4"),
    $ff4f98fa05691718$var$load("i73Fi"),
    $ff4f98fa05691718$var$load("4Bp5z"),
    $ff4f98fa05691718$var$load("6gqpV"),
    $ff4f98fa05691718$var$load("aZinD"),
    $ff4f98fa05691718$var$load("ffEVr"),
    $ff4f98fa05691718$var$load("joJy8"),
    $ff4f98fa05691718$var$load("aHE9G"),
    $ff4f98fa05691718$var$load("c6MKV"),
    $ff4f98fa05691718$var$load("ldtPf"),
    $ff4f98fa05691718$var$load("6unZM")
]).then(()=>parcelRequire('c0oNl'));

});



parcelRegister("b46bP", function(module, exports) {

$parcel$export(module.exports, "SpaceSettingsForgeAppsRoute", () => $70d1956925899c9e$export$21a09e0ddc77eafe);
/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $70d1956925899c9e$var$SpaceSettingsForgeAppsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zXYF3",
    name: "SpaceSettingsForgeAppsRouteComponent",
    loader: ()=>(parcelRequire("iWtnm"))
});
const $70d1956925899c9e$export$21a09e0ddc77eafe = ({ params: { appId: appId, forgeManifestRoute: forgeManifestRoute, envId: envId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($70d1956925899c9e$var$SpaceSettingsForgeAppsRouteComponent, {
        spaceKey: spaceKey,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    });
$70d1956925899c9e$export$21a09e0ddc77eafe.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, appId: appId, envId: envId } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsForgeApps',
                id: spaceKey,
                attributes: {
                    appId: appId,
                    envId: envId
                }
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });

});
parcelRegister("iWtnm", function(module, exports) {

let $dca46e37a5070606$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dca46e37a5070606$var$load("7UdVV").then(()=>parcelRequire('kCK7c'));

});


parcelRegister("3Bgee", function(module, exports) {

$parcel$export(module.exports, "SpaceSettingsArchiveSpaceRoute", () => $3d2592d831aaf97c$export$c5e406a0947cdc56);
/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $3d2592d831aaf97c$var$SpaceSettingsArchiveSpaceRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ZLKey",
    name: "SpaceSettingsArchiveSpaceRouteComponent",
    loader: ()=>(parcelRequire("ft1IA"))
});
const $3d2592d831aaf97c$export$c5e406a0947cdc56 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3d2592d831aaf97c$var$SpaceSettingsArchiveSpaceRouteComponent, {
        spaceKey: spaceKey
    });
$3d2592d831aaf97c$export$c5e406a0947cdc56.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsArchiveSpace',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });

});
parcelRegister("ft1IA", function(module, exports) {

let $b42ae5a84fd998ea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b42ae5a84fd998ea$var$load("ge3AN").then(()=>parcelRequire('iiG61'));

});


parcelRegister("6QT4V", function(module, exports) {

$parcel$export(module.exports, "SpaceSettingsEditorConversionRoute", () => $c1c9698c93be07c8$export$698dfc3fe326e6d2);
/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $c1c9698c93be07c8$var$SpaceSettingsEditorConversionRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "640l2",
    name: "SpaceSettingsEditorConversionRouteComponent",
    loader: ()=>(parcelRequire("2Tacf"))
});
const $c1c9698c93be07c8$export$698dfc3fe326e6d2 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c1c9698c93be07c8$var$SpaceSettingsEditorConversionRouteComponent, {
        spaceKey: spaceKey
    });
$c1c9698c93be07c8$export$698dfc3fe326e6d2.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsEditorConversion',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });

});
parcelRegister("2Tacf", function(module, exports) {

let $21a8a0a06254609c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $21a8a0a06254609c$var$load("4Yemz").then(()=>parcelRequire('3R3rh'));

});


parcelRegister("g2kt1", function(module, exports) {

$parcel$export(module.exports, "SpaceSettingsContentStateRoute", () => $ada82682e35c0989$export$9cf7aa4fa48eb220);
/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $ada82682e35c0989$var$SpaceSettingsContentStateRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "dJgx9",
    name: "SpaceSettingsContentStateRouteComponent",
    loader: ()=>(parcelRequire("3Deu1"))
});
const $ada82682e35c0989$export$9cf7aa4fa48eb220 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ada82682e35c0989$var$SpaceSettingsContentStateRouteComponent, {
        spaceKey: spaceKey
    });
$ada82682e35c0989$export$9cf7aa4fa48eb220.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsContentState',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });

});
parcelRegister("3Deu1", function(module, exports) {

let $2a503fb2196cbd8c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2a503fb2196cbd8c$var$load("8prF9").then(()=>parcelRequire('aJ0Cr'));

});


parcelRegister("aGl0i", function(module, exports) {

$parcel$export(module.exports, "SpaceSettingsRelatedPagesRoute", () => $5fd2607ebf0fb934$export$50efde5a87cc8957);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $5fd2607ebf0fb934$var$SpaceSettingsRelatedPagesRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "z-Bup",
    name: "SpaceSettingsRelatedPagesRouteComponent",
    loader: async ()=>(await (parcelRequire("iNcOp"))).SpaceSettingsRelatedPagesRouteComponent
});
const $5fd2607ebf0fb934$export$50efde5a87cc8957 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5fd2607ebf0fb934$var$SpaceSettingsRelatedPagesRouteComponent, {
        spaceKey: spaceKey
    });
$5fd2607ebf0fb934$export$50efde5a87cc8957.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsRelatedPages',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });

});
parcelRegister("iNcOp", function(module, exports) {

let $dae6bdcc7429f4d1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $dae6bdcc7429f4d1$var$load("ePOyH"),
    $dae6bdcc7429f4d1$var$load("6qah4"),
    $dae6bdcc7429f4d1$var$load("3XMOA"),
    $dae6bdcc7429f4d1$var$load("ffEVr"),
    $dae6bdcc7429f4d1$var$load("aIuOE")
]).then(()=>parcelRequire('56n4X'));

});


parcelRegister("6L3RG", function(module, exports) {

$parcel$export(module.exports, "SpaceSettingsEditFeaturesRoute", () => $c991c60ce35a3f45$export$769dfef0447f3a55);
/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $c991c60ce35a3f45$var$SpaceSettingsEditFeaturesRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "iFso2",
    name: "SpaceSettingsEditFeaturesRouteComponent",
    loader: async ()=>(await (parcelRequire("8wlfd"))).SpaceSettingsEditFeaturesRouteComponent
});
const $c991c60ce35a3f45$export$769dfef0447f3a55 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c991c60ce35a3f45$var$SpaceSettingsEditFeaturesRouteComponent, {
        spaceKey: spaceKey
    });
$c991c60ce35a3f45$export$769dfef0447f3a55.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsEditFeatures',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });

});
parcelRegister("8wlfd", function(module, exports) {

let $6341ca93d82c3b55$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6341ca93d82c3b55$var$load("fV7Cf").then(()=>parcelRequire('gkSJt'));

});


parcelRegister("2fP83", function(module, exports) {

$parcel$export(module.exports, "SpaceSettingsDetailsRoute", () => $ae6364090fd3faa0$export$45c01163cd56b3a2);

var $gwFzn = parcelRequire("gwFzn");

var $feuG2 = parcelRequire("feuG2");

var $kE2cJ = parcelRequire("kE2cJ");

var $64KID = parcelRequire("64KID");

var $4l6Wo = parcelRequire("4l6Wo");

var $iqZzD = parcelRequire("iqZzD");

var $9wGTI = parcelRequire("9wGTI");
const $ae6364090fd3faa0$export$45c01163cd56b3a2 = ({ params: { spaceKey: spaceKey } })=>{
    if ((0, $9wGTI.fg)('confluence-fe-space-settings-space-details')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $feuG2.LazySpaceDetailsPage), {
        spaceKey: spaceKey
    }));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $64KID.namedRoutes).SPACE_SETTINGS.name,
        params: {
            spaceKey: spaceKey
        }
    });
};
$ae6364090fd3faa0$export$45c01163cd56b3a2.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: (0, $feuG2.SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    });

});

parcelRegister("gzxVF", function(module, exports) {

$parcel$export(module.exports, "SpaceLookAndFeelSettingsRoute", () => $ea3042d7dfb4b938$export$9ebf5b01b0356442);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $4l6Wo = parcelRequire("4l6Wo");

const $ea3042d7dfb4b938$var$SpaceLookAndFeelSettingsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EJBqs",
    name: "SpaceLookAndFeelSettingsRouteComponent",
    loader: async ()=>(parcelRequire("gAj8F"))
});
const $ea3042d7dfb4b938$export$9ebf5b01b0356442 = ({ params: { spaceKey: spaceKey, tab: tab } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ea3042d7dfb4b938$var$SpaceLookAndFeelSettingsRouteComponent, {
        spaceKey: spaceKey,
        tab: tab
    });
};
$ea3042d7dfb4b938$export$9ebf5b01b0356442.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingLookAndFeelPage',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });

});
parcelRegister("gAj8F", function(module, exports) {

let $c12edaafd5f83912$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c12edaafd5f83912$var$load("ePOyH"),
    $c12edaafd5f83912$var$load("3XMOA"),
    $c12edaafd5f83912$var$load("ffEVr"),
    $c12edaafd5f83912$var$load("dezv5")
]).then(()=>parcelRequire('hD4yV'));

});


parcelRegister("4jPVU", function(module, exports) {

$parcel$export(module.exports, "SpaceArchivedPagesRoute", () => $6079beeead36a4aa$export$77792abc2bfae7a1);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

var $8dwdz = parcelRequire("8dwdz");

var $iqZzD = parcelRequire("iqZzD");

const $6079beeead36a4aa$var$ArchivedPagesListContainer = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "mIHzp",
    name: "ArchivedPagesListContainer",
    loader: async ()=>(await (parcelRequire("i6fV0"))).ArchivedPagesListContainer
});
const $6079beeead36a4aa$export$77792abc2bfae7a1 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6079beeead36a4aa$var$ArchivedPagesListContainer, {
        spaceKey: spaceKey
    }));
};
$6079beeead36a4aa$export$77792abc2bfae7a1.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>{
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    return {
        Screen: {
            screenEvent: {
                name: 'spaceArchivedPages',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            enableNavigation: !isMobile
        }
    };
};

});
parcelRegister("i6fV0", function(module, exports) {

let $d2d522a0ebe19394$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d2d522a0ebe19394$var$load("2aE9V"),
    $d2d522a0ebe19394$var$load("iQ0Jm"),
    $d2d522a0ebe19394$var$load("dA1E5"),
    $d2d522a0ebe19394$var$load("daCl8"),
    $d2d522a0ebe19394$var$load("ffEVr"),
    $d2d522a0ebe19394$var$load("2eiOk")
]).then(()=>parcelRequire('do0K0'));

});


parcelRegister("dfVB9", function(module, exports) {

$parcel$export(module.exports, "SpaceSettingsDataClassificationRoute", () => $9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca);
/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $9ad8ac092b3ce6dd$var$SpaceSettingsDataClassificationRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EYcHq",
    name: "SpaceSettingsDataClassificationRouteComponent",
    loader: ()=>(parcelRequire("5oZuH"))
});
const $9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($9ad8ac092b3ce6dd$var$SpaceSettingsDataClassificationRouteComponent, {
        spaceKey: spaceKey
    });
$9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsDataClassification',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });

});
parcelRegister("5oZuH", function(module, exports) {

let $3eeee51c109f8848$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3eeee51c109f8848$var$load("EEHCI").then(()=>parcelRequire('dtJ3H'));

});


parcelRegister("1RdAz", function(module, exports) {

$parcel$export(module.exports, "MyCalendarRoute", () => $e84d6ad8839aa142$export$355693d248632c9a);

var $gwFzn = parcelRequire("gwFzn");

var $ltKTq = parcelRequire("ltKTq");

var $4H46k = parcelRequire("4H46k");
function $e84d6ad8839aa142$export$355693d248632c9a() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyTeamCalendars), {
        calendarContext: (0, $ltKTq.CALENDAR_CONTEXT).MY_CALENDARS
    });
}
$e84d6ad8839aa142$export$355693d248632c9a.NAVIGATION_PARAMS = ({ spaceKey: spaceKey })=>({
        Screen: {
            screenEvent: {
                name: 'myCalendarsScreen',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            spaceKey: spaceKey
        }
    });

});

parcelRegister("gRPTO", function(module, exports) {

$parcel$export(module.exports, "SpaceTeamCalendarsRoute", () => $116a232d5237eb91$export$c1ba174e1a668b1a);
/* eslint-disable react/prop-types */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

var $ltKTq = parcelRequire("ltKTq");

const $116a232d5237eb91$var$SpaceTeamCalendarsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "tO6zv",
    name: "SpaceTeamCalendarsRouteComponent",
    loader: ()=>(parcelRequire("fjPoa"))
});
const $116a232d5237eb91$export$c1ba174e1a668b1a = ({ params: { subCalendarId: subCalendarId } })=>{
    const calendarContext = subCalendarId ? (0, $ltKTq.CALENDAR_CONTEXT).SPACE_SUBCALENDAR : (0, $ltKTq.CALENDAR_CONTEXT).SPACE_CALENDARS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($116a232d5237eb91$var$SpaceTeamCalendarsRouteComponent, {
        subCalendarId: subCalendarId,
        calendarContext: calendarContext
    });
};
$116a232d5237eb91$export$c1ba174e1a668b1a.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, subCalendarId: subCalendarId } })=>{
    return {
        Screen: {
            screenEvent: {
                name: 'spaceTeamCalendarsScreen',
                id: spaceKey,
                attributes: {
                    isSingleCalendar: !!subCalendarId
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    };
};

});
parcelRegister("fjPoa", function(module, exports) {

let $b2707e1ab764b23a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b2707e1ab764b23a$var$load("fAUr9").then(()=>parcelRequire('7EJ9w'));

});


parcelRegister("aGq9N", function(module, exports) {

$parcel$export(module.exports, "SpaceEmbeddedSubcalendarRoute", () => $40c2c72cc1663e14$export$b6ba0c14cb68dffc);

var $gwFzn = parcelRequire("gwFzn");

var $ltKTq = parcelRequire("ltKTq");

var $4H46k = parcelRequire("4H46k");
const $40c2c72cc1663e14$export$b6ba0c14cb68dffc = ({ params: { subCalendarId: subCalendarId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyTeamCalendars), {
        calendarContext: (0, $ltKTq.CALENDAR_CONTEXT).EMBEDDED_SUBCALENDAR,
        subCalendarId: subCalendarId
    });
};
$40c2c72cc1663e14$export$b6ba0c14cb68dffc.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, subCalendarId: subCalendarId } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceEmbeddedSubcalendarScreen',
                id: spaceKey,
                attributes: {
                    subCalendarId: subCalendarId
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            enableNavigation: false,
            spaceKey: spaceKey
        }
    });

});

parcelRegister("kDYTs", function(module, exports) {

$parcel$export(module.exports, "SpaceDirectoryRoute", () => $6b9376eebbcdd446$export$e2f6c7ec524fdd6a);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $ku3HK = parcelRequire("ku3HK");
const $6b9376eebbcdd446$export$e2f6c7ec524fdd6a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ku3HK.LazySpaceDirectory), null);
$6b9376eebbcdd446$export$e2f6c7ec524fdd6a.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'spaceDirectoryScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID),
            disableMinWidth: true
        }
    });

});

parcelRegister("6VTQj", function(module, exports) {

$parcel$export(module.exports, "SpaceSettingsLandingPageRoute", () => $bdfe305fbc319d8d$export$b0e13503df86295);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

var $cEgMD = parcelRequire("cEgMD");

var $kE2cJ = parcelRequire("kE2cJ");

var $1NBp8 = parcelRequire("1NBp8");

const $bdfe305fbc319d8d$var$SpaceSettingsLandingPageRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EHSjL",
    name: "SpaceSettingsLandingPageRouteComponent",
    loader: ()=>(parcelRequire("wRQQ8"))
});
const $bdfe305fbc319d8d$export$b0e13503df86295 = ({ params: { spaceKey: spaceKey } })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name,
        params: {
            spaceKey: spaceKey,
            tab: 'users'
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bdfe305fbc319d8d$var$SpaceSettingsLandingPageRouteComponent, {
        spaceKey: spaceKey
    });
};
$bdfe305fbc319d8d$export$b0e13503df86295.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsLandingPage',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });

});
parcelRegister("wRQQ8", function(module, exports) {

let $062cc302f4ddf98f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $062cc302f4ddf98f$var$load("evWu5").then(()=>parcelRequire('8foBH'));

});


parcelRegister("e7w9d", function(module, exports) {

$parcel$export(module.exports, "SpaceOverviewRoute", () => $8290afb66ac54848$export$200c90655ff1c697);
parcelRequire("6v2ig");
var $4lJOK = parcelRequire("4lJOK");

var $kvNja = parcelRequire("kvNja");
const $8290afb66ac54848$export$200c90655ff1c697 = (0, $4lJOK.getSpaceOverviewRoute)((0, $kvNja.SpaceOverviewRouteComponent));

});
parcelRegister("kvNja", function(module, exports) {

$parcel$export(module.exports, "SpaceOverviewRouteComponent", () => $6c697104f01a0e5d$export$495cec58911c040d);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");

var $1iSzD = parcelRequire("1iSzD");

var $ep3mz = parcelRequire("ep3mz");

var $4NvKO = parcelRequire("4NvKO");

var $480xA = parcelRequire("480xA");

var $f1JyU = parcelRequire("f1JyU");

var $6O2BV = parcelRequire("6O2BV");

var $f5aR2 = parcelRequire("f5aR2");

var $iqZzD = parcelRequire("iqZzD");

var $4H46k = parcelRequire("4H46k");

var $9pOEz = parcelRequire("9pOEz");

var $9wGTI = parcelRequire("9wGTI");
const $6c697104f01a0e5d$var$EmbeddedSpaceOverview = ({ spaceKey: spaceKey, contentId: contentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $480xA.EmbeddedViewPageLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        classicComments: (0, $f1JyU.CommentsSectionLoader),
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader),
        showHeaderButtons: false
    }));
};
const $6c697104f01a0e5d$var$SpaceOverview = ({ spaceKey: spaceKey })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4NvKO.SpaceOverviewLoader), {
        spaceKey: spaceKey
    });
};
const $6c697104f01a0e5d$export$495cec58911c040d = ({ spaceKey: spaceKey })=>{
    const [contextContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = contextContentId ?? '';
    const component = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6c697104f01a0e5d$var$EmbeddedSpaceOverview, {
        contentId: contentId,
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6c697104f01a0e5d$var$SpaceOverview, {
        spaceKey: spaceKey
    });
    if ((0, $9wGTI.fg)('confluence_frontend_ssr_space_base')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9pOEz.CommentContextWrapper), null, component)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyDwellTime), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), {
        spaceKey: spaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9pOEz.CommentContextWrapper), null, component))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyDwellTime), null));
};
var $6c697104f01a0e5d$export$2e2bcd8739ae039 = $6c697104f01a0e5d$export$495cec58911c040d;

});


parcelRegister("kn7N3", function(module, exports) {

$parcel$export(module.exports, "CompanyHubRoute", () => $f6b27607b6d81126$export$d8819c37d45ffdfc);
parcelRequire("6v2ig");
var $hDf9e = parcelRequire("hDf9e");

var $kvNja = parcelRequire("kvNja");
const $f6b27607b6d81126$export$d8819c37d45ffdfc = (0, $hDf9e.getCompanyHubRoute)((0, $kvNja.SpaceOverviewRouteComponent));

});

parcelRegister("88o5m", function(module, exports) {

$parcel$export(module.exports, "CompanyHubAnalyticsRoute", () => $b5f6e0dacae3f98e$export$ccf9c625603cc873);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $9HNv5 = parcelRequire("9HNv5");

var $2xHWL = parcelRequire("2xHWL");
var $agglT = parcelRequire("agglT");

var $8NC5Z = parcelRequire("8NC5Z");

var $1NBp8 = parcelRequire("1NBp8");

var $cEgMD = parcelRequire("cEgMD");
parcelRequire("1SvVY");
var $2Uf3N = parcelRequire("2Uf3N");
/**
 * The route "Company Hub settings > Analytics" in the Confluence app.
 * `CompanyHubAnalyticsRoute` wraps this one to implement the Company Hub pseudo app.
 */ function $b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute() {
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    if (shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
        featureName: "companyHub"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2xHWL.CompanyHubSettingsPage), {
        tab: (0, $agglT.CompanyHubSettingsPageTabsType).ANALYTICS
    });
}
$b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute.NAVIGATION_PARAMS = (_routeMatch, isNav4Enabled)=>{
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    const navView = isNav4Enabled ? (0, $4l6Wo.COMPANY_HUB_SETTINGS_ID) : (0, $4l6Wo.PRODUCT_HOME_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'companyHubAnalytics'
            },
            pageState: {
                routeName: (0, $1NBp8.COMPANY_HUB_ANALYTICS).name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};
const $b5f6e0dacae3f98e$export$ccf9c625603cc873 = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute);

});

parcelRegister("lO8N3", function(module, exports) {

$parcel$export(module.exports, "CompanyHubEditRoute", () => $1f7939e43bf6965f$export$335f265b0f783405);

var $3fx4Y = parcelRequire("3fx4Y");
parcelRequire("6v2ig");
var $hkCxu = parcelRequire("hkCxu");
const $1f7939e43bf6965f$export$335f265b0f783405 = (0, $hkCxu.getCompanyHubEditRoute)((0, $3fx4Y.EditPageOrBlogV2Route));

});
parcelRegister("3fx4Y", function(module, exports) {

$parcel$export(module.exports, "EditPageOrBlogV2Route", () => $0e80cf500c4229e5$export$5cc0e8d070ec38e9);

var $gwFzn = parcelRequire("gwFzn");

var $eXODy = parcelRequire("eXODy");

var $Ky12v = parcelRequire("Ky12v");

var $bA0Rg = parcelRequire("bA0Rg");

var $34NZw = parcelRequire("34NZw");

var $5vi32 = parcelRequire("5vi32");

var $78QFu = parcelRequire("78QFu");

var $dEBDF = parcelRequire("dEBDF");

var $4l6Wo = parcelRequire("4l6Wo");

var $cEgMD = parcelRequire("cEgMD");

var $cZa7r = parcelRequire("cZa7r");

var $kE2cJ = parcelRequire("kE2cJ");

var $1NBp8 = parcelRequire("1NBp8");

var $6O2BV = parcelRequire("6O2BV");
const $0e80cf500c4229e5$export$5cc0e8d070ec38e9 = ({ params: { contentId: contentId, spaceKey: spaceKey, contentType: editRouteTypeParam }, query: query, pathname: pathname })=>{
    const draftShareId = typeof query?.draftShareId === 'string' ? query.draftShareId : undefined;
    // editRouteTypeParam !== contentType !== pageType
    // editContentType is blog or pages
    // contentType is blogpost or page
    // pageType is blog or page
    const contentType = editRouteTypeParam === 'blog' ? 'blogpost' : 'page';
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const shouldRedirectCompanyHubEditRoute = isCompanyHub && (0, $1NBp8.COMPANY_HUB_EDIT).pattern !== pathname;
    if (shouldRedirectCompanyHubEditRoute) // The company hub edit route should handle upsell scenarios and other cases
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.COMPANY_HUB_EDIT).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cZa7r.AnnotationsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bA0Rg.EditPageLoaderServer), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $Ky12v.EditPageLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $34NZw.PageShownPublicLinksEventLoader), {
        contentId: contentId,
        isPage: editRouteTypeParam === 'page',
        isEditPage: true
    })));
};
$0e80cf500c4229e5$export$5cc0e8d070ec38e9.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey, contentType: editRouteTypeParam } })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    const isPageLikeContent = editRouteTypeParam === 'pages' || editRouteTypeParam === 'blog';
    const isBlog = editRouteTypeParam === 'blog';
    // editRouteTypeParam !== contentType
    // editRouteTypeParam is blog or pages
    // contentType is blogpost or page
    const contentType = editRouteTypeParam === 'blog' ? 'blogpost' : 'page';
    let viewId = (0, $4l6Wo.CONTAINER_HOME_ID);
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) viewId = (0, $4l6Wo.PRODUCT_HOME_ID);
    else if (isBlog) viewId = (0, $4l6Wo.CONTAINER_BLOG_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: false,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)(),
                    navdexPointType: (0, $dEBDF.END)
                }
            },
            pageState: {
                routeName: routeName,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: contentType
            },
            showPremiumOnboarding: isPageLikeContent ? showPremiumOnboarding : false
        },
        MainLayout: {
            navView: viewId,
            spaceKey: spaceKey,
            editorPreloader: isPageLikeContent ? (0, $eXODy.getEditorPreloader) : undefined,
            disableMinWidth: true,
            isViewPage: true,
            isEdit: true
        }
    };
};

});
parcelRegister("Ky12v", function(module, exports) {

$parcel$export(module.exports, "EditPageLoader", () => $3a3f581332e861b8$export$b6d447abe5222d2c);

var $gwFzn = parcelRequire("gwFzn");

var $hnvzE = parcelRequire("hnvzE");

var $jXpbL = parcelRequire("jXpbL");

var $dHX7l = parcelRequire("dHX7l");

var $eqNP8 = parcelRequire("eqNP8");

var $kE2cJ = parcelRequire("kE2cJ");

var $1NBp8 = parcelRequire("1NBp8");

var $gTyTP = parcelRequire("gTyTP");

var $2MhGC = parcelRequire("2MhGC");
const $3a3f581332e861b8$var$EditPageLoaderInternal = ({ contentId: contentId, spaceKey: spaceKey, draftShareId: draftShareId, contentType: contentType, ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader })=>{
    const [prevContentId, setPrevContentId] = (0, $gwFzn.useState)(contentId);
    const [prevContentType, setPrevContentType] = (0, $gwFzn.useState)(contentType);
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { referredFromLivePage: referredFromLivePage } = (0, $2MhGC.useEditPageLoadingValues)();
    const { loadEditor: setEditPageLoadingValues } = (0, $2MhGC.useEditPageLoadingActions)();
    const [livePageTransitionHandled, setLivePageTransitionHandled] = (0, $gwFzn.useState)(false);
    // This useEffect allows us to unmount and remount the ClassicEditorContextProvider,
    // NativeCollabLoader, and FullPageEditor when switching from one edit page to another edit page.
    // This is necessary to reset the editor properly for edit -> edit transitions.
    (0, $gwFzn.useEffect)(()=>{
        setPrevContentId(contentId);
        setLivePageTransitionHandled(false);
    }, [
        contentId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        setPrevContentType(contentType);
    }, [
        contentType
    ]);
    // Be careful when modifying this useEffect as this can break live page -> edit page transitions
    // This effect is a temporary solution to address an issue where the editor does not reset properly when navigating from a live page.
    // The editor tends to hold onto state from the previous page, causing problems when switching between pages if a full unmount doesn't occur.
    // This effects resets the editor by force-unmounting it by showing the loading screen when it detects a transition from a live page.
    (0, $gwFzn.useEffect)(()=>{
        // livePageTransitionHandled is used to prevent the editor from showing the loading screen endlessly
        if (referredFromLivePage && !livePageTransitionHandled) {
            setLivePageTransitionHandled(true);
            // Need to reset this property or it'll be retained when the browser back button is used.
            // In that case, it doesn't go through the flow that sets the value again.
            setEditPageLoadingValues({
                referredFromLivePage: undefined
            });
        }
    }, [
        referredFromLivePage,
        livePageTransitionHandled,
        setEditPageLoadingValues
    ]);
    if (contentId !== prevContentId || contentType !== prevContentType || referredFromLivePage && !livePageTransitionHandled) // isLoading is set to true by a state change, which does not happen immediately after content id changes
    // To make sure loading screen shows up immediately after content id changes, compare new content id with the content id in ref
    // This is smilar to how componentWillUpdate works in a classic react component
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
    const EditPageWrapper = ClassicEditorContextProviderLoader ?? (({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            "data-testid": "edit-page-default-wrapper"
        }, children));
    return(// @ts-ignore - Property 'isWithinEditor' is missing in type '{ children: Element; }' but required in type '{ children: any; isWithinEditor: any; }'
    // This error was introduced after upgrading to TypeScript 5
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(EditPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jXpbL.NativeCollabPresenceStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jXpbL.NativeCollabLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        permissionTokenRefresh: (0, $jXpbL.fetchCollabPermissionToken)(contentId, draftShareId)
    }, (propsFromNativeCollab)=>propsFromNativeCollab.subType === 'live' && !propsFromNativeCollab.isOverviewPage && isLivePagesFeatureEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.VIEW_PAGE).name,
            params: {
                contentId: contentId,
                spaceKey: spaceKey
            }
        }) : // This TreeRootForServerPlaceholderWrapper placed here to ensure the proper lookup of the placeholders for
        // SSRed loadables. Due to different component trees between server (EditPageLoader) and client (EditPageLoaderServer)
        // the placeholder ids hierarchy is different. This wrapper terminates the lookup for placeholder ids on the common parent,
        // so it matches on both server and client.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dHX7l.TreeRootForServerPlaceholderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dHX7l.FullPageEditorLoader), {
            ...propsFromNativeCollab,
            extensionContextProvider: {
                ClassicEditorContextProvider: ClassicEditorContextProviderLoader
            }
        }))))));
};
const $3a3f581332e861b8$export$b6d447abe5222d2c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hnvzE.default), {
        name: "edit-page-loader"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3a3f581332e861b8$var$EditPageLoaderInternal, props));
};

});



parcelRegister("a9fiu", function(module, exports) {

$parcel$export(module.exports, "CompanyHubSettingsRoute", () => $dbfb738401d21a8a$export$5df4bb70a888e6ef);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $2xHWL = parcelRequire("2xHWL");

var $1NBp8 = parcelRequire("1NBp8");

var $cEgMD = parcelRequire("cEgMD");
parcelRequire("1SvVY");
var $2Uf3N = parcelRequire("2Uf3N");
/**
 * The route "Company Hub settings" in the Confluence app.
 * `CompanyHubSettingsRoute` wraps this one to implement the Company Hub pseudo app.
 */ const $dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2xHWL.CompanyHubSettingsPage), null);
$dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute.NAVIGATION_PARAMS = (_routeMatch, isNav4Enabled)=>{
    const navView = isNav4Enabled ? (0, $4l6Wo.COMPANY_HUB_SETTINGS_ID) : (0, $4l6Wo.PRODUCT_HOME_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'companyHubSettingsScreen',
                attributes: {
                    // Company Hub hides its space from the user, doesn't refer to its page
                    // as such, is rather presented to the user as "a new surface", and thus
                    // doesn't constitute space usage from the perspective of the user.
                    screenIsInSpace: false
                }
            },
            pageState: {
                routeName: (0, $1NBp8.COMPANY_HUB_SETTINGS).name,
                spaceKey: (0, $cEgMD.getCompanyHubSpaceKey)()
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};
const $dbfb738401d21a8a$export$5df4bb70a888e6ef = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute);

});

parcelRegister("bnrhk", function(module, exports) {

$parcel$export(module.exports, "SpacePagesRoute", () => $3ae3b5e6a32b9f05$export$64ef8a59e56631d4);

var $gwFzn = parcelRequire("gwFzn");

var $eXODy = parcelRequire("eXODy");

var $jmjWc = parcelRequire("jmjWc");

var $4l6Wo = parcelRequire("4l6Wo");

var $dEBDF = parcelRequire("dEBDF");

var $iqZzD = parcelRequire("iqZzD");

const $3ae3b5e6a32b9f05$var$SpacePages = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Mg0yj",
    name: "SpacePages",
    loader: async ()=>(await (parcelRequire("8GsWB"))).SpacePages
});
const $3ae3b5e6a32b9f05$export$64ef8a59e56631d4 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3ae3b5e6a32b9f05$var$SpacePages, null));
};
$3ae3b5e6a32b9f05$export$64ef8a59e56631d4.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spacePagesScreen',
                attributes: {
                    navigationLayer: 'container',
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            editorPreloader: (0, $eXODy.getEditorPreloader),
            disableMinWidth: true
        }
    });

});
parcelRegister("8GsWB", function(module, exports) {

let $6528b2b4b3feca16$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6528b2b4b3feca16$var$load("3D26r"),
    $6528b2b4b3feca16$var$load("kRtpG"),
    $6528b2b4b3feca16$var$load("dH2J7"),
    $6528b2b4b3feca16$var$load("do9PF"),
    $6528b2b4b3feca16$var$load("jkoeR"),
    $6528b2b4b3feca16$var$load("6qah4"),
    $6528b2b4b3feca16$var$load("kjZZD"),
    $6528b2b4b3feca16$var$load("ffEVr"),
    $6528b2b4b3feca16$var$load("jXE7i"),
    $6528b2b4b3feca16$var$load("aDjtG")
]).then(()=>parcelRequire('fJXL7'));

});


parcelRegister("4jOiz", function(module, exports) {

$parcel$export(module.exports, "BlogHomeRoute", () => $5fbf62dcc2c7f9c7$export$59ba7d1ff575355e);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $iqZzD = parcelRequire("iqZzD");

var $4H46k = parcelRequire("4H46k");
const $5fbf62dcc2c7f9c7$export$59ba7d1ff575355e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazySpaceBlogRedirect), null));
$5fbf62dcc2c7f9c7$export$59ba7d1ff575355e.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'blogHomeScreen'
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_BLOG_ID),
            spaceKey: spaceKey
        }
    });

});

parcelRegister("kfBE6", function(module, exports) {

$parcel$export(module.exports, "SpaceBulkToolsRoute", () => $95e685c28d9f350e$export$690ececaf2f5ac01);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $fMDqz = parcelRequire("fMDqz");

var $cEgMD = parcelRequire("cEgMD");

var $lt6Lx = parcelRequire("lt6Lx");

var $gllul = parcelRequire("gllul");

var $iqZzD = parcelRequire("iqZzD");
const $95e685c28d9f350e$export$690ececaf2f5ac01 = ({ params: { spaceKey: spaceKey } })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lt6Lx.DocumentContentTitle), {
        notFound: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gllul.NotFound), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fMDqz.ManagePagesLoader), {
        spaceKey: spaceKey
    }));
};
$95e685c28d9f350e$export$690ececaf2f5ac01.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceBulkTools',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });

});
parcelRegister("fMDqz", function(module, exports) {

$parcel$export(module.exports, "ManagePagesLoader", () => $604611f3b9c6a1bd$export$6fe611e4bd8a9f83);

var $jmjWc = parcelRequire("jmjWc");

const $604611f3b9c6a1bd$export$6fe611e4bd8a9f83 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "KbMaW",
    name: 'ManagePagesLoader',
    loader: async ()=>{
        return (await (parcelRequire("6xIM2"))).ManagePagesV2;
    }
});

});
parcelRegister("6xIM2", function(module, exports) {

let $4c388e4826534ddd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $4c388e4826534ddd$var$load("1giye"),
    $4c388e4826534ddd$var$load("2aE9V"),
    $4c388e4826534ddd$var$load("7vwsA"),
    $4c388e4826534ddd$var$load("kFF5s"),
    $4c388e4826534ddd$var$load("gWoEm"),
    $4c388e4826534ddd$var$load("6Tuw7"),
    $4c388e4826534ddd$var$load("9Q8Ik"),
    $4c388e4826534ddd$var$load("3FG3M"),
    $4c388e4826534ddd$var$load("3Zr7p"),
    $4c388e4826534ddd$var$load("kjZZD"),
    $4c388e4826534ddd$var$load("6ZETc"),
    $4c388e4826534ddd$var$load("joJy8"),
    $4c388e4826534ddd$var$load("aHE9G"),
    $4c388e4826534ddd$var$load("daCl8"),
    $4c388e4826534ddd$var$load("leIbB"),
    $4c388e4826534ddd$var$load("dTsOE"),
    $4c388e4826534ddd$var$load("aQp8v"),
    $4c388e4826534ddd$var$load("ffEVr"),
    $4c388e4826534ddd$var$load("2jsRt"),
    $4c388e4826534ddd$var$load("651dU")
]).then(()=>parcelRequire('gDZU2'));

});



parcelRegister("f739q", function(module, exports) {

$parcel$export(module.exports, "TemplateMigrationPreviewRoute", () => $a310d6589e3c6137$export$2549ad5558b468ce);

var $gwFzn = parcelRequire("gwFzn");

var $d0r12 = parcelRequire("d0r12");
const $a310d6589e3c6137$export$2549ad5558b468ce = ({ params: { contentId: contentId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d0r12.TemplateMigrationPreviewLoader), {
        templateId: contentId
    });
$a310d6589e3c6137$export$2549ad5558b468ce.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId } })=>({
        Screen: {
            screenEvent: {
                name: 'templateMigrationPreviewScreen'
            },
            pageState: {
                routeName: name,
                contentId: contentId
            }
        },
        MainLayout: false
    });

});
parcelRegister("d0r12", function(module, exports) {

$parcel$export(module.exports, "TemplateMigrationPreviewLoader", () => $c51c7f4fbe27db1f$export$e8ec235e2dc3d2c4);

var $jmjWc = parcelRequire("jmjWc");

const $c51c7f4fbe27db1f$export$e8ec235e2dc3d2c4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1mKe4",
    name: "TemplateMigrationPreviewLoader",
    loader: async ()=>(await (parcelRequire("3qyqN"))).TemplateMigrationPreview
});

});
parcelRegister("3qyqN", function(module, exports) {

let $27ee821b04016b5e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $27ee821b04016b5e$var$load("16ht2"),
    $27ee821b04016b5e$var$load("joJy8"),
    $27ee821b04016b5e$var$load("aHE9G"),
    $27ee821b04016b5e$var$load("kKNsN")
]).then(()=>parcelRequire('1vSpd'));

});



parcelRegister("6AwS3", function(module, exports) {

$parcel$export(module.exports, "TemplateEditorRoute", () => $db60bab822fccf44$export$b015e9e7191a93bd);

var $gwFzn = parcelRequire("gwFzn");

var $86JNs = parcelRequire("86JNs");

var $6O2BV = parcelRequire("6O2BV");
function $db60bab822fccf44$var$getId(params) {
    const { contentId: contentId, pluginKey: pluginKey, moduleKey: moduleKey } = params;
    return !contentId && moduleKey ? `${pluginKey}:${moduleKey}` : contentId;
}
const $db60bab822fccf44$export$b015e9e7191a93bd = ({ params: params })=>{
    const id = $db60bab822fccf44$var$getId(params);
    const { spaceKey: spaceKey } = params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $86JNs.TemplateEditorLoader), {
        templateId: id,
        spaceKey: spaceKey
    }));
};
$db60bab822fccf44$export$b015e9e7191a93bd.NAVIGATION_PARAMS = ({ params: params })=>{
    const id = $db60bab822fccf44$var$getId(params);
    const { spaceKey: spaceKey } = params;
    return {
        Screen: {
            screenEvent: {
                name: 'editTemplatePageScreen',
                id: id || ''
            },
            pageState: {
                contentId: id,
                spaceKey: spaceKey
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    };
};

});
parcelRegister("86JNs", function(module, exports) {

$parcel$export(module.exports, "TemplateEditorLoader", () => $ab6a74840300f72c$export$8cf1c696fd3c0922);

var $jmjWc = parcelRequire("jmjWc");

const $ab6a74840300f72c$export$8cf1c696fd3c0922 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-xoDL",
    name: "TemplateEditorLoader",
    loader: async ()=>{
        const { TemplateEditor: TemplateEditor } = await (parcelRequire("7HuU5"));
        return TemplateEditor;
    }
});

});
parcelRegister("7HuU5", function(module, exports) {

let $59b48561e851572c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $59b48561e851572c$var$load("j2GwS"),
    $59b48561e851572c$var$load("e9stW"),
    $59b48561e851572c$var$load("7jBYv"),
    $59b48561e851572c$var$load("bW8TA"),
    $59b48561e851572c$var$load("iAspJ"),
    $59b48561e851572c$var$load("emd3r"),
    $59b48561e851572c$var$load("jCu7l"),
    $59b48561e851572c$var$load("42PSc"),
    $59b48561e851572c$var$load("ePOyH"),
    $59b48561e851572c$var$load("5zDuS"),
    $59b48561e851572c$var$load("jkoeR"),
    $59b48561e851572c$var$load("7vwsA"),
    $59b48561e851572c$var$load("joJy8"),
    $59b48561e851572c$var$load("aHE9G"),
    $59b48561e851572c$var$load("dTsOE"),
    $59b48561e851572c$var$load("7jSfd"),
    $59b48561e851572c$var$load("4HZlX"),
    $59b48561e851572c$var$load("kDqHr"),
    $59b48561e851572c$var$load("kjZZD"),
    $59b48561e851572c$var$load("5i7Tn"),
    $59b48561e851572c$var$load("c6MKV"),
    $59b48561e851572c$var$load("ZJtkJ"),
    $59b48561e851572c$var$load("6qah4"),
    $59b48561e851572c$var$load("aZinD"),
    $59b48561e851572c$var$load("kFF5s"),
    $59b48561e851572c$var$load("gWoEm"),
    $59b48561e851572c$var$load("gAqnu"),
    $59b48561e851572c$var$load("ffEVr"),
    $59b48561e851572c$var$load("iPz8n"),
    $59b48561e851572c$var$load("jXE7i"),
    $59b48561e851572c$var$load("6Tuw7"),
    $59b48561e851572c$var$load("6Z8WE"),
    $59b48561e851572c$var$load("i0gb6"),
    $59b48561e851572c$var$load("g7QTt"),
    $59b48561e851572c$var$load("j6RYV")
]).then(()=>parcelRequire('5y7xd'));

});



parcelRegister("1LbgK", function(module, exports) {

$parcel$export(module.exports, "OnboardingRoute", () => $52219feed318a69e$export$329ee42b27a3306e);

var $gwFzn = parcelRequire("gwFzn");

var $dZv2C = parcelRequire("dZv2C");

var $dIouf = parcelRequire("dIouf");
const $52219feed318a69e$export$329ee42b27a3306e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).FLYWHEEL_ACTIVATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dZv2C.Onboarding), null));
$52219feed318a69e$export$329ee42b27a3306e.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'onboardingContainerScreen'
            }
        },
        MainLayout: false
    });

});
parcelRegister("dZv2C", function(module, exports) {

$parcel$export(module.exports, "Onboarding", () => $e6c819a73b1c7672$export$70238cd3868b67c9);

var $jmjWc = parcelRequire("jmjWc");

const $e6c819a73b1c7672$export$70238cd3868b67c9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gd8xC",
    name: "Onboarding",
    loader: async ()=>(await (parcelRequire("67AVN"))).Onboarding
});

});
parcelRegister("67AVN", function(module, exports) {

let $47500b46c5107abd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $47500b46c5107abd$var$load("1Zo7q"),
    $47500b46c5107abd$var$load("jSPit"),
    $47500b46c5107abd$var$load("4tWDP"),
    $47500b46c5107abd$var$load("kFF5s"),
    $47500b46c5107abd$var$load("gWoEm"),
    $47500b46c5107abd$var$load("cmcKh"),
    $47500b46c5107abd$var$load("70aiP"),
    $47500b46c5107abd$var$load("ej4rO"),
    $47500b46c5107abd$var$load("joJy8"),
    $47500b46c5107abd$var$load("aHE9G"),
    $47500b46c5107abd$var$load("c5krk"),
    $47500b46c5107abd$var$load("dFNh6"),
    $47500b46c5107abd$var$load("hYWtF"),
    $47500b46c5107abd$var$load("1TOYq"),
    $47500b46c5107abd$var$load("f9XGo"),
    $47500b46c5107abd$var$load("dTsOE"),
    $47500b46c5107abd$var$load("aQp8v"),
    $47500b46c5107abd$var$load("ffEVr"),
    $47500b46c5107abd$var$load("2jsRt"),
    $47500b46c5107abd$var$load("i0gb6"),
    $47500b46c5107abd$var$load("g7QTt"),
    $47500b46c5107abd$var$load("dkIUD")
]).then(()=>parcelRequire('l2J3i'));

});



parcelRegister("fIJjV", function(module, exports) {

$parcel$export(module.exports, "ContentHistoryRoute", () => $48c85dee1e05da94$export$e510023ce2e8f364);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $cEgMD = parcelRequire("cEgMD");

var $ahSiN = parcelRequire("ahSiN");
parcelRequire("1SvVY");
var $2Uf3N = parcelRequire("2Uf3N");
const $48c85dee1e05da94$var$ContentHistoryRouteComponent = ({ params: { spaceKey: spaceKey, contentId: contentId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahSiN.ContentHistoryLoader), {
        spaceKey: spaceKey,
        contentId: contentId,
        stack: "classic"
    });
$48c85dee1e05da94$var$ContentHistoryRouteComponent.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, contentId: contentId, contentSlug: contentSlug } })=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    return {
        Screen: {
            screenEvent: {
                name: isCompanyHub ? 'hubHistoryScreen' : 'pageHistoryScreen',
                id: contentId
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId,
                contentSlug: contentSlug
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: isCompanyHub ? (0, $4l6Wo.COMPANY_HUB_SETTINGS_ID) : (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    };
};
const $48c85dee1e05da94$export$e510023ce2e8f364 = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($48c85dee1e05da94$var$ContentHistoryRouteComponent, (route)=>(0, $cEgMD.isCompanyHubSpaceKey)(route?.params?.spaceKey));

});
parcelRegister("ahSiN", function(module, exports) {

$parcel$export(module.exports, "ContentHistoryLoader", () => $72fe25ca1dda155a$export$e5cc8897c2b49b25);

var $jmjWc = parcelRequire("jmjWc");

const $72fe25ca1dda155a$export$e5cc8897c2b49b25 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "P5sQM",
    name: "ContentHistoryLoader",
    loader: async ()=>(await (parcelRequire("1yDKx"))).ContentHistory
});

});
parcelRegister("1yDKx", function(module, exports) {

let $1227ccdfafbbec59$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1227ccdfafbbec59$var$load("4tWDP"),
    $1227ccdfafbbec59$var$load("7ylp3"),
    $1227ccdfafbbec59$var$load("kIPUL"),
    $1227ccdfafbbec59$var$load("1xV57"),
    $1227ccdfafbbec59$var$load("7jBYv"),
    $1227ccdfafbbec59$var$load("i3TSs"),
    $1227ccdfafbbec59$var$load("4Oj5y"),
    $1227ccdfafbbec59$var$load("affRy"),
    $1227ccdfafbbec59$var$load("dH2J7"),
    $1227ccdfafbbec59$var$load("3hm97"),
    $1227ccdfafbbec59$var$load("dA1E5"),
    $1227ccdfafbbec59$var$load("ePOyH"),
    $1227ccdfafbbec59$var$load("2F69B"),
    $1227ccdfafbbec59$var$load("leIbB"),
    $1227ccdfafbbec59$var$load("joJy8"),
    $1227ccdfafbbec59$var$load("aHE9G"),
    $1227ccdfafbbec59$var$load("dTsOE"),
    $1227ccdfafbbec59$var$load("ZJtkJ"),
    $1227ccdfafbbec59$var$load("6qah4"),
    $1227ccdfafbbec59$var$load("aZinD"),
    $1227ccdfafbbec59$var$load("ffEVr"),
    $1227ccdfafbbec59$var$load("aodp5"),
    $1227ccdfafbbec59$var$load("6zHfc"),
    $1227ccdfafbbec59$var$load("jXE7i"),
    $1227ccdfafbbec59$var$load("2Qrvo"),
    $1227ccdfafbbec59$var$load("j2GwS"),
    $1227ccdfafbbec59$var$load("e9stW"),
    $1227ccdfafbbec59$var$load("6Tuw7"),
    $1227ccdfafbbec59$var$load("c0RpY"),
    $1227ccdfafbbec59$var$load("fNffa")
]).then(()=>parcelRequire('7MAGI'));

});



parcelRegister("dXC0J", function(module, exports) {

$parcel$export(module.exports, "TemplateGalleryRoute", () => $0f81c6a8d9931e4d$export$e2ed88affe37abdc);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $lDd3Z = parcelRequire("lDd3Z");
const $0f81c6a8d9931e4d$export$e2ed88affe37abdc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lDd3Z.TemplateGalleryLoader), null);
$0f81c6a8d9931e4d$export$e2ed88affe37abdc.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'templateGalleryScreen'
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID),
            disableMinWidth: true
        }
    });

});
parcelRegister("lDd3Z", function(module, exports) {

$parcel$export(module.exports, "TemplateGalleryLoader", () => $64e99ecf69e59c34$export$9defecaf7509c9ff);

var $jmjWc = parcelRequire("jmjWc");

const $64e99ecf69e59c34$export$9defecaf7509c9ff = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "NjYCL",
    name: "TemplateGalleryLoader",
    loader: async ()=>(await (parcelRequire("b9Cwv"))).TemplateGallery
});

});
parcelRegister("b9Cwv", function(module, exports) {

let $81ee6ae67c5f480e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $81ee6ae67c5f480e$var$load("kFOec"),
    $81ee6ae67c5f480e$var$load("16ht2"),
    $81ee6ae67c5f480e$var$load("70aiP"),
    $81ee6ae67c5f480e$var$load("ePOyH"),
    $81ee6ae67c5f480e$var$load("cS7dz")
]).then(()=>parcelRequire('ec8HN'));

});



parcelRegister("4kytX", function(module, exports) {

$parcel$export(module.exports, "MobileTakeoverPageRoute", () => $7b810fd40f00ac37$export$1a98ae7373202607);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $7b810fd40f00ac37$var$MobileAppTakeoverPageLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oLwa7",
    name: "MobileAppTakeoverPageLoader",
    loader: async ()=>(await (parcelRequire("hreS5"))).MobileAppTakeoverPage
});
const $7b810fd40f00ac37$export$1a98ae7373202607 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7b810fd40f00ac37$var$MobileAppTakeoverPageLoader, null);
$7b810fd40f00ac37$export$1a98ae7373202607.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'mobileTakeoverPage'
            }
        },
        MainLayout: false
    });

});
parcelRegister("hreS5", function(module, exports) {

let $cb207e7295a633c5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $cb207e7295a633c5$var$load("aZinD"),
    $cb207e7295a633c5$var$load("7S9EX")
]).then(()=>parcelRequire('3VmKy'));

});


parcelRegister("e1x2n", function(module, exports) {

$parcel$export(module.exports, "WikiRoute", () => $75f6c666a9c742b2$export$e5707bd7e32dbf9b);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $3Up8V = parcelRequire("3Up8V");
const $75f6c666a9c742b2$export$e5707bd7e32dbf9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Up8V.SiteHomepageRedirectLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Up8V.GoToHomeLoader), null));
$75f6c666a9c742b2$export$e5707bd7e32dbf9b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'wikiScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    });

});
parcelRegister("3Up8V", function(module, exports) {

$parcel$export(module.exports, "SiteHomepageRedirectLoader", () => $9a92030a887a5e49$export$1fe963e8f052ccbb);
$parcel$export(module.exports, "GoToHomeLoader", () => $9a92030a887a5e49$export$c34c105fee6e8977);

var $jmjWc = parcelRequire("jmjWc");

const $9a92030a887a5e49$export$1fe963e8f052ccbb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "_BuCT",
    name: "SiteHomepageRedirectLoader",
    loader: async ()=>(await (parcelRequire("f69jJ"))).SiteHomepageRedirect
});

const $9a92030a887a5e49$export$c34c105fee6e8977 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "fei0k",
    name: "GoToHomeLoader",
    loader: async ()=>(await (parcelRequire("8QjJF"))).GoToHome
});

});
parcelRegister("f69jJ", function(module, exports) {

let $afdea4c09d7a6293$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $afdea4c09d7a6293$var$load("cgZOp").then(()=>parcelRequire('kkwpp'));

});

parcelRegister("8QjJF", function(module, exports) {

let $67027d1fbe3577e2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $67027d1fbe3577e2$var$load("c0lrw").then(()=>parcelRequire('7QGXJ'));

});



parcelRegister("bCsEo", function(module, exports) {

$parcel$export(module.exports, "HomeRoute", () => $4625b8b3d160569d$export$48d3d184aade51b1);

var $gwFzn = parcelRequire("gwFzn");

var $eXODy = parcelRequire("eXODy");

var $4l6Wo = parcelRequire("4l6Wo");

var $3Up8V = parcelRequire("3Up8V");

var $dEBDF = parcelRequire("dEBDF");
const $4625b8b3d160569d$export$48d3d184aade51b1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Up8V.GoToHomeLoader), null);
$4625b8b3d160569d$export$48d3d184aade51b1.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'homeScreen',
                attributes: {
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID),
            editorPreloader: (0, $eXODy.getEditorPreloader)
        }
    });

});

parcelRegister("crpJB", function(module, exports) {

$parcel$export(module.exports, "CreateBlogRoute", () => $c3c08e13adc00b49$export$daeca97aa431dd80);

var $gwFzn = parcelRequire("gwFzn");

var $4H46k = parcelRequire("4H46k");

var $cAuYW = parcelRequire("cAuYW");
const $c3c08e13adc00b49$export$daeca97aa431dd80 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazySpaceCreatePage), {
        contentType: "blogpost"
    });
$c3c08e13adc00b49$export$daeca97aa431dd80.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                ...(0, $cAuYW.navdexEnd)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    });

});
parcelRegister("cAuYW", function(module, exports) {

$parcel$export(module.exports, "navdexEnd", () => $92a0e12da2d6b5f0$export$bf305e48a79a981b);

var $dEBDF = parcelRequire("dEBDF");
const $92a0e12da2d6b5f0$export$bf305e48a79a981b = {
    attributes: {
        navdexPointType: (0, $dEBDF.END)
    }
};

});


parcelRegister("c8KH6", function(module, exports) {

$parcel$export(module.exports, "CreatePageRoute", () => $93e08279e521422d$export$92431fd1ef2a3e02);

var $gwFzn = parcelRequire("gwFzn");

var $4H46k = parcelRequire("4H46k");

var $cAuYW = parcelRequire("cAuYW");
const $93e08279e521422d$export$92431fd1ef2a3e02 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazySpaceCreatePage), {
        contentType: "page"
    });
$93e08279e521422d$export$92431fd1ef2a3e02.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                ...(0, $cAuYW.navdexEnd)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    });

});

parcelRegister("4oYhL", function(module, exports) {

$parcel$export(module.exports, "EditPageRoute", () => $2807fe6645e49e0b$export$6a3218472cdf374a);

var $gwFzn = parcelRequire("gwFzn");

var $78QFu = parcelRequire("78QFu");

var $cAuYW = parcelRequire("cAuYW");

var $4H46k = parcelRequire("4H46k");
const $2807fe6645e49e0b$export$6a3218472cdf374a = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyRouteToRightEditor), {
        contentType: "pages",
        contentId: contentId,
        spaceKey: spaceKey
    });
$2807fe6645e49e0b$export$6a3218472cdf374a.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    ...(0, $cAuYW.navdexEnd).attributes,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    });

});

parcelRegister("jABgD", function(module, exports) {

$parcel$export(module.exports, "EditBlogRoute", () => $cdf2efa932a544ee$export$657999c2675036a8);

var $gwFzn = parcelRequire("gwFzn");

var $4H46k = parcelRequire("4H46k");

var $78QFu = parcelRequire("78QFu");
const $cdf2efa932a544ee$export$657999c2675036a8 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyRouteToRightEditor), {
        contentType: "blog",
        contentId: contentId,
        spaceKey: spaceKey
    });
$cdf2efa932a544ee$export$657999c2675036a8.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'blogpost'
            }
        },
        MainLayout: false
    });

});

parcelRegister("boeN3", function(module, exports) {

$parcel$export(module.exports, "EditPageEmbedRoute", () => $dde5e37bf0f94188$export$a338f76d183c610);

var $gwFzn = parcelRequire("gwFzn");

var $480xA = parcelRequire("480xA");

var $6O2BV = parcelRequire("6O2BV");

var $cAuYW = parcelRequire("cAuYW");
const $dde5e37bf0f94188$export$a338f76d183c610 = ({ params: { contentId: contentId, spaceKey: spaceKey }, query: { draftShareId: draftShareId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $480xA.EmbeddedEditPageLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: String(draftShareId),
        contentType: "page"
    }));
$dde5e37bf0f94188$export$a338f76d183c610.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageEmbedScreen',
                id: contentId,
                ...(0, $cAuYW.navdexEnd)
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'page'
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });

});

parcelRegister("6xYtK", function(module, exports) {

$parcel$export(module.exports, "SpaceSettingsAutomationRoute", () => $d6b8391ba067d418$export$3e7656e40361b9c3);
/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $d6b8391ba067d418$var$SpaceSettingsAutomationRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xxPa8",
    name: "SpaceSettingsAutomationRouteComponent",
    loader: ()=>(parcelRequire("g1EcB"))
});
const $d6b8391ba067d418$export$3e7656e40361b9c3 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d6b8391ba067d418$var$SpaceSettingsAutomationRouteComponent, {
        spaceKey: spaceKey
    });
$d6b8391ba067d418$export$3e7656e40361b9c3.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingAutomationRoute',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });

});
parcelRegister("g1EcB", function(module, exports) {

let $baabecab2cb1c9c0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $baabecab2cb1c9c0$var$load("iO7VA").then(()=>parcelRequire('4CchY'));

});


parcelRegister("tpIej", function(module, exports) {

$parcel$export(module.exports, "SpaceCustomContentListRoute", () => $25fdeb0a789de125$export$1045fc666c352ae6);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $evmt3 = parcelRequire("evmt3");
const $25fdeb0a789de125$export$1045fc666c352ae6 = ({ params: { spaceKey: spaceKey, type: type } })=>{
    const [stateKey, setStateKey] = (0, $gwFzn.useState)(history?.state?.key || Math.random());
    // Updating a key state and reload ConnectSpaceCustomContentListView component.
    //
    // Connect Apps can have an inner history state (created with AP.history), which add
    // hashtag to URL (for example: #!state1)
    // When user navigates to this route again the URL is reset to initial state and
    // hashtag is removed, but inner app does not get any notifications about that and
    // don't reset inner app state.
    //
    // To fix this issue we are listening history.state.key, and when it's changed
    // (user create a new entry in history) refresh component
    (0, $gwFzn.useEffect)(()=>{
        // We rely on history.state.key that is not documented, but major browsers have it
        if (history?.state?.key) setStateKey(history.state.key);
        else if (!history?.state?._AP) setStateKey(Math.random());
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        history?.state,
        setStateKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $evmt3.ConnectSpaceCustomContentListView), {
        spaceKey: spaceKey,
        type: type,
        key: stateKey
    });
};
$25fdeb0a789de125$export$1045fc666c352ae6.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, type: type } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceCustomContent',
                id: spaceKey,
                attributes: {
                    type: type
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });

});
parcelRegister("evmt3", function(module, exports) {

$parcel$export(module.exports, "ConnectSpaceCustomContentListView", () => $90cab0c9e6efa470$export$c5b2c959a5ee5a4a);

var $jmjWc = parcelRequire("jmjWc");

const $90cab0c9e6efa470$export$c5b2c959a5ee5a4a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Lsv8X",
    name: "ConnectSpaceCustomContentListView",
    loader: async ()=>(await (parcelRequire("luRiY"))).ConnectSpaceCustomContentListView
});

});
parcelRegister("luRiY", function(module, exports) {

let $fa65bf97e8440eb6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $fa65bf97e8440eb6$var$load("dTsOE"),
    $fa65bf97e8440eb6$var$load("3cI3U")
]).then(()=>parcelRequire('5CzWQ'));

});



parcelRegister("eLEnw", function(module, exports) {

$parcel$export(module.exports, "CustomContentOnPageRoute", () => $4af991445198673b$export$80477c996ae74379);

var $gwFzn = parcelRequire("gwFzn");

var $4zvFX = parcelRequire("4zvFX");

var $4l6Wo = parcelRequire("4l6Wo");
const $4af991445198673b$export$80477c996ae74379 = ({ params: { contentId: contentId, spaceKey: spaceKey, type: type } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4zvFX.CustomContentOnPageComponentLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        type: type === 'undefined' ? '' : type
    });
};
$4af991445198673b$export$80477c996ae74379.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'customContentOnPage',
                id: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });

});
parcelRegister("4zvFX", function(module, exports) {

$parcel$export(module.exports, "CustomContentOnPageComponentLoader", () => $ae3041c2a586590e$export$cc376322db18bf6e);

var $jmjWc = parcelRequire("jmjWc");

const $ae3041c2a586590e$export$cc376322db18bf6e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sjwPy",
    name: "CustomContentOnPageComponentLoader",
    loader: async ()=>(await (parcelRequire("eQXea"))).CustomContentOnPageComponent
});

});
parcelRegister("eQXea", function(module, exports) {

let $ad03dd623e553de4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ad03dd623e553de4$var$load("hf7yW"),
    $ad03dd623e553de4$var$load("28vtL"),
    $ad03dd623e553de4$var$load("gFbkL"),
    $ad03dd623e553de4$var$load("lnKog"),
    $ad03dd623e553de4$var$load("2aE9V"),
    $ad03dd623e553de4$var$load("iQ0Jm"),
    $ad03dd623e553de4$var$load("daCl8"),
    $ad03dd623e553de4$var$load("ffEVr"),
    $ad03dd623e553de4$var$load("5n2uM")
]).then(()=>parcelRequire('bexnX'));

});



parcelRegister("7DnqF", function(module, exports) {

$parcel$export(module.exports, "CustomContentViewRoute", () => $c7473af47fe3192c$export$b836ebd0f49cc9f5);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $dWJbE = parcelRequire("dWJbE");
const $c7473af47fe3192c$export$b836ebd0f49cc9f5 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dWJbE.CustomContentView), {
        spaceKey: spaceKey,
        contentId: contentId
    });
};
$c7473af47fe3192c$export$b836ebd0f49cc9f5.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'customContentView',
                id: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });

});
parcelRegister("dWJbE", function(module, exports) {

$parcel$export(module.exports, "CustomContentView", () => $95bd051929613722$export$f536037c46d4c012);

var $jmjWc = parcelRequire("jmjWc");

const $95bd051929613722$export$f536037c46d4c012 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9X2ye",
    name: "CustomContentView",
    loader: async ()=>(await (parcelRequire("9rJpN"))).CustomContentView
});

});
parcelRegister("9rJpN", function(module, exports) {

let $6e09dd24d224cd4c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6e09dd24d224cd4c$var$load("lHNSl").then(()=>parcelRequire('8fbPW'));

});



parcelRegister("9AAzV", function(module, exports) {

$parcel$export(module.exports, "PublicLinksSettingsPageRoute", () => $0960da40109465b4$export$af4daa43ca1332b9);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $4l6Wo = parcelRequire("4l6Wo");

const $0960da40109465b4$var$PublicLinksSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rP97Y",
    name: "PublicLinksSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("hdSUS"))
});
const $0960da40109465b4$export$af4daa43ca1332b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($0960da40109465b4$var$PublicLinksSettingsPageRouteComponent, null);
$0960da40109465b4$export$af4daa43ca1332b9.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'publicLinksSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});
parcelRegister("hdSUS", function(module, exports) {

let $c89e3fcea85e21d5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c89e3fcea85e21d5$var$load("vlZ5n").then(()=>parcelRequire('i5MLu'));

});


parcelRegister("7Hjeq", function(module, exports) {

$parcel$export(module.exports, "ContactAdministratorRoute", () => $95bdd88deead3c11$export$ecc44bd892306adb);

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $95bdd88deead3c11$export$ecc44bd892306adb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "00c23",
    name: "ContactAdministratorRoute",
    loader: async ()=>(await (parcelRequire("c0zF3"))).ContactAdministratorPage
});
$95bdd88deead3c11$export$ecc44bd892306adb.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: {
            screenEvent: {
                name: 'contactAdministratorScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    };
};

});
parcelRegister("c0zF3", function(module, exports) {

let $8be125af7c08258a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8be125af7c08258a$var$load("hsAS2").then(()=>parcelRequire('6PsK0'));

});


parcelRegister("ggmLP", function(module, exports) {

$parcel$export(module.exports, "AdminAnnouncementBannerRendererRoute", () => $e77b8eed9c4fe03f$export$81a4ecf687c4a61b);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $4l6Wo = parcelRequire("4l6Wo");

const $e77b8eed9c4fe03f$var$AdminAnnouncementBannerRenderer = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LCRNu",
    name: "AdminAnnouncementBannerRenderer",
    loader: async ()=>(await (parcelRequire("2qPb5"))).AdminAnnouncementBannerRenderer
});
const $e77b8eed9c4fe03f$export$81a4ecf687c4a61b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e77b8eed9c4fe03f$var$AdminAnnouncementBannerRenderer, null);
};
$e77b8eed9c4fe03f$export$81a4ecf687c4a61b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminAnnouncementBannerRenderer'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});
parcelRegister("2qPb5", function(module, exports) {

let $1c55b54f7b9ebcfd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1c55b54f7b9ebcfd$var$load("dH2J7"),
    $1c55b54f7b9ebcfd$var$load("ePOyH"),
    $1c55b54f7b9ebcfd$var$load("gAqnu"),
    $1c55b54f7b9ebcfd$var$load("1eZ0R"),
    $1c55b54f7b9ebcfd$var$load("eIzhm"),
    $1c55b54f7b9ebcfd$var$load("bW8TA"),
    $1c55b54f7b9ebcfd$var$load("iAspJ"),
    $1c55b54f7b9ebcfd$var$load("avCUM"),
    $1c55b54f7b9ebcfd$var$load("emd3r"),
    $1c55b54f7b9ebcfd$var$load("7vwsA"),
    $1c55b54f7b9ebcfd$var$load("joJy8"),
    $1c55b54f7b9ebcfd$var$load("aHE9G"),
    $1c55b54f7b9ebcfd$var$load("dTsOE"),
    $1c55b54f7b9ebcfd$var$load("7jSfd"),
    $1c55b54f7b9ebcfd$var$load("4HZlX"),
    $1c55b54f7b9ebcfd$var$load("kDqHr"),
    $1c55b54f7b9ebcfd$var$load("kjZZD"),
    $1c55b54f7b9ebcfd$var$load("5i7Tn"),
    $1c55b54f7b9ebcfd$var$load("c6MKV"),
    $1c55b54f7b9ebcfd$var$load("ZJtkJ"),
    $1c55b54f7b9ebcfd$var$load("6qah4"),
    $1c55b54f7b9ebcfd$var$load("aZinD"),
    $1c55b54f7b9ebcfd$var$load("kFF5s"),
    $1c55b54f7b9ebcfd$var$load("gWoEm"),
    $1c55b54f7b9ebcfd$var$load("ffEVr"),
    $1c55b54f7b9ebcfd$var$load("iPz8n"),
    $1c55b54f7b9ebcfd$var$load("6Z8WE"),
    $1c55b54f7b9ebcfd$var$load("faxwR")
]).then(()=>parcelRequire('eHKVU'));

});


parcelRegister("k0Wco", function(module, exports) {

$parcel$export(module.exports, "AdminCenterRoute", () => $36a63e56cd2b2984$export$60c1a30975370191);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $4l6Wo = parcelRequire("4l6Wo");

var $bQm3c = parcelRequire("bQm3c");

const $36a63e56cd2b2984$var$AdminCenterPage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yN5_D",
    name: "AdminCenterPage",
    loader: async ()=>(await (parcelRequire("dAHUF"))).AdminCenterPage
});
const $36a63e56cd2b2984$export$60c1a30975370191 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($36a63e56cd2b2984$var$AdminCenterPage, null);
$36a63e56cd2b2984$export$60c1a30975370191.NAVIGATION_PARAMS = ()=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return {
        Screen: {
            screenEvent: {
                name: 'adminCenter',
                attributes: {
                    edition: edition
                }
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    };
};

});
parcelRegister("dAHUF", function(module, exports) {

let $9e50b3583c566e2b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9e50b3583c566e2b$var$load("dH2J7"),
    $9e50b3583c566e2b$var$load("kFF5s"),
    $9e50b3583c566e2b$var$load("gWoEm"),
    $9e50b3583c566e2b$var$load("3Qqx3"),
    $9e50b3583c566e2b$var$load("1wMt1"),
    $9e50b3583c566e2b$var$load("iXIx7"),
    $9e50b3583c566e2b$var$load("1giye"),
    $9e50b3583c566e2b$var$load("9z63v"),
    $9e50b3583c566e2b$var$load("do9PF"),
    $9e50b3583c566e2b$var$load("joJy8"),
    $9e50b3583c566e2b$var$load("aHE9G"),
    $9e50b3583c566e2b$var$load("kjZZD"),
    $9e50b3583c566e2b$var$load("ffEVr"),
    $9e50b3583c566e2b$var$load("c6MKV"),
    $9e50b3583c566e2b$var$load("gYbv6")
]).then(()=>parcelRequire('9qsRH'));

});


parcelRegister("2m9tD", function(module, exports) {

$parcel$export(module.exports, "AdminCenterSpaceRoute", () => $015145ca08e6a13a$export$bd929b984ffc4a9);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $4l6Wo = parcelRequire("4l6Wo");

var $bQm3c = parcelRequire("bQm3c");

var $iqZzD = parcelRequire("iqZzD");

const $015145ca08e6a13a$var$AdminCenterSpacePage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "1dPKI",
    name: "AdminCenterSpacePage",
    loader: async ()=>(await (parcelRequire("dAHUF"))).AdminCenterSpacePage
});
const $015145ca08e6a13a$export$bd929b984ffc4a9 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($015145ca08e6a13a$var$AdminCenterSpacePage, {
        spaceKey: spaceKey
    }));
};
$015145ca08e6a13a$export$bd929b984ffc4a9.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return {
        Screen: {
            screenEvent: {
                name: 'adminCenterSpace',
                id: spaceKey,
                attributes: {
                    edition: edition
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    };
};

});

parcelRegister("gxgRl", function(module, exports) {

$parcel$export(module.exports, "AdminSettingsRoute", () => $6f06338c7fe23a44$export$44bc7d6c094dc951);

var $gwFzn = parcelRequire("gwFzn");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");
const $6f06338c7fe23a44$export$44bc7d6c094dc951 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (edition === (0, $euL71.ConfluenceEdition).PREMIUM) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CENTER).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CONFIGURATION).name
    });
};
$6f06338c7fe23a44$export$44bc7d6c094dc951.NAVIGATION_PARAMS = ()=>false;

});

parcelRegister("7w9zb", function(module, exports) {

$parcel$export(module.exports, "SpaceSettingsExportSpaceUnavailableRoute", () => $e2d8d9818dde6381$export$1d1f8d0ef7c7a185);
/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $e2d8d9818dde6381$var$SpaceSettingsExportSpaceUnavailableRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HYdso",
    name: "SpaceSettingsExportSpaceUnavailableRouteComponent",
    loader: ()=>(parcelRequire("1b4bl"))
});
const $e2d8d9818dde6381$export$1d1f8d0ef7c7a185 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e2d8d9818dde6381$var$SpaceSettingsExportSpaceUnavailableRouteComponent, {
        spaceKey: spaceKey
    });
$e2d8d9818dde6381$export$1d1f8d0ef7c7a185.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsExportSpaceUnavailable',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });

});
parcelRegister("1b4bl", function(module, exports) {

let $0dba0ffc506988aa$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0dba0ffc506988aa$var$load("83Dnz").then(()=>parcelRequire('1e8Au'));

});


parcelRegister("cTDal", function(module, exports) {

$parcel$export(module.exports, "BulkSpacePermissionsRoute", () => $4255a2123073399b$export$a1ed7a563d6f8c80);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $4l6Wo = parcelRequire("4l6Wo");
parcelRequire("bbMp7");
var $9TVBV = parcelRequire("9TVBV");
var $bbMp7 = parcelRequire("bbMp7");

var $crxmG = parcelRequire("crxmG");
const $4255a2123073399b$export$a1ed7a563d6f8c80 = ()=>(0, $9wGTI.fg)('confluence_rbac_spaces_beta_opt_in') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $crxmG.BulkAccessManagementPage), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bbMp7.BulkSpacePermissionsPage), null);
$4255a2123073399b$export$a1ed7a563d6f8c80.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $9TVBV.ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});
parcelRegister("bbMp7", function(module, exports) {

$parcel$export(module.exports, "BulkSpacePermissionsPage", () => $55b7ec62080e1638$export$405a6cc8f1c994c8);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => (parcelRequire("9TVBV")).ANALYTICS_SOURCE);

var $jmjWc = parcelRequire("jmjWc");

var $9TVBV = parcelRequire("9TVBV");

const $55b7ec62080e1638$export$98f6226b8f451523 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "TMJ6c",
    loader: async ()=>(await (parcelRequire("5LPzP"))).BulkSpacePermissionsPortal,
    name: 'BulkSpacePermissionsPortal'
});

const $55b7ec62080e1638$export$405a6cc8f1c994c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LzFeC",
    loader: async ()=>(await Promise.resolve((parcelRequire("9TVBV")))).BulkSpacePermissionsPage,
    name: 'BulkSpacePermissionsPage'
});

});
parcelRegister("9TVBV", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $eb8c51b94819be10$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "i18nBulk", () => $eb8c51b94819be10$export$c4b5d6610bc5fc6e);
$parcel$export(module.exports, "BulkSpacePermissionsPage", () => $eb8c51b94819be10$export$405a6cc8f1c994c8);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1KmJq = parcelRequire("1KmJq");

var $laHi9 = parcelRequire("laHi9");

var $ccHMk = parcelRequire("ccHMk");
var $7p4As = parcelRequire("7p4As");

var $inPa6 = parcelRequire("inPa6");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $1BYn9 = parcelRequire("1BYn9");

var $9wGTI = parcelRequire("9wGTI");

var $g3p2i = parcelRequire("g3p2i");
var $hpRYU = parcelRequire("hpRYU");

var $1NBp8 = parcelRequire("1NBp8");

var $dIouf = parcelRequire("dIouf");

var $7aRa9 = parcelRequire("7aRa9");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $lqf9t = parcelRequire("lqf9t");

var $c09s4 = parcelRequire("c09s4");

var $8A6YM = parcelRequire("8A6YM");

var $dWpPi = parcelRequire("dWpPi");

var $eIwUX = parcelRequire("eIwUX");

var $2Pnx9 = parcelRequire("2Pnx9");

var $kAGh9 = parcelRequire("kAGh9");
const $eb8c51b94819be10$var$BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation = (0, $d2LG0.default)`mutation BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation($spacePermissions:[SpacePermissionType]!$spaceTypes:[BulkSetSpacePermissionSpaceType]!$subjectId:ID!$subjectType:BulkSetSpacePermissionSubjectType!){bulkSetSpacePermissionAsync(input:{spacePermissions:$spacePermissions spaceTypes:$spaceTypes subjectId:$subjectId subjectType:$subjectType}){success errors{message extensions{errorType statusCode}}taskId}}`;
const $eb8c51b94819be10$export$f7109619a5e9e0d6 = 'bulkSpacePermissionsScreen';
const $eb8c51b94819be10$export$c4b5d6610bc5fc6e = (0, $2nPZH.defineMessages)({
    backToSpacePermissions: {
        id: "bulk-permissions.space-permissions-link",
        defaultMessage: "Space permissions"
    },
    bulkAddHeader: {
        id: "bulk-permissions.space.header",
        defaultMessage: "Add people to all spaces"
    },
    titleSubtext: {
        id: "bulk-permissions.space.title-subtext",
        defaultMessage: "Quickly add (or remove) an individual user or group to all spaces on your Confluence site. This will overwrite any existing access they have, which means it can also be a good way to change access for a user or group in all spaces."
    },
    userPickerHeader: {
        id: "bulk-permissions.space.user-picker-header",
        defaultMessage: "Choose who to add or remove<asterisk>*</asterisk>"
    },
    userPickerSubtext: {
        id: "bulk-permissions.space.user-picker-subtext",
        defaultMessage: "You may only select one for this action."
    },
    asyncSuccessFlagTitle: {
        id: "bulk-permissions.space.async.update.success-flag-title",
        defaultMessage: "Bulk permissions change processing"
    },
    asyncSuccessFlagDescription: {
        id: "bulk-permissions.space.async.update.success-flag-description",
        defaultMessage: "These changes can take a while. We\u2019ll notify you when it\u2019s finished."
    },
    errorFlagTitle: {
        id: "bulk-permissions.space.error-flag-title",
        defaultMessage: "Bulk permissions change failed"
    },
    errorFlagDescription: {
        id: "bulk-permissions.space.error-flag-description",
        defaultMessage: "We ran into a problem completing your bulk permissions change. Try again."
    },
    userPickerPlaceholder: {
        id: "bulk-permissions.space.user-picker-placeholder",
        defaultMessage: "Enter a person or group"
    },
    requirementMessage: {
        id: "bulk-permissions.space.requirement-message",
        defaultMessage: "<asterisk>* </asterisk> Required to perform action"
    },
    applyButtonTextAdd: {
        id: "bulk-permissions.space.apply-button-text-add",
        defaultMessage: "Add to all"
    },
    applyButtonTextRemove: {
        id: "bulk-permissions.space.apply-button-text-remove",
        defaultMessage: "Remove from all"
    }
});
const $eb8c51b94819be10$var$bulkAddHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingBottom: 'space.100',
    paddingTop: 'space.300'
});
const $eb8c51b94819be10$var$bulkSubtextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $eb8c51b94819be10$var$userPickerHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $eb8c51b94819be10$var$asteriskStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.red'
});
const $eb8c51b94819be10$var$userPickerFineTextStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.050',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $eb8c51b94819be10$var$contentStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.1000',
    marginRight: 'space.1000'
});
const $eb8c51b94819be10$var$backButtonStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.200',
    paddingTop: 'space.300'
});
const $eb8c51b94819be10$var$userPickerStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.050'
});
const $eb8c51b94819be10$var$requirementMessageStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingTop: 'space.300'
});
const $eb8c51b94819be10$var$getPrincipalId = (principal)=>{
    return principal?.type === 'user' ? principal?.extra?.accountId : principal?.extra?.id;
};
const $eb8c51b94819be10$export$405a6cc8f1c994c8 = (0, $7aRa9.withFlags)((0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).PERMISSIONS_EXPERIENCE
})(({ flags: flags })=>{
    const intl = (0, $dBxQj.default)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isProductAdmin: isProductAdmin, isAdminCheckLoading: isAdminCheckLoading } = (0, $1BYn9.useIsProductAdmin)();
    const [spacePermissions, setSpacePermissions] = (0, $gwFzn.useState)([
        (0, $lqf9t.SpacePermissionType).VIEW_SPACE
    ]);
    const [stagedPrincipal, setStagedPrincipal] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(undefined);
    const [spaceSelection, setSpaceSelection] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState((0, $8A6YM.SpaceSelection).AllExcludingPersonal);
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [showDialog, setShowDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(false);
    const isRemoval = !spacePermissions.includes((0, $lqf9t.SpacePermissionType).VIEW_SPACE);
    const closeDialog = (0, $gwFzn.useCallback)(()=>{
        setShowDialog(false);
    }, [
        setShowDialog
    ]);
    const setInitState = (0, $gwFzn.useCallback)(()=>{
        setStagedPrincipal(undefined);
        setSpaceSelection((0, $8A6YM.SpaceSelection).AllExcludingPersonal);
        setSpacePermissions([
            (0, $lqf9t.SpacePermissionType).VIEW_SPACE
        ]);
    }, []);
    const onMutationErrored = (0, $gwFzn.useCallback)((error)=>{
        closeDialog();
        flags.showErrorFlag({
            id: 'bulk-space-permissions.add.error',
            title: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.errorFlagTitle),
            description: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.errorFlagDescription),
            isAutoDismiss: true
        });
        experienceTracker.stopOnError({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE),
            error: error
        });
    }, [
        closeDialog,
        flags,
        intl,
        experienceTracker
    ]);
    const onAsyncMutationSubmitted = (0, $gwFzn.useCallback)((data)=>{
        closeDialog();
        /**
     * The backend is counting the mutation as a success for some exceptions
     * but returning an error in the mutation response.  We need to check for
     * these here.
     */ if (data?.bulkSetSpacePermissionAsync?.errors?.length > 0) onMutationErrored(new Error('Bulk space permissions mutation failed', data?.bulkSetSpacePermissionAsync?.errors));
        else {
            flags.showSuccessFlag({
                id: 'bulk-space-permissions.async.update.success',
                title: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.asyncSuccessFlagTitle),
                description: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.asyncSuccessFlagDescription),
                isAutoDismiss: true
            });
            experienceTracker.succeed({
                name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
            });
        }
        setInitState();
    }, [
        closeDialog,
        setInitState,
        onMutationErrored,
        flags,
        intl,
        experienceTracker
    ]);
    const getBulkSpacePermissionSubjectType = (0, $gwFzn.useCallback)(()=>{
        return stagedPrincipal?.type === 'user' ? (0, $lqf9t.BulkSetSpacePermissionSubjectType).USER : (0, $lqf9t.BulkSetSpacePermissionSubjectType).GROUP;
    }, [
        stagedPrincipal
    ]);
    const getBulkSpacePermissionSpaceType = (0, $gwFzn.useCallback)(()=>{
        switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return [
                    (0, $lqf9t.BulkSetSpacePermissionSpaceType).GLOBAL,
                    (0, $lqf9t.BulkSetSpacePermissionSpaceType).COLLABORATION,
                    (0, $lqf9t.BulkSetSpacePermissionSpaceType).KNOWLEDGE_BASE
                ];
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return [
                    (0, $lqf9t.BulkSetSpacePermissionSpaceType).PERSONAL,
                    (0, $lqf9t.BulkSetSpacePermissionSpaceType).GLOBAL,
                    (0, $lqf9t.BulkSetSpacePermissionSpaceType).COLLABORATION,
                    (0, $lqf9t.BulkSetSpacePermissionSpaceType).KNOWLEDGE_BASE
                ];
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return [
                    (0, $lqf9t.BulkSetSpacePermissionSpaceType).PERSONAL
                ];
            default:
                return [
                    null
                ];
        }
    }, [
        spaceSelection
    ]);
    const [bulkUpdateAsync, { loading: asyncLoading, error: asyncError }] = (0, $1KmJq.useMutation)($eb8c51b94819be10$var$BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation, {
        onCompleted: onAsyncMutationSubmitted,
        onError: (err)=>{
            closeDialog();
            onMutationErrored(err);
        },
        variables: {
            spacePermissions: spacePermissions,
            subjectType: getBulkSpacePermissionSubjectType(),
            subjectId: $eb8c51b94819be10$var$getPrincipalId(stagedPrincipal),
            spaceTypes: getBulkSpacePermissionSpaceType()
        }
    });
    const openDialog = (0, $gwFzn.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
        });
        setShowDialog(true);
    }, [
        setShowDialog,
        experienceTracker
    ]);
    const handleBackClick = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'defaultspaceperms',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onSpaceRadioChange = (0, $gwFzn.useCallback)((e)=>{
        setSpaceSelection(e.target.value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'radio',
                action: 'selected',
                actionSubjectId: 'bulkSpacePermissionsType',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6,
                attributes: {
                    spaceSelection: e.target.value
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onPrincipalChange = (0, $gwFzn.useCallback)((received)=>{
        // Only send an analytic event if a principal isn't deselected
        if (received) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'principal',
                action: 'selected',
                actionSubjectId: 'bulkSpacePermissionsPrincipal',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6,
                attributes: {
                    principal: received.type
                }
            }
        }).fire();
        setStagedPrincipal(received);
    }, [
        createAnalyticsEvent
    ]);
    const onDialogConfirm = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'bulkSpacePermissionsConfirm',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6
            }
        }).fire();
        bulkUpdateAsync();
    }, [
        createAnalyticsEvent,
        bulkUpdateAsync
    ]);
    const onDialogCancel = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'bulkSpacePermissionsCancel',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6
            }
        }).fire();
        closeDialog();
        experienceTracker.abort({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE),
            reason: 'User closed the dialog'
        });
    }, [
        createAnalyticsEvent,
        experienceTracker,
        closeDialog
    ]);
    // Don't render the page until we know if the user is a product admin
    // to avoid a flicker of the restricted view.
    if (isAdminCheckLoading) return null;
    if (!isProductAdmin || edition === (0, $euL71.ConfluenceEdition).FREE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eIwUX.RestrictedView), null);
    return (0, $9wGTI.fg)('confluence_rbac_spaces_beta_opt_in') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kAGh9.BulkAccessManagementPage), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, asyncError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: asyncError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$contentStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$backButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        onClick: handleBackClick,
        href: (0, $1NBp8.ADMIN_SITE_SPACE_PERMISSIONS).toUrl({
            tab: 'allspaces'
        }),
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                ...iconProps,
                size: "small"
            })
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.backToSpacePermissions))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$bulkAddHeaderStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.bulkAddHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$bulkSubtextStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.titleSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$userPickerHeaderStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $eb8c51b94819be10$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$userPickerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hpRYU.UserAndGroupSearchPicker), {
        ariaLabel: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerPlaceholder),
        "data-test-id": "user-and-group-search",
        fieldId: "bulk-permissions-user-picker",
        includeGroup: true,
        withUsers: true,
        isMulti: false,
        smart: false,
        placeholder: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerPlaceholder),
        sitePermissionTypeFilter: (0, $g3p2i.SitePermissionTypeFilter).NONE,
        // @ts-ignore - Type 'null' is not assignable to type 'string | ((input: { inputValue: string; }) => string | null)'
        // Using `ts-ignore` and not `ts-expect-error` here as TypeScript will fail on this line without `ts-ignore` but with `ts-expect-error`
        // This error was introduced after upgrading to TypeScript 5
        noOptionsMessage: null,
        onChange: (received)=>{
            // @ts-ignore - Argument of type 'Value' is not assignable to parameter of type 'OptionData | undefined'
            // Using `ts-ignore` and not `ts-expect-error` here as TypeScript will fail on this line without `ts-ignore` but with `ts-expect-error`
            // This error was introduced after upgrading to TypeScript 5
            onPrincipalChange(received);
        },
        value: stagedPrincipal || [],
        filterSearchResults: (value)=>value?.extra?.permissionType !== (0, $g3p2i.SitePermissionType).EXTERNAL
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $eb8c51b94819be10$var$userPickerFineTextStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8A6YM.SpaceSelectionRadioButtons), {
        spaceSelection: spaceSelection,
        onRadioChange: onSpaceRadioChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dWpPi.PermissionSelectionSection), {
        spacePermissions: spacePermissions,
        setSpacePermissions: setSpacePermissions
    }), isRemoval && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c09s4.RemovalWarning), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: openDialog,
        isDisabled: stagedPrincipal === undefined
    }, intl.formatMessage(isRemoval ? $eb8c51b94819be10$export$c4b5d6610bc5fc6e.applyButtonTextRemove : $eb8c51b94819be10$export$c4b5d6610bc5fc6e.applyButtonTextAdd)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        xcss: $eb8c51b94819be10$var$requirementMessageStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.requirementMessage, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $eb8c51b94819be10$var$asteriskStyle
            }, chunks)
    }))), showDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Pnx9.BulkSpacePermissionsModal), {
        principalName: stagedPrincipal?.name || '',
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        isLoading: asyncLoading,
        onConfirm: onDialogConfirm,
        onCancel: onDialogCancel
    }));
}));

});
parcelRegister("lqf9t", function(module, exports) {

$parcel$export(module.exports, "BulkSetSpacePermissionSpaceType", () => $70228f3077c41fe6$export$e57870671ec2468e);
$parcel$export(module.exports, "BulkSetSpacePermissionSubjectType", () => $70228f3077c41fe6$export$8b2051573ac4b3d5);
$parcel$export(module.exports, "SpacePermissionType", () => $70228f3077c41fe6$export$a99f5dae9c149910);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $70228f3077c41fe6$export$e57870671ec2468e = /*#__PURE__*/ function(BulkSetSpacePermissionSpaceType) {
    BulkSetSpacePermissionSpaceType["COLLABORATION"] = "COLLABORATION";
    BulkSetSpacePermissionSpaceType["GLOBAL"] = "GLOBAL";
    BulkSetSpacePermissionSpaceType["KNOWLEDGE_BASE"] = "KNOWLEDGE_BASE";
    BulkSetSpacePermissionSpaceType["PERSONAL"] = "PERSONAL";
    return BulkSetSpacePermissionSpaceType;
}({});
var $70228f3077c41fe6$export$8b2051573ac4b3d5 = /*#__PURE__*/ function(BulkSetSpacePermissionSubjectType) {
    BulkSetSpacePermissionSubjectType["GROUP"] = "GROUP";
    BulkSetSpacePermissionSubjectType["USER"] = "USER";
    return BulkSetSpacePermissionSubjectType;
}({});
var $70228f3077c41fe6$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});

});

parcelRegister("c09s4", function(module, exports) {

$parcel$export(module.exports, "RemovalWarning", () => $0d65445224ec1da1$export$ebaaa2fd42680a02);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $aoVih = parcelRequire("aoVih");

var $6f0Oj = parcelRequire("6f0Oj");
const $0d65445224ec1da1$export$ebaaa2fd42680a02 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aoVih.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: 'bulk-permissions.space.removal-warning.non-final',
        defaultMessage: '<b>Permission to view is not selected. This will remove the user or group from all spaces.</b>',
        description: 'Warning text telling the user that they are removing permissions for a user or group.',
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks)
        }
    })));

});

parcelRegister("8A6YM", function(module, exports) {

$parcel$export(module.exports, "SpaceSelection", () => $ec94e17fe3441559$export$463c90b38fc542de);
$parcel$export(module.exports, "SpaceSelectionRadioButtons", () => $ec94e17fe3441559$export$1117068039e5ec07);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $4vzBZ = parcelRequire("4vzBZ");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $kZ5GD = parcelRequire("kZ5GD");

var $dh538 = parcelRequire("dh538");

var $1qfLF = parcelRequire("1qfLF");

var $3gadb = parcelRequire("3gadb");
const $ec94e17fe3441559$var$i18n = (0, $2nPZH.defineMessages)({
    archivedSpacesTooltip: {
        id: "bulk-permissions.space.archived-spaces-tooltip",
        defaultMessage: "Archived spaces are not included in bulk permissions actions."
    },
    archivedSpacesTooltipBulkAccess: {
        id: "bulk-permissions.space.archived-spaces-tooltip-bulk-access",
        defaultMessage: "Archived spaces are not included in bulk access actions."
    },
    archivedSpacesTooltipIconLabel: {
        id: "bulk-permissions.space.archived-spaces-tooltip-icon-label",
        defaultMessage: "Archived space information"
    },
    spaceSelectionHeader: {
        id: "bulk-permissions.space.space-selection-header",
        defaultMessage: "Choose which spaces"
    },
    spaceAccessSelectionHeader: {
        id: "bulk-permissions.space.space-access-selection-header",
        defaultMessage: "On which spaces<asterisk>*</asterisk>"
    },
    spaceSelectionOne: {
        id: "bulk-permissions.space.space-selection-one",
        defaultMessage: "All (excluding personal)"
    },
    spaceSelectionTwo: {
        id: "bulk-permissions.space.space-selection-two",
        defaultMessage: "All"
    },
    spaceSelectionThree: {
        id: "bulk-permissions.space.space-selection-three",
        defaultMessage: "Only personal"
    }
});
var $ec94e17fe3441559$export$463c90b38fc542de = /*#__PURE__*/ function(SpaceSelection) {
    SpaceSelection["AllExcludingPersonal"] = "all-excluding-personal";
    SpaceSelection["AllIncludingPersonal"] = "all-including-personal";
    SpaceSelection["OnlyPersonal"] = "only-personal";
    return SpaceSelection;
}({});
const $ec94e17fe3441559$var$spaceSelectionHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $ec94e17fe3441559$var$spaceSelectionRadioButtonStyle = (0, $ecnYn.xcss)({
    marginBottom: 'space.300'
});
const $ec94e17fe3441559$var$asteriskStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.red'
});
const $ec94e17fe3441559$export$1117068039e5ec07 = ({ spaceSelection: spaceSelection, onRadioChange: onRadioChange })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        xcss: $ec94e17fe3441559$var$spaceSelectionHeaderStyle,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $ec94e17fe3441559$var$spaceSelectionHeaderStyle
    }, formatMessage((0, $dh538.fg)('confluence_rbac_spaces_beta_opt_in') ? $ec94e17fe3441559$var$i18n.spaceAccessSelectionHeader : $ec94e17fe3441559$var$i18n.spaceSelectionHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $ec94e17fe3441559$var$asteriskStyle
            }, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: (0, $dh538.fg)('confluence_rbac_spaces_beta_opt_in') ? formatMessage($ec94e17fe3441559$var$i18n.archivedSpacesTooltipBulkAccess) : formatMessage($ec94e17fe3441559$var$i18n.archivedSpacesTooltip),
        position: "right"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))), {
                    ...iconProps,
                    size: "small"
                }),
            appearance: "subtle",
            label: formatMessage($ec94e17fe3441559$var$i18n.archivedSpacesTooltipIconLabel),
            spacing: "compact",
            shape: "circle",
            ...tooltipProps
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $ec94e17fe3441559$var$spaceSelectionRadioButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kZ5GD.default), {
        value: "all-excluding-personal",
        onChange: onRadioChange,
        isChecked: spaceSelection === "all-excluding-personal",
        name: "space-selection",
        label: formatMessage($ec94e17fe3441559$var$i18n.spaceSelectionOne)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kZ5GD.default), {
        value: "all-including-personal",
        onChange: onRadioChange,
        isChecked: spaceSelection === "all-including-personal",
        name: "space-selection",
        label: formatMessage($ec94e17fe3441559$var$i18n.spaceSelectionTwo)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kZ5GD.default), {
        value: "only-personal",
        onChange: onRadioChange,
        isChecked: spaceSelection === "only-personal",
        name: "space-selection",
        label: formatMessage($ec94e17fe3441559$var$i18n.spaceSelectionThree)
    })));
};

});

parcelRegister("dWpPi", function(module, exports) {

$parcel$export(module.exports, "PermissionSelectionSection", () => $ac9ac80a1cd63f38$export$15775f46ef52c627);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $dRCYF = parcelRequire("dRCYF");
const $ac9ac80a1cd63f38$var$i18n = (0, $2nPZH.defineMessages)({
    permissionsSelectionHeader: {
        id: "bulk-permissions.space.permissions-selection-header",
        defaultMessage: "Choose space permissions"
    },
    permissionsSelectionSubtext: {
        id: "bulk-permissions.space.permissions-selection-subtext",
        defaultMessage: "Select which permissions the user or group should have in all spaces. This will overwrite any existing permissions they have. <b>This can\u2019t be undone</b> so make sure to double check who you\u2019re adding and what permissions they should have."
    },
    permissionsSelectionSubtextAdditional: {
        id: "bulk-permissions.space.permissions-selection-subtext-additional",
        defaultMessage: "To remove permissions from all spaces, uncheck the view permission."
    }
});
const $ac9ac80a1cd63f38$var$permissionSelectionHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBottom: 'space.100',
    paddingTop: 'space.300'
});
const $ac9ac80a1cd63f38$var$subtextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $ac9ac80a1cd63f38$export$15775f46ef52c627 = ({ spacePermissions: spacePermissions, setSpacePermissions: setSpacePermissions })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $ac9ac80a1cd63f38$var$permissionSelectionHeaderStyle
    }, formatMessage($ac9ac80a1cd63f38$var$i18n.permissionsSelectionHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $ac9ac80a1cd63f38$var$subtextStyle
    }, formatMessage($ac9ac80a1cd63f38$var$i18n.permissionsSelectionSubtext, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingBlockStart: "space.200"
    }, formatMessage($ac9ac80a1cd63f38$var$i18n.permissionsSelectionSubtextAdditional))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dRCYF.BulkSpacePermissionsTable), {
        spacePermissions: spacePermissions,
        setSpacePermissions: setSpacePermissions
    }));
};

});
parcelRegister("dRCYF", function(module, exports) {

$parcel$export(module.exports, "BulkSpacePermissionsTable", () => $7a1206d786c0ab1b$export$2f227e4ea23eeffd);
/* BulkSpacePermissionsTable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gEpEw = parcelRequire("gEpEw");

var $7gpC4 = parcelRequire("7gpC4");

var $inPa6 = parcelRequire("inPa6");

var $eicAg = parcelRequire("eicAg");

var $yuLaV = parcelRequire("yuLaV");

var $jhwJP = parcelRequire("jhwJP");

var $lqf9t = parcelRequire("lqf9t");

var $9TVBV = parcelRequire("9TVBV");
const $7a1206d786c0ab1b$var$groupI18nBase = (0, $2nPZH.defineMessages)({
    selectAll: {
        id: "bulk-permissions.space.table.header.group.select-all",
        defaultMessage: "Select all"
    },
    all: {
        id: "bulk-permissions.space.table.header.group.all",
        defaultMessage: "All"
    },
    pages: {
        id: "bulk-permissions.space.table.header.group.pages",
        defaultMessage: "Pages"
    },
    pagesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-embeds",
        defaultMessage: "Pages and Smart Links"
    },
    pagesWhiteboardsDatabases: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases",
        defaultMessage: "Pages, whiteboards, and databases"
    },
    pagesWhiteboardsEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-embeds",
        defaultMessage: "Pages, whiteboards, and Smart Links"
    },
    pagesDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-databases-embeds",
        defaultMessage: "Pages, databases, and Smart Links"
    },
    pagesWhiteboardsDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases-embeds",
        defaultMessage: "Pages, whiteboards, databases, and Smart Links"
    },
    blogs: {
        id: "bulk-permissions.space.table.header.group.blogs",
        defaultMessage: "Blogs"
    },
    comments: {
        id: "bulk-permissions.space.table.header.group.comments",
        defaultMessage: "Comments"
    },
    attachments: {
        id: "bulk-permissions.space.table.header.group.attachments",
        defaultMessage: "Attachments"
    },
    restrictions: {
        id: "bulk-permissions.space.table.header.group.restrictions",
        defaultMessage: "Restrictions"
    },
    mail: {
        id: "bulk-permissions.space.table.header.group.mail",
        defaultMessage: "Mail"
    },
    space: {
        id: "bulk-permissions.space.table.header.group.space",
        defaultMessage: "Space"
    }
});
const $7a1206d786c0ab1b$var$groupI18nLiveDocs = (0, $2nPZH.defineMessages)({
    pages: {
        id: "bulk-permissions.space.table.header.group.pages.livedocs",
        defaultMessage: "Pages and live docs"
    },
    pagesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-embeds.livedocs",
        defaultMessage: "Pages, live docs, and Smart Links"
    },
    pagesWhiteboardsDatabases: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases.livedocs",
        defaultMessage: "Pages, live docs, whiteboards, and databases"
    },
    pagesWhiteboardsEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-embeds.livedocs",
        defaultMessage: "Pages, live docs, whiteboards, databases, and Smart Links"
    },
    pagesDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-databases-embeds.livedocs",
        defaultMessage: "Pages, live docs, databases, and Smart Links"
    },
    pagesWhiteboardsDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases-embeds.livedocs",
        defaultMessage: "Pages, live docs, whiteboards, databases, and Smart Links"
    }
});
const $7a1206d786c0ab1b$var$groupI18n = (0, $jhwJP.mergeLiveDocI18n)($7a1206d786c0ab1b$var$groupI18nBase, $7a1206d786c0ab1b$var$groupI18nLiveDocs);
const $7a1206d786c0ab1b$var$columnI18n = (0, $2nPZH.defineMessages)({
    view: {
        id: "bulk-permissions.space.table.header.column.view",
        defaultMessage: "View"
    },
    deleteOwn: {
        id: "bulk-permissions.space.table.header.column.delete-own",
        defaultMessage: "Delete own"
    },
    add: {
        id: "bulk-permissions.space.table.header.column.Add",
        defaultMessage: "Add"
    },
    delete: {
        id: "bulk-permissions.space.table.header.column.delete",
        defaultMessage: "Delete"
    },
    archive: {
        id: "bulk-permissions.space.table.header.column.archive",
        defaultMessage: "Archive"
    },
    addDelete: {
        id: "bulk-permissions.space.table.header.column.add-delete",
        defaultMessage: "Add/Delete"
    },
    export: {
        id: "bulk-permissions.space.table.header.column.export",
        defaultMessage: "Export"
    },
    admin: {
        id: "bulk-permissions.space.table.header.column.admin",
        defaultMessage: "Admin"
    }
});
const $7a1206d786c0ab1b$var$i18n = (0, $2nPZH.defineMessages)({
    allViewTooltipContent: {
        id: "bulk-permissions.space.table.header.allViewTooltipContent",
        defaultMessage: "View permission determines who has access to the space."
    },
    allViewTooltipIconLabel: {
        id: "bulk-permissions.space.table.header.allViewTooltipIconLabel",
        defaultMessage: "Learn more about view permissions"
    },
    deleteOwnTooltipContent: {
        id: "bulk-permissions.space.table.header.deleteOwnTooltipContent",
        defaultMessage: "Lets users delete their own content and attachments. (For comments, the \u201CAdd\u201D permission includes \u201CDelete Own\u201D)"
    },
    deleteOwnTooltipIconLabel: {
        id: "bulk-permissions.space.table.header.deleteOwnTooltipIconLabel",
        defaultMessage: "Learn more about delete own"
    },
    restrictionsTooltipContent: {
        id: "bulk-permissions.space.table.header.restrictionsTooltipContent",
        defaultMessage: "Lets users add and remove restrictions directly on content. Does not affect inherited restrictions."
    },
    restrictionsTooltipIconLabel: {
        id: "bulk-permissions.space.table.header.restrictionsTooltipIconLabel",
        defaultMessage: "Restrictions Add/Delete tooltip"
    }
});
const $7a1206d786c0ab1b$var$COLUMN_KEY_SELECT_ALL = 'SELECT_ALL';
const $7a1206d786c0ab1b$var$CELL_BORDER = {
    borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7a1206d786c0ab1b$var$TableWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1reo1wug _19pkv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7a1206d786c0ab1b$var$CheckboxWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $7a1206d786c0ab1b$export$92f022c5db01744 = {
    [(0, $lqf9t.SpacePermissionType).VIEW_SPACE]: false,
    [(0, $lqf9t.SpacePermissionType).REMOVE_OWN_CONTENT]: false,
    [(0, $lqf9t.SpacePermissionType).CREATE_EDIT_PAGE]: false,
    [(0, $lqf9t.SpacePermissionType).ARCHIVE_PAGE]: false,
    [(0, $lqf9t.SpacePermissionType).REMOVE_PAGE]: false,
    [(0, $lqf9t.SpacePermissionType).EDIT_BLOG]: false,
    [(0, $lqf9t.SpacePermissionType).REMOVE_BLOG]: false,
    [(0, $lqf9t.SpacePermissionType).COMMENT]: false,
    [(0, $lqf9t.SpacePermissionType).REMOVE_COMMENT]: false,
    [(0, $lqf9t.SpacePermissionType).CREATE_ATTACHMENT]: false,
    [(0, $lqf9t.SpacePermissionType).REMOVE_ATTACHMENT]: false,
    [(0, $lqf9t.SpacePermissionType).SET_PAGE_PERMISSIONS]: false,
    [(0, $lqf9t.SpacePermissionType).EXPORT_SPACE]: false,
    [(0, $lqf9t.SpacePermissionType).ADMINISTER_SPACE]: false
};
const $7a1206d786c0ab1b$export$2f227e4ea23eeffd = ({ spacePermissions: spacePermissions, setSpacePermissions: setSpacePermissions })=>{
    const isWhiteboardsEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isSelectAllCheckbox, setSelectAllCheckbox] = (0, $gwFzn.useState)(false);
    spacePermissions.forEach((val)=>{
        $7a1206d786c0ab1b$export$92f022c5db01744[val] = true;
    });
    const [checkboxValues, setCheckboxValues] = (0, $gwFzn.useState)($7a1206d786c0ab1b$export$92f022c5db01744);
    (0, $gwFzn.useEffect)(()=>{
        Object.keys(checkboxValues).forEach((val)=>{
            checkboxValues[val] = false;
        });
        spacePermissions.forEach((val)=>{
            checkboxValues[val] = true;
        });
        setCheckboxValues(checkboxValues);
        checkSelectAllCheckbox(checkboxValues);
    }, [
        spacePermissions,
        checkboxValues
    ]);
    const getContentGroupName = (_isWhiteboardsEnabled, _isDatabasesEnabled)=>{
        if (!_isWhiteboardsEnabled && !_isDatabasesEnabled) return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesEmbeds);
        else if (_isWhiteboardsEnabled && !_isDatabasesEnabled) return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesWhiteboardsEmbeds);
        else if (!_isWhiteboardsEnabled && _isDatabasesEnabled) return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesDatabasesEmbeds);
        else return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesWhiteboardsDatabasesEmbeds);
    };
    const groupNames = {
        SELECT_ALL: formatMessage($7a1206d786c0ab1b$var$groupI18n.selectAll),
        ALL: formatMessage($7a1206d786c0ab1b$var$groupI18n.all),
        CONTENT: getContentGroupName(isWhiteboardsEnabled, isDatabasesEnabled),
        BLOGS: formatMessage($7a1206d786c0ab1b$var$groupI18n.blogs),
        COMMENTS: formatMessage($7a1206d786c0ab1b$var$groupI18n.comments),
        ATTACHMENTS: formatMessage($7a1206d786c0ab1b$var$groupI18n.attachments),
        RESTRICTIONS: formatMessage($7a1206d786c0ab1b$var$groupI18n.restrictions),
        MAIL: formatMessage($7a1206d786c0ab1b$var$groupI18n.mail),
        SPACE: formatMessage($7a1206d786c0ab1b$var$groupI18n.space)
    };
    const columnNames = {
        VIEW: formatMessage($7a1206d786c0ab1b$var$columnI18n.view),
        DELETE_OWN: formatMessage($7a1206d786c0ab1b$var$columnI18n.deleteOwn),
        ADD: formatMessage($7a1206d786c0ab1b$var$columnI18n.add),
        DELETE: formatMessage($7a1206d786c0ab1b$var$columnI18n.delete),
        ARCHIVE: formatMessage($7a1206d786c0ab1b$var$columnI18n.archive),
        ADD_DELETE: formatMessage($7a1206d786c0ab1b$var$columnI18n.addDelete),
        EXPORT: formatMessage($7a1206d786c0ab1b$var$columnI18n.export),
        ADMIN: formatMessage($7a1206d786c0ab1b$var$columnI18n.admin)
    };
    const permissionsTableHeaders = [
        {
            key: $7a1206d786c0ab1b$var$COLUMN_KEY_SELECT_ALL,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: "",
                columnName: groupNames.SELECT_ALL
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).VIEW_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ALL,
                columnName: columnNames.VIEW,
                tooltipContent: $7a1206d786c0ab1b$var$i18n.allViewTooltipContent,
                tooltipIconLabel: $7a1206d786c0ab1b$var$i18n.allViewTooltipIconLabel,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_OWN_CONTENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ALL,
                columnName: columnNames.DELETE_OWN,
                tooltipContent: $7a1206d786c0ab1b$var$i18n.deleteOwnTooltipContent,
                tooltipIconLabel: $7a1206d786c0ab1b$var$i18n.deleteOwnTooltipIconLabel
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).CREATE_EDIT_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.CONTENT,
                columnName: columnNames.ADD
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).ARCHIVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                showGroupName: true,
                groupName: groupNames.CONTENT,
                columnName: columnNames.ARCHIVE,
                centerGroupName: true,
                setWidth: true
            }),
            inlineStyles: {
                maxWidth: "var(--ds-space-1000, 80px)"
            }
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.CONTENT,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).EDIT_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.BLOGS,
                columnName: columnNames.ADD,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.BLOGS,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.COMMENTS,
                columnName: columnNames.ADD,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.COMMENTS,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).CREATE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ATTACHMENTS,
                columnName: columnNames.ADD,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ATTACHMENTS,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).SET_PAGE_PERMISSIONS,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.RESTRICTIONS,
                columnName: columnNames.ADD_DELETE,
                tooltipContent: $7a1206d786c0ab1b$var$i18n.restrictionsTooltipContent,
                tooltipIconLabel: $7a1206d786c0ab1b$var$i18n.restrictionsTooltipIconLabel,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).EXPORT_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.SPACE,
                columnName: columnNames.EXPORT,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).ADMINISTER_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.SPACE,
                columnName: columnNames.ADMIN
            })
        }
    ];
    const updateSpacePermissions = (checkboxValues)=>{
        setSpacePermissions(Object.keys(checkboxValues).filter((val)=>checkboxValues[val]));
    };
    const checkSelectAllCheckbox = (valuesObject)=>{
        if (Object.values(valuesObject).every((v)=>{
            return v;
        })) setSelectAllCheckbox(true);
        else setSelectAllCheckbox(false);
    };
    const getAriaLabel = (checkBox)=>{
        switch(checkBox){
            case (0, $lqf9t.SpacePermissionType).VIEW_SPACE:
                return `${columnNames.VIEW} ${groupNames.ALL}`;
            case (0, $lqf9t.SpacePermissionType).REMOVE_OWN_CONTENT:
                return `${columnNames.DELETE_OWN} ${groupNames.ALL}`;
            case (0, $lqf9t.SpacePermissionType).CREATE_EDIT_PAGE:
                return `${columnNames.ADD} ${groupNames.CONTENT}`;
            case (0, $lqf9t.SpacePermissionType).ARCHIVE_PAGE:
                return `${columnNames.ARCHIVE} ${groupNames.CONTENT}`;
            case (0, $lqf9t.SpacePermissionType).REMOVE_PAGE:
                return `${columnNames.DELETE} ${groupNames.CONTENT}`;
            case (0, $lqf9t.SpacePermissionType).EDIT_BLOG:
                return `${columnNames.ADD} ${groupNames.BLOGS}`;
            case (0, $lqf9t.SpacePermissionType).REMOVE_BLOG:
                return `${columnNames.DELETE} ${groupNames.BLOGS}`;
            case (0, $lqf9t.SpacePermissionType).COMMENT:
                return `${columnNames.ADD} ${groupNames.COMMENTS}`;
            case (0, $lqf9t.SpacePermissionType).REMOVE_COMMENT:
                return `${columnNames.DELETE} ${groupNames.COMMENTS}`;
            case (0, $lqf9t.SpacePermissionType).CREATE_ATTACHMENT:
                return `${columnNames.ADD} ${groupNames.ATTACHMENTS}`;
            case (0, $lqf9t.SpacePermissionType).REMOVE_ATTACHMENT:
                return `${columnNames.DELETE} ${groupNames.ATTACHMENTS}`;
            case (0, $lqf9t.SpacePermissionType).SET_PAGE_PERMISSIONS:
                return `${columnNames.ADD_DELETE} ${groupNames.RESTRICTIONS}`;
            case (0, $lqf9t.SpacePermissionType).EXPORT_SPACE:
                return `${columnNames.EXPORT} ${groupNames.SPACE}`;
            case (0, $lqf9t.SpacePermissionType).ADMINISTER_SPACE:
                return `${columnNames.ADMIN} ${groupNames.SPACE}`;
        }
    };
    const PermissionsTableCheckBox = ({ spacePermission: spacePermission })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7a1206d786c0ab1b$var$CheckboxWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7gpC4.default), {
            testId: `bulk-space-permissions-table-checkbox-${spacePermission}`,
            "aria-label": getAriaLabel(spacePermission),
            isChecked: getCheckedValue(spacePermission),
            isDisabled: spacePermission === (0, $lqf9t.SpacePermissionType).VIEW_SPACE ? false : isDisabled(),
            onChange: ()=>{
                checkboxValues[spacePermission] = !checkboxValues[spacePermission];
                setCheckboxValues(checkboxValues);
                checkSelectAllCheckbox(checkboxValues);
                updateSpacePermissions(checkboxValues);
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        actionSubject: 'checkbox',
                        action: 'clicked',
                        actionSubjectId: spacePermission,
                        source: (0, $9TVBV.ANALYTICS_SOURCE),
                        attributes: {
                            value: checkboxValues[spacePermission]
                        }
                    }
                }).fire();
            }
        }));
    };
    const handleSelectAllChange = ()=>{
        setSelectAllCheckbox(!isSelectAllCheckbox);
        Object.keys(checkboxValues).map((val)=>{
            checkboxValues[val] = !isSelectAllCheckbox;
        });
        setCheckboxValues(checkboxValues);
        updateSpacePermissions(checkboxValues);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'checkbox',
                action: 'clicked',
                actionSubjectId: 'COLUMN_KEY_SELECT_ALL',
                source: (0, $9TVBV.ANALYTICS_SOURCE),
                attributes: {
                    value: isSelectAllCheckbox
                }
            }
        }).fire();
    };
    const isDisabled = ()=>{
        return !checkboxValues[(0, $lqf9t.SpacePermissionType).VIEW_SPACE];
    };
    const getCheckedValue = (itemId)=>{
        return checkboxValues[itemId];
    };
    const checkboxes = [
        {
            key: $7a1206d786c0ab1b$var$COLUMN_KEY_SELECT_ALL,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7a1206d786c0ab1b$var$CheckboxWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7gpC4.default), {
                testId: "bulk-space-permissions-table-checkbox-SELECT_ALL",
                "aria-label": groupNames.SELECT_ALL,
                isChecked: isSelectAllCheckbox,
                isDisabled: false,
                onChange: handleSelectAllChange
            }))
        },
        {
            key: (0, $lqf9t.SpacePermissionType).VIEW_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).VIEW_SPACE
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_OWN_CONTENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).REMOVE_OWN_CONTENT
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).CREATE_EDIT_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).CREATE_EDIT_PAGE
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).ARCHIVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).ARCHIVE_PAGE
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).REMOVE_PAGE
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).EDIT_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).EDIT_BLOG
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).REMOVE_BLOG
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).COMMENT
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).REMOVE_COMMENT
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).CREATE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).CREATE_ATTACHMENT
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).REMOVE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).REMOVE_ATTACHMENT
            })
        },
        {
            key: (0, $lqf9t.SpacePermissionType).SET_PAGE_PERMISSIONS,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).SET_PAGE_PERMISSIONS
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).EXPORT_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).EXPORT_SPACE
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $lqf9t.SpacePermissionType).ADMINISTER_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $lqf9t.SpacePermissionType).ADMINISTER_SPACE
            })
        }
    ];
    const rowData = [
        checkboxValues
    ].map(()=>({
            key: `checkboxes`,
            cells: checkboxes
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7a1206d786c0ab1b$var$TableWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gEpEw.default), {
        head: {
            cells: permissionsTableHeaders
        },
        rows: rowData,
        testId: "bulk-space-permissions-table"
    }));
};

});
parcelRegister("eicAg", function(module, exports) {

$parcel$export(module.exports, "HeaderCell", () => $1734009c6c243aaa$export$efcbfab786023e1a);
/* HeaderCell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $4vzBZ = parcelRequire("4vzBZ");

var $3gadb = parcelRequire("3gadb");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $eEA8O = parcelRequire("eEA8O");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1734009c6c243aaa$var$HeaderWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { center: center, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _2lx21bp4 _1bahesu3 _1p57v77o _y3gn1h6o _1ul9xy5q _4t3i1wug",
            __cmplp.center ? "_4cvr1h6o" : "_4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$var$GroupNameWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { setWidth: setWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c81vhk _1e0c1txw _2lx21bp4 _1bah1h6o _1reoewfl _o5721q9c _1tke1u1b _y3gn1h6o _syaz1fxt",
            __cmplp.setWidth ? "_p12fglyw" : "_p12foahv",
            __cmplp.setWidth ? "_1bsb7l9q" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$var$largeGroupNameStyle = (0, $ecnYn.xcss)({
    whiteSpace: 'normal',
    wordBreak: 'keep-all'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1734009c6c243aaa$var$ColumnNameWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c81o8v _1e0c1txw _o5721q9c _syaz1gjq _1wpz1h6o",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$var$IconWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1ssb _4t3i4cqu _s7n4nkob _jq8g4cqu _14hp4cqu _irr3avxe _oq581axd",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$export$efcbfab786023e1a = ({ groupName: groupName, columnName: columnName, showGroupName: showGroupName = false, testKey: testKey, tooltipContent: tooltipContent, tooltipIconLabel: tooltipIconLabel, centerGroupName: centerGroupName = false, setMaxWidth: setMaxWidth = false, setWidth: setWidth = false })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1734009c6c243aaa$var$HeaderWrapper, {
        center: centerGroupName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1734009c6c243aaa$var$GroupNameWrapper, {
        "data-testid": testKey ? `space-table-header-${testKey}` : undefined,
        "aria-label": `${groupName}`,
        setMaxWidth: setMaxWidth,
        setWidth: setWidth
    }, showGroupName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            setWidth ? $1734009c6c243aaa$var$largeGroupNameStyle : false
        ]
    }, groupName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        "aria-label": `${groupName}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1734009c6c243aaa$var$ColumnNameWrapper, {
        key: groupName + columnName,
        "aria-label": `${columnName}`
    }, columnName, tooltipContent && tooltipIconLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), tooltipContent)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1734009c6c243aaa$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
            ...tooltipProps,
            appearance: "subtle-link",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))), {
                label: formatMessage(tooltipIconLabel),
                color: "var(--ds-icon, #44546F)",
                size: "small"
            })
        })))));
};

});



parcelRegister("eIwUX", function(module, exports) {

$parcel$export(module.exports, "RestrictedView", () => $57959768319b5632$export$b5dab984a2ed58cb);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gllul = parcelRequire("gllul");

var $j3Co0 = parcelRequire("j3Co0");

var $2VsnS = parcelRequire("2VsnS");
const $57959768319b5632$var$i18n = (0, $2nPZH.defineMessages)({
    title: {
        id: "bulk-permissions.restricted.title",
        defaultMessage: "This item is restricted"
    },
    message: {
        id: "bulk-permissions.space-settings.restricted.message",
        defaultMessage: "If you think you should have access, try asking the person who sent you here for help."
    }
});
const $57959768319b5632$export$b5dab984a2ed58cb = ()=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gllul.ErrorPageComponent), {
        errorImage: (0, (/*@__PURE__*/$parcel$interopDefault($j3Co0))),
        errorImageDark: (0, (/*@__PURE__*/$parcel$interopDefault($2VsnS))),
        errorTitle: intl.formatMessage($57959768319b5632$var$i18n.title),
        errorMessage: intl.formatMessage($57959768319b5632$var$i18n.message)
    });
};

});
parcelRegister("j3Co0", function(module, exports) {
module.exports = new URL("RestrictedContentIcon-Light.e0fef1fb.svg", import.meta.url).toString();

});

parcelRegister("2VsnS", function(module, exports) {
module.exports = new URL("RestrictedContentIcon-Dark.bc90ae31.svg", import.meta.url).toString();

});


parcelRegister("2Pnx9", function(module, exports) {

$parcel$export(module.exports, "BulkSpacePermissionsModal", () => $0e3e25b83ca7a775$export$a9b83e32db9bc573);

var $gwFzn = parcelRequire("gwFzn");

var $ekolh = parcelRequire("ekolh");
var $6xdDU = parcelRequire("6xdDU");

var $67Foi = parcelRequire("67Foi");

var $lM2MU = parcelRequire("lM2MU");

var $iPchQ = parcelRequire("iPchQ");
const $0e3e25b83ca7a775$export$a9b83e32db9bc573 = ({ principalName: principalName, isLoading: isLoading, isRemoval: isRemoval, spaceSelection: spaceSelection, onCancel: onCancel, onConfirm: onConfirm })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $67Foi.ScreenEvent), {
        name: "bulk-space-permissions-dialog",
        id: "bulk-space-permissions-dialog",
        attributes: isRemoval ? {
            action: 'remove'
        } : {
            action: 'add'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ekolh.default), {
        testId: "bulk-space-permissions-confirmation",
        onClose: // Don't allow the dialog to close while mutation is loading
        isLoading ? undefined : onCancel
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lM2MU.LoadingDialog), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iPchQ.ConfirmationDialog), {
        principalName: principalName,
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        onCancel: onCancel,
        onConfirm: onConfirm
    })));

});
parcelRegister("lM2MU", function(module, exports) {

$parcel$export(module.exports, "LoadingDialog", () => $b25698afe0cbfe9a$export$7d8626d803788e96);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $1DHa6 = parcelRequire("1DHa6");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");

var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $6UBEn = parcelRequire("6UBEn");

var $2ZJmt = parcelRequire("2ZJmt");
const $b25698afe0cbfe9a$var$i18n = (0, $2nPZH.defineMessages)({
    loadingTitle: {
        id: "bulk-permissions.space.loading-title",
        defaultMessage: "We\u2019re processing your change"
    },
    loadingDialogDescription: {
        id: "bulk-permissions.space.loading-dialog-description",
        defaultMessage: "Don\u2019t navigate away or refresh."
    }
});
const $b25698afe0cbfe9a$var$LoadingSubSectionStyle = (0, $ecnYn.xcss)({
    rowGap: 'space.300',
    paddingBottom: 'space.800'
});
const $b25698afe0cbfe9a$export$7d8626d803788e96 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9ot3w.default), {
        hasCloseButton: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b25698afe0cbfe9a$var$i18n.loadingTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $b25698afe0cbfe9a$var$LoadingSubSectionStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b25698afe0cbfe9a$var$i18n.loadingDialogDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6UBEn.default), {
        isIndeterminate: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2ZJmt.NavigationLockout), null));

});

parcelRegister("iPchQ", function(module, exports) {

$parcel$export(module.exports, "ConfirmationDialog", () => $e9f437038d263d04$export$b8704437d11c7fe7);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $eEA8O = parcelRequire("eEA8O");

var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $8A6YM = parcelRequire("8A6YM");
const $e9f437038d263d04$var$i18n = (0, $2nPZH.defineMessages)({
    addConfirmationDialogTitle: {
        id: "bulk-permissions.space.add.confirmation-dialog",
        defaultMessage: "Add {principalName} to selected spaces?"
    },
    addAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces</b> (excluding personal) on your site with the selected permissions."
    },
    addAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-all.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces</b> on your site with the selected permissions."
    },
    addAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all personal spaces</b> on your site with the selected permissions."
    },
    confirmationDialogWarning: {
        id: "bulk-permissions.space.confirmation-dialog-warning",
        defaultMessage: "<b>This can\u2019t be undone.</b>"
    },
    removeConfirmationDialogTitle: {
        id: "bulk-permissions.space.remove.confirmation-dialog",
        defaultMessage: "Remove {principalName} from selected spaces?"
    },
    removeAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> (excluding personal) on your site."
    },
    removeAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-all.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> on your site."
    },
    removeAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all personal spaces</b> on your site."
    },
    cancelButtonText: {
        id: "bulk-permissions.space.cancel-button-text",
        defaultMessage: "Cancel"
    },
    addButtonText: {
        id: "bulk-permissions.space.add-button-text",
        defaultMessage: "Add to all"
    },
    removeButtonText: {
        id: "bulk-permissions.space.remove-button-text",
        defaultMessage: "Remove from all"
    }
});
const $e9f437038d263d04$var$ConfirmatonSubSection = (0, $ecnYn.xcss)({
    paddingTop: 'space.300'
});
const $e9f437038d263d04$var$boldString = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks);
const $e9f437038d263d04$export$b8704437d11c7fe7 = ({ principalName: principalName, isRemoval: isRemoval, spaceSelection: spaceSelection, onConfirm: onConfirm, onCancel: onCancel })=>{
    const getConfirmationDialogDescription = ()=>{
        if (isRemoval) switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $e9f437038d263d04$var$i18n.removeAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $e9f437038d263d04$var$i18n.removeAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $e9f437038d263d04$var$i18n.removeAllPersonalConfirmationDialogDescription;
        }
        else switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $e9f437038d263d04$var$i18n.addAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $e9f437038d263d04$var$i18n.addAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $e9f437038d263d04$var$i18n.addAllPersonalConfirmationDialogDescription;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d8eRd.default), {
        appearance: isRemoval ? 'warning' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...isRemoval ? $e9f437038d263d04$var$i18n.removeConfirmationDialogTitle : $e9f437038d263d04$var$i18n.addConfirmationDialogTitle,
        values: {
            principalName: principalName
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...getConfirmationDialogDescription(),
        values: {
            b: $e9f437038d263d04$var$boldString
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $e9f437038d263d04$var$ConfirmatonSubSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$e9f437038d263d04$var$i18n.confirmationDialogWarning,
        values: {
            b: $e9f437038d263d04$var$boldString
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $e9f437038d263d04$var$i18n.cancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        testId: "confirmation-dialog-confirm-button",
        appearance: isRemoval ? 'warning' : 'primary',
        onClick: onConfirm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), isRemoval ? $e9f437038d263d04$var$i18n.removeButtonText : $e9f437038d263d04$var$i18n.addButtonText))));
};

});


parcelRegister("kAGh9", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $1f40f2edcedc8ce5$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "BulkAccessManagementPage", () => $1f40f2edcedc8ce5$export$db2035bfb5892b74);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $laHi9 = parcelRequire("laHi9");

var $ccHMk = parcelRequire("ccHMk");
var $7p4As = parcelRequire("7p4As");

var $inPa6 = parcelRequire("inPa6");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $1BYn9 = parcelRequire("1BYn9");

var $g3p2i = parcelRequire("g3p2i");
var $hpRYU = parcelRequire("hpRYU");

var $1NBp8 = parcelRequire("1NBp8");

var $dIouf = parcelRequire("dIouf");

var $7aRa9 = parcelRequire("7aRa9");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $c6lYi = parcelRequire("c6lYi");

var $itlCX = parcelRequire("itlCX");

var $6sX6R = parcelRequire("6sX6R");

var $8A6YM = parcelRequire("8A6YM");

var $ipM1n = parcelRequire("ipM1n");

var $b8z8O = parcelRequire("b8z8O");

var $lhYST = parcelRequire("lhYST");

var $eIwUX = parcelRequire("eIwUX");

var $9TVBV = parcelRequire("9TVBV");

var $d259h = parcelRequire("d259h");

var $i0aiC = parcelRequire("i0aiC");
const $1f40f2edcedc8ce5$export$f7109619a5e9e0d6 = 'bulkAccessManagementScreen';
const $1f40f2edcedc8ce5$var$i18n = (0, $2nPZH.defineMessages)({
    bulkRoleAccessHeader: {
        id: "bulk-permissions.space.role-access-header",
        defaultMessage: "Manage space access in bulk"
    },
    bulkRoleAccessSubtext: {
        id: "bulk-permissions.space.role-access-subtext",
        defaultMessage: "Quickly add, change, or remove access for individual users or groups across all spaces on your Confluence site. This is an all or nothing action that will overwrite any existing access."
    },
    userPickerAccessHeader: {
        id: "bulk-permissions.space.user-picker-access-header",
        defaultMessage: "Who<asterisk>*</asterisk>"
    },
    userPickerPlaceholder: {
        id: "bulk-permissions.space.user-picker-placeholder",
        defaultMessage: "Add a user, group, or user class"
    }
});
const $1f40f2edcedc8ce5$var$bulkAddRolesHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBottom: 'space.100',
    paddingTop: 'space.300'
});
const $1f40f2edcedc8ce5$var$bulkRolesSubtextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    width: '75%'
});
const $1f40f2edcedc8ce5$var$principlePickerHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $1f40f2edcedc8ce5$var$asteriskStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.red'
});
const $1f40f2edcedc8ce5$var$principlePickerFineTextStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.050',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $1f40f2edcedc8ce5$var$contentStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.1000',
    marginRight: 'space.1000',
    paddingBottom: 'space.1000'
});
const $1f40f2edcedc8ce5$var$backAndFeedbackButtonsStyle = (0, $ecnYn.xcss)({
    width: '100%',
    marginLeft: 'space.negative.200',
    paddingTop: 'space.300',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
});
const $1f40f2edcedc8ce5$var$principlePickerStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.050'
});
const $1f40f2edcedc8ce5$var$requirementTextStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingTop: 'space.300',
    paddingBottom: 'space.1000',
    marginBottom: 'space.1000'
});
const $1f40f2edcedc8ce5$export$db2035bfb5892b74 = (0, $7aRa9.withFlags)((0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).PERMISSIONS_EXPERIENCE
})(({ flags: flags })=>{
    const intl = (0, $dBxQj.default)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isProductAdmin: isProductAdmin, isAdminCheckLoading: isAdminCheckLoading } = (0, $1BYn9.useIsProductAdmin)();
    const accessClassInclusion = (0, $6sX6R.useAccessClassInclusion)();
    const [showDialog, setShowDialog] = (0, $gwFzn.useState)(false);
    const [stagedPrincipal, setStagedPrincipal] = (0, $gwFzn.useState)(undefined);
    const [spaceSelection, setSpaceSelection] = (0, $gwFzn.useState)((0, $8A6YM.SpaceSelection).AllExcludingPersonal);
    const [actionSelection, setActionSelection] = (0, $gwFzn.useState)((0, $ipM1n.ActionSelection).AddOrChangeAccess);
    const [roleAssignment, setRoleAssignment] = (0, $gwFzn.useState)(null);
    const isRemoval = actionSelection === (0, $ipM1n.ActionSelection).RemoveAccess;
    const closeDialog = (0, $gwFzn.useCallback)(()=>{
        setShowDialog(false);
    }, [
        setShowDialog
    ]);
    const { bulkSetRoleAssignmentToSpaces: bulkSetRoleAssignmentToSpaces, bulkRemoveRoleAssignment: bulkRemoveRoleAssignment } = (0, $i0aiC.useBulkRoleSetAssignment)({
        closeDialog: closeDialog,
        flags: flags
    });
    const getSpaceTypes = (targetValue)=>{
        const spaceTypesArray = [
            (0, $b8z8O.BulkRoleAssignmentSpaceType).PERSONAL,
            (0, $b8z8O.BulkRoleAssignmentSpaceType).COLLABORATION,
            (0, $b8z8O.BulkRoleAssignmentSpaceType).GLOBAL,
            (0, $b8z8O.BulkRoleAssignmentSpaceType).KNOWLEDGE_BASE
        ];
        if (targetValue === (0, $8A6YM.SpaceSelection).AllExcludingPersonal) return spaceTypesArray.filter((type)=>type !== (0, $b8z8O.BulkRoleAssignmentSpaceType).PERSONAL);
        else if (targetValue === (0, $8A6YM.SpaceSelection).AllIncludingPersonal) return spaceTypesArray;
        else if (targetValue === (0, $8A6YM.SpaceSelection).OnlyPersonal) return [
            (0, $b8z8O.BulkRoleAssignmentSpaceType).PERSONAL
        ];
    };
    const getPrincipalType = (principalType)=>{
        if (principalType === 'group') return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
        else if (principalType === 'team') return (0, $itlCX.RoleAssignmentPrincipalType).TEAM;
        else if (principalType === 'custom') return (0, $itlCX.RoleAssignmentPrincipalType).ACCESS_CLASS;
        else return (0, $itlCX.RoleAssignmentPrincipalType).USER;
    };
    const getPrincipalId = (principal)=>{
        if (principal?.type === 'custom') return principal?.id;
        else if (principal?.type === 'group') return principal?.extra?.id;
        else {
            const idx = principal?.id.indexOf('-');
            return principal?.id.slice(idx + 1);
        }
    };
    const onDialogConfirm = (0, $gwFzn.useCallback)(async ()=>{
        closeDialog();
        isRemoval ? await bulkRemoveRoleAssignment({
            variables: {
                principalId: getPrincipalId(stagedPrincipal),
                principalType: getPrincipalType(stagedPrincipal.type),
                spaceTypes: getSpaceTypes(spaceSelection)
            }
        }) : await bulkSetRoleAssignmentToSpaces({
            variables: {
                principalId: getPrincipalId(stagedPrincipal),
                principalType: getPrincipalType(stagedPrincipal.type),
                roleId: roleAssignment.id,
                spaceTypes: getSpaceTypes(spaceSelection)
            }
        });
    }, [
        closeDialog,
        isRemoval,
        bulkRemoveRoleAssignment,
        stagedPrincipal,
        spaceSelection,
        bulkSetRoleAssignmentToSpaces,
        roleAssignment
    ]);
    const handleBackToDefaultSpaceAccessClick = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'defaultspaceperms',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onSpaceTypeRadioChange = (0, $gwFzn.useCallback)((e)=>{
        setSpaceSelection(e.target.value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'radio',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagementSpace',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    spaceSelection: e.target.value,
                    isRBACEnabled: true
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onActionRadioChange = (0, $gwFzn.useCallback)((e)=>{
        setActionSelection(e.target.value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'radio',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagementAction',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    actionSelection: e.target.value,
                    isRBACEnabled: true
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    //Only passing roleId to the analytics event to avoid leaking UGC
    //Ticket to audit rest of analytics events: https://product-fabric.atlassian.net/browse/RBAC-1552
    const onRoleChange = (0, $gwFzn.useCallback)((role)=>{
        setRoleAssignment(role);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'role picker',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagement',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    roleAssignment: role.id
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onPrincipalChange = (0, $gwFzn.useCallback)((received)=>{
        // Only send an analytic event if a principal isn't deselected
        if (received) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'principal',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagementPrincipal',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    principal: received.type,
                    isRBACEnabled: true
                }
            }
        }).fire();
        setStagedPrincipal(received);
    }, [
        createAnalyticsEvent
    ]);
    const openDialog = (0, $gwFzn.useCallback)(()=>{
        setShowDialog(true);
    }, [
        setShowDialog
    ]);
    // Don't render the page until we know if the user is a product admin
    // to avoid a flicker of the restricted view.
    if (isAdminCheckLoading) return null;
    if (!isProductAdmin || edition === (0, $euL71.ConfluenceEdition).FREE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eIwUX.RestrictedView), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$contentStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$backAndFeedbackButtonsStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        onClick: handleBackToDefaultSpaceAccessClick,
        href: (0, $1NBp8.ADMIN_SITE_SPACE_PERMISSIONS).toUrl({
            tab: 'allspaces'
        }),
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                ...iconProps,
                size: "small"
            })
    }, intl.formatMessage((0, $9TVBV.i18nBulk).backToSpacePermissions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c6lYi.FeedbackCollectorButton), {
        source: "Bulk Space Roles"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$bulkAddRolesHeaderStyle
    }, intl.formatMessage($1f40f2edcedc8ce5$var$i18n.bulkRoleAccessHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$bulkRolesSubtextStyle
    }, intl.formatMessage($1f40f2edcedc8ce5$var$i18n.bulkRoleAccessSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$principlePickerHeaderStyle
    }, intl.formatMessage($1f40f2edcedc8ce5$var$i18n.userPickerAccessHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $1f40f2edcedc8ce5$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$principlePickerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hpRYU.UserAndGroupSearchPicker), {
        ariaLabel: intl.formatMessage($1f40f2edcedc8ce5$var$i18n.userPickerPlaceholder),
        "data-test-id": "user-and-group-search",
        fieldId: "bulk-permissions-user-picker",
        includeGroup: true,
        withUsers: true,
        isMulti: false,
        smart: false,
        customInclusion: accessClassInclusion,
        placeholder: intl.formatMessage($1f40f2edcedc8ce5$var$i18n.userPickerPlaceholder),
        sitePermissionTypeFilter: (0, $g3p2i.SitePermissionTypeFilter).NONE,
        // @ts-ignore - Type 'null' is not assignable to type 'string | ((input: { inputValue: string; }) => string | null)'
        // Using `ts-ignore` and not `ts-expect-error` here as TypeScript will fail on this line without `ts-ignore` but with `ts-expect-error`
        // This error was introduced after upgrading to TypeScript 5
        noOptionsMessage: null,
        onChange: (received)=>{
            // @ts-ignore - Argument of type 'Value' is not assignable to parameter of type 'OptionData | undefined'
            // Using `ts-ignore` and not `ts-expect-error` here as TypeScript will fail on this line without `ts-ignore` but with `ts-expect-error`
            // This error was introduced after upgrading to TypeScript 5
            onPrincipalChange(received);
        },
        value: stagedPrincipal || [],
        filterSearchResults: (value)=>value?.extra?.permissionType !== (0, $g3p2i.SitePermissionType).EXTERNAL
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $1f40f2edcedc8ce5$var$principlePickerFineTextStyle
    }, intl.formatMessage((0, $9TVBV.i18nBulk).userPickerSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipM1n.ActionSelectionRadioButtons), {
        actionSelection: actionSelection,
        onRadioChange: onActionRadioChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8A6YM.SpaceSelectionRadioButtons), {
        spaceSelection: spaceSelection,
        onRadioChange: onSpaceTypeRadioChange
    }), !isRemoval && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lhYST.RoleSelectionSection), {
        onRoleChange: onRoleChange,
        roleAssignment: roleAssignment
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: isRemoval ? 'danger' : 'primary',
        onClick: ()=>openDialog(),
        isDisabled: stagedPrincipal === undefined || !isRemoval && roleAssignment === null
    }, intl.formatMessage(isRemoval ? (0, $9TVBV.i18nBulk).applyButtonTextRemove : (0, $9TVBV.i18nBulk).applyButtonTextAdd)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        xcss: $1f40f2edcedc8ce5$var$requirementTextStyle
    }, intl.formatMessage((0, $9TVBV.i18nBulk).requirementMessage, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $1f40f2edcedc8ce5$var$asteriskStyle
            }, chunks)
    }))), showDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d259h.BulkAccessModal), {
        principalName: stagedPrincipal?.name || '',
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        isLoading: false,
        onConfirm: onDialogConfirm,
        onCancel: closeDialog,
        roleName: roleAssignment?.name
    }));
}));

});
parcelRegister("6sX6R", function(module, exports) {

$parcel$export(module.exports, "useAccessClassInclusion", () => $fed355c8c6dd10eb$export$3084d470555a4d72);
/** @graphql cc **/ 
var $xQxzY = parcelRequire("xQxzY");

var $d2LG0 = parcelRequire("d2LG0");

var $7Sm4c = parcelRequire("7Sm4c");

var $5ZqQS = parcelRequire("5ZqQS");

var $dIouf = parcelRequire("dIouf");

var $bQm3c = parcelRequire("bQm3c");
const $fed355c8c6dd10eb$var$useAccessClassInclusionClassesQuery = (0, $d2LG0.gql)`query useAccessClassInclusionClassesQuery($cloudId:ID!){confluence_userClasses(cloudId:$cloudId){nodes{principalId displayName}}}`;
const $fed355c8c6dd10eb$var$toLowerWithoutSpaces = (str)=>str?.toLowerCase().replace(/ /g, '');


const $fed355c8c6dd10eb$export$3084d470555a4d72 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)($fed355c8c6dd10eb$var$useAccessClassInclusionClassesQuery, {
        variables: {
            cloudId: cloudId
        },
        onError: (e)=>{
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: (0, $dIouf.Attribution).PERMISSIONS_EXPERIENCE
            });
            (0, $7Sm4c.markErrorAsHandled)(e);
        }
    });
    const allConfluenceUsers = data?.confluence_userClasses?.nodes?.find((userClass)=>userClass?.principalId === 'all-licensed-users');
    const allConfluenceAdmins = data?.confluence_userClasses?.nodes?.find((userClass)=>userClass?.principalId === 'all-product-admins');
    if (loading || error) return [];
    return [
        {
            ...allConfluenceUsers?.principalId && allConfluenceUsers?.displayName && {
                [$fed355c8c6dd10eb$var$toLowerWithoutSpaces(allConfluenceUsers.displayName)]: {
                    id: allConfluenceUsers.principalId,
                    name: allConfluenceUsers.displayName,
                    type: 'custom',
                    avatarUrl: (parcelRequire("j43jY"))
                }
            },
            ...allConfluenceAdmins?.principalId && allConfluenceAdmins?.displayName && {
                [$fed355c8c6dd10eb$var$toLowerWithoutSpaces(allConfluenceAdmins.displayName)]: {
                    id: allConfluenceAdmins.principalId,
                    name: allConfluenceAdmins.displayName,
                    type: 'custom',
                    avatarUrl: (parcelRequire("j43jY"))
                }
            }
        }
    ];
};

});
parcelRegister("j43jY", function(module, exports) {
module.exports = new URL("atlassian-icon.1175e11b.svg", import.meta.url).toString();

});


parcelRegister("ipM1n", function(module, exports) {

$parcel$export(module.exports, "ActionSelection", () => $8799edea050578d8$export$19d9f94347fa723d);
$parcel$export(module.exports, "ActionSelectionRadioButtons", () => $8799edea050578d8$export$321778e99f9fd257);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $kZ5GD = parcelRequire("kZ5GD");
const $8799edea050578d8$var$i18n = (0, $2nPZH.defineMessages)({
    actionSelectionHeader: {
        id: "bulk-permissions.space.action-selection-header",
        defaultMessage: "Action to perform<asterisk>*</asterisk>"
    },
    actionSelectionAdd: {
        id: "bulk-permissions.space.action-selection-add",
        defaultMessage: "Add or change access"
    },
    actionSelectionRemove: {
        id: "bulk-permissions.space.action-selection-remove",
        defaultMessage: "Remove access"
    }
});
var $8799edea050578d8$export$19d9f94347fa723d = /*#__PURE__*/ function(ActionSelection) {
    ActionSelection["AddOrChangeAccess"] = "add-or-change-access";
    ActionSelection["RemoveAccess"] = "remove-access";
    return ActionSelection;
}({});
const $8799edea050578d8$var$actionSelectionHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $8799edea050578d8$var$asteriskStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.red'
});
const $8799edea050578d8$export$321778e99f9fd257 = ({ actionSelection: actionSelection, onRadioChange: onRadioChange })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $8799edea050578d8$var$actionSelectionHeaderStyle,
        "data-testId": "action-selection-radio-buttons"
    }, formatMessage($8799edea050578d8$var$i18n.actionSelectionHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $8799edea050578d8$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kZ5GD.default), {
        value: "add-or-change-access",
        onChange: onRadioChange,
        isChecked: actionSelection === "add-or-change-access",
        name: "action-selection",
        label: formatMessage($8799edea050578d8$var$i18n.actionSelectionAdd)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kZ5GD.default), {
        value: "remove-access",
        onChange: onRadioChange,
        isChecked: actionSelection === "remove-access",
        name: "action-selection",
        label: formatMessage($8799edea050578d8$var$i18n.actionSelectionRemove)
    })));
};

});

parcelRegister("b8z8O", function(module, exports) {

$parcel$export(module.exports, "BulkRoleAssignmentSpaceType", () => $2fd747c2df30bd9d$export$dc2a111abcc46324);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $2fd747c2df30bd9d$export$dc2a111abcc46324 = /*#__PURE__*/ function(BulkRoleAssignmentSpaceType) {
    BulkRoleAssignmentSpaceType["COLLABORATION"] = "COLLABORATION";
    BulkRoleAssignmentSpaceType["GLOBAL"] = "GLOBAL";
    BulkRoleAssignmentSpaceType["KNOWLEDGE_BASE"] = "KNOWLEDGE_BASE";
    BulkRoleAssignmentSpaceType["PERSONAL"] = "PERSONAL";
    return BulkRoleAssignmentSpaceType;
}({});
var $2fd747c2df30bd9d$export$4e2d5448f3fd8728 = /*#__PURE__*/ function(RoleAssignmentPrincipalType) {
    RoleAssignmentPrincipalType["ACCESS_CLASS"] = "ACCESS_CLASS";
    RoleAssignmentPrincipalType["GROUP"] = "GROUP";
    RoleAssignmentPrincipalType["TEAM"] = "TEAM";
    RoleAssignmentPrincipalType["USER"] = "USER";
    return RoleAssignmentPrincipalType;
}({});

});

parcelRegister("lhYST", function(module, exports) {

$parcel$export(module.exports, "RoleSelectionSection", () => $0c8581713df69b2f$export$884fc60bd42d0abd);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $d2LG0 = parcelRequire("d2LG0");

var $xQxzY = parcelRequire("xQxzY");

var $6f0Oj = parcelRequire("6f0Oj");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $bfgIy = parcelRequire("bfgIy");

var $1kHsc = parcelRequire("1kHsc");

var $ku6MO = parcelRequire("ku6MO");

var $4zvS9 = parcelRequire("4zvS9");
const $0c8581713df69b2f$var$i18n = (0, $2nPZH.defineMessages)({
    roleSelectionHeader: {
        id: "bulk-permissions.space.role-selection-header",
        defaultMessage: "With what access<asterisk>*</asterisk>"
    },
    roleSelectionSubHeader: {
        id: "bulk-permissions.space.role-selection-sub-header",
        defaultMessage: "Choose the role they should have."
    },
    roleSelectionWarning: {
        id: "bulk-permissions.space.role-selection-warning",
        defaultMessage: "This will overwrite any existing access they have. <b>This can\u2019t be undone,</b> so make sure to double check your selections."
    },
    roleSelectLabel: {
        id: "bulk-permissions.space.role-select-label",
        defaultMessage: "Role"
    },
    roleSelectPlaceholder: {
        id: "bulk-permissions.space-role.select-placeholder",
        defaultMessage: "Select a role"
    }
});
const $0c8581713df69b2f$var$roleSelectionHeaderStyle = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 'space.100'
});
const $0c8581713df69b2f$var$asteriskStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.red'
});
const $0c8581713df69b2f$var$roleSelectionContainer = (0, $ecnYn.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.300'
});
const $0c8581713df69b2f$var$sectionContainer = (0, $ecnYn.xcss)({
    marginBottom: 'space.300'
});
const $0c8581713df69b2f$var$roleSelectInfoButtonStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    minWidth: '500px',
    alignItems: 'center'
});
const $0c8581713df69b2f$var$roleSelectStyle = (0, $ecnYn.xcss)({
    minWidth: '300px'
});
const $0c8581713df69b2f$var$roleSelectionSectionRolesQuery = (0, $d2LG0.default)`query RoleSelectionSectionRolesQuery{spaceRolesByCriteria{nodes{roleId roleDisplayName roleDescription roleType spacePermissionList{id priority displayName description requiredSpacePermissions}}}}`;
const $0c8581713df69b2f$export$884fc60bd42d0abd = ({ onRoleChange: onRoleChange, roleAssignment: roleAssignment })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [experienceStarted, setExperienceStarted] = (0, $gwFzn.useState)(false);
    //TODO: update this and add it to experience tracker once the experience is created
    const BULK_ROLES_VIEW_EXPERIENCE = 'bulk-roles-view-experience';
    const placeholder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text"
    }, formatMessage($0c8581713df69b2f$var$i18n.roleSelectPlaceholder));
    const { data: data, loading: loading } = (0, $xQxzY.useQuery)($0c8581713df69b2f$var$roleSelectionSectionRolesQuery, {
        onCompleted: ()=>{
            setExperienceStarted(false);
            experienceTracker.succeed({
                name: BULK_ROLES_VIEW_EXPERIENCE
            });
        },
        onError: (error)=>{
            experienceTracker.stopOnError({
                name: BULK_ROLES_VIEW_EXPERIENCE,
                error: error
            });
        }
    });
    const roleOptions = data?.spaceRolesByCriteria?.nodes.map((role)=>({
            id: role?.roleId || '',
            name: role?.roleDisplayName || '',
            permissions: role?.spacePermissionList.map((permission)=>permission.id) || [],
            description: role?.roleDescription || ''
        })) || [];
    (0, $gwFzn.useEffect)(()=>{
        if (loading && !experienceStarted) setExperienceStarted(true);
    }, [
        loading,
        experienceStarted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$sectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$roleSelectionHeaderStyle
    }, formatMessage($0c8581713df69b2f$var$i18n.roleSelectionHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $0c8581713df69b2f$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), null, formatMessage($0c8581713df69b2f$var$i18n.roleSelectionSubHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$roleSelectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bfgIy.Label), {
        htmlFor: "role-selector"
    }, formatMessage($0c8581713df69b2f$var$i18n.roleSelectLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$roleSelectInfoButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $0c8581713df69b2f$var$roleSelectStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ku6MO.RoleSelector), {
        value: roleAssignment?.id || null,
        onChange: onRoleChange,
        placeholder: placeholder,
        isLoading: loading,
        spaceRoleOptions: roleOptions,
        appearance: "default"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4zvS9.RoleSelectInfoButton), {
        currentRole: roleAssignment,
        roleLookup: roleOptions
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), null, formatMessage($0c8581713df69b2f$var$i18n.roleSelectionWarning, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks)
    })));
};

});
parcelRegister("ku6MO", function(module, exports) {

$parcel$export(module.exports, "RoleSelector", () => $d5c5d64568180920$export$7b32174eb7b60a13);
/* RoleSelector.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $3hOY6 = parcelRequire("3hOY6");
var $2gD2K = parcelRequire("2gD2K");

var $6f0Oj = parcelRequire("6f0Oj");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");
const $d5c5d64568180920$var$i18n = (0, $2nPZH.defineMessages)({
    noOptionsMessage: {
        id: "space-roles.role-selector.no-options.non-final",
        defaultMessage: "No roles found that are assignable from your access level"
    }
});
const $d5c5d64568180920$var$menuItemStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.050'
});
const $d5c5d64568180920$export$7b32174eb7b60a13 = ({ initialRoleId: initialRoleId, value: value, isLoading: isLoading, onChange: onChange, placeholder: placeholder, spaceRoleOptions: spaceRoleOptions, onMenuClose: onMenuClose, onMenuOpen: onMenuOpen, menuPlacement: menuPlacement = 'auto', appearance: appearance = 'subtle' })=>{
    const [internalVal, setInternalVal] = (0, $gwFzn.useState)((value === undefined ? initialRoleId : value) || null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)(); // The component is controlled if value is not `undefined`. `initialRole` will ignored in controlled mode.
    const isControlledComponent = value !== undefined;
    const options = (0, $gwFzn.useMemo)(()=>spaceRoleOptions.map((role)=>({
                id: role?.id ?? '',
                label: role?.name ?? '',
                value: role?.id ?? '',
                description: role?.description ?? ''
            })), [
        spaceRoleOptions
    ]);
    const getOptionFromValue = (0, $gwFzn.useCallback)((val)=>{
        if (!val) return null;
        return typeof val === 'string' ? options.find((option)=>option.value === val) || null : {
            id: val.value.toString(),
            label: val.label,
            value: val.value.toString(),
            description: ''
        };
    }, [
        options
    ]);
    const CustomSingleValue = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3hOY6.components).SingleValue, props, props.data.label));
    const CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3hOY6.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $d5c5d64568180920$var$menuItemStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), null, props.data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest"
        }, props.data.description))));
    const handleChange = (newSelection)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'change',
                source: 'spaceRoles-roleSelector',
                attributes: {
                    newSelection: newSelection?.id
                }
            }
        }).fire();
        setInternalVal(newSelection?.value || null);
        onChange?.(spaceRoleOptions.find((role)=>role?.id === newSelection?.value));
    };
    const handleMenuOpen = (currentRoleSelection)=>{
        onMenuOpen?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'open',
                source: 'spaceRoles-roleSelector',
                attributes: {
                    currentRoleSelection: currentRoleSelection?.id
                }
            }
        }).fire();
    };
    const SELECT_STYLE_PROPS = {
        isSearchable: false,
        styles: {
            menu: (base)=>({
                    ...base,
                    width: '320px',
                    padding: 0,
                    margin: 0
                })
        }
    };
    const selectValue = isControlledComponent ? getOptionFromValue(value) : getOptionFromValue(internalVal);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2gD2K.default), {
        "data-testid": "space-roles-table-role-selector",
        placeholder: isLoading ? '' : placeholder,
        options: options,
        appearance: appearance,
        isLoading: isLoading,
        onChange: handleChange,
        onMenuOpen: ()=>handleMenuOpen(getOptionFromValue(isControlledComponent ? value : internalVal)),
        onMenuClose: onMenuClose,
        components: {
            SingleValue: CustomSingleValue,
            Option: CustomOption
        },
        menuPosition: "fixed",
        menuPlacement: menuPlacement,
        maxMenuHeight: 320,
        scrollBehavior: "outside",
        defaultValue: getOptionFromValue(initialRoleId),
        value: selectValue,
        noOptionsMessage: ()=>formatMessage($d5c5d64568180920$var$i18n.noOptionsMessage),
        ...SELECT_STYLE_PROPS
    });
};

});

parcelRegister("4zvS9", function(module, exports) {

$parcel$export(module.exports, "RoleSelectInfoButton", () => $117ed3de9d2a23fd$export$5bafd35f9dc9151a);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");

var $cMmEA = parcelRequire("cMmEA");

var $7swbU = parcelRequire("7swbU");
const $117ed3de9d2a23fd$export$5bafd35f9dc9151a = ({ currentRole: currentRole, roleLookup: roleLookup })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $gwFzn.useState)(false);
    const onInfoButtonClick = (0, $gwFzn.useCallback)(()=>{
        setIsPopupOpen(!isPopupOpen);
    }, [
        isPopupOpen
    ]);
    const onPopupContentCtaClick = (0, $gwFzn.useCallback)(()=>{
        setIsPopupOpen(false);
    }, []);
    const popupRef = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(null);
    (0, $gwFzn.useEffect)(()=>{
        if (popupRef.current) {
            const handleClickOutside = (e)=>{
                if (popupRef.current && !popupRef.current.contains(e.target)) setIsPopupOpen(false);
            };
            document.addEventListener('click', handleClickOutside);
            return ()=>document.removeEventListener('click', handleClickOutside);
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, currentRole ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        ref: popupRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cMmEA.ViewPermissionsInfoButton), {
        "data-testid": "role-selector-info-button",
        isOpen: isPopupOpen,
        onClick: onInfoButtonClick,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7swbU.InfoPopupContent), {
            onCtaClick: onPopupContentCtaClick,
            roleId: currentRole.id,
            permissions: currentRole.permissions,
            roleLookup: roleLookup
        })
    })) : null);
};

});
parcelRegister("cMmEA", function(module, exports) {

$parcel$export(module.exports, "ViewPermissionsInfoButton", () => $710ea738a38b5734$export$1a3c335d7dca645d);

var $9wGTI = parcelRequire("9wGTI");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $lGgRw = parcelRequire("lGgRw");

var $4vzBZ = parcelRequire("4vzBZ");

var $ccHMk = parcelRequire("ccHMk");
const $710ea738a38b5734$export$1a3c335d7dca645d = ({ content: content, isOpen: isOpen, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        content: ()=>content,
        placement: "bottom",
        trigger: (triggerProps)=>// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                ...triggerProps,
                onClick: onClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
                appearance: "subtle",
                "aria-haspopup": true,
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))),
                onClick: onClick,
                "aria-label": formatMessage({
                    id: "bulk-access.role-select.info-popup",
                    defaultMessage: "View info"
                })
            }, null)),
        shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-truepermissions')
    }));
};

});

parcelRegister("7swbU", function(module, exports) {

$parcel$export(module.exports, "InfoPopupContent", () => $5e889a2aa3054314$export$90dae7b611e581b7);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $7hXDW = parcelRequire("7hXDW");

var $ccHMk = parcelRequire("ccHMk");
const $5e889a2aa3054314$var$i18n = (0, $2nPZH.defineMessages)({
    viewRolePermissionsLabel: {
        id: "bulk-permissions.info-popup.view-role-permissions-label",
        defaultMessage: "View role permissions"
    }
});
const $5e889a2aa3054314$var$contentStyle = (0, $ecnYn.xcss)({
    width: '315px',
    padding: 'space.300'
});
const $5e889a2aa3054314$var$headerStyle = (0, $ecnYn.xcss)({
    marginBottom: 'space.100'
});
const $5e889a2aa3054314$var$buttonStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.150',
    display: 'flex',
    alignItems: 'center'
});
const $5e889a2aa3054314$var$usePermissionsSummary = ({ roleId: roleId, roleLookup: roleLookup })=>{
    const role = roleLookup.find((lookup)=>lookup.id === roleId);
    // Role access
    return {
        heading: role?.name,
        description: role?.description
    };
};
const $5e889a2aa3054314$export$90dae7b611e581b7 = ({ onCtaClick: onCtaClick, roleId: roleId, roleLookup: roleLookup })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { heading: heading, description: description } = $5e889a2aa3054314$var$usePermissionsSummary({
        roleId: roleId,
        roleLookup: roleLookup
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $5e889a2aa3054314$var$contentStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $5e889a2aa3054314$var$headerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "xsmall"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        xcss: $5e889a2aa3054314$var$buttonStyle
    }, Boolean(roleId) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        onClick: onCtaClick
    }, formatMessage($5e889a2aa3054314$var$i18n.viewRolePermissionsLabel)) : null)));
};

});



parcelRegister("d259h", function(module, exports) {

$parcel$export(module.exports, "BulkAccessModal", () => $1d76093de32754c2$export$9297639d67b5de69);

var $gwFzn = parcelRequire("gwFzn");

var $ekolh = parcelRequire("ekolh");
var $6xdDU = parcelRequire("6xdDU");

var $lM2MU = parcelRequire("lM2MU");

var $etDcs = parcelRequire("etDcs");
const $1d76093de32754c2$export$9297639d67b5de69 = ({ principalName: principalName, roleName: roleName, isLoading: isLoading, isRemoval: isRemoval, spaceSelection: spaceSelection, onCancel: onCancel, onConfirm: onConfirm })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ekolh.default), {
        testId: "bulk-access-confirmation",
        onClose: // Don't allow the dialog to close while mutation is loading
        isLoading ? undefined : onCancel
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lM2MU.LoadingDialog), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $etDcs.ChangeConfirmationDialog), {
        principalName: principalName,
        roleName: roleName,
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        onCancel: onCancel,
        onConfirm: onConfirm
    })));

});
parcelRegister("etDcs", function(module, exports) {

$parcel$export(module.exports, "ChangeConfirmationDialog", () => $d771d120872e42c7$export$6daa4510cb54b507);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $eEA8O = parcelRequire("eEA8O");

var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $67Foi = parcelRequire("67Foi");

var $8A6YM = parcelRequire("8A6YM");
const $d771d120872e42c7$var$i18n = (0, $2nPZH.defineMessages)({
    addConfirmationDialogTitle: {
        id: "bulk-permissions.space.add.confirmation-dialog",
        defaultMessage: "Add {principalName} to all spaces?"
    },
    addAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces (excluding personal)</b> on your site as <b>{roleName}</b>."
    },
    addAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-all.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces</b> on your site as <b>{roleName}</b>."
    },
    addAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all personal spaces</b> on your site as <b>{roleName}</b>."
    },
    confirmationDialogWarning: {
        id: "bulk-permissions.space.confirmation-dialog-warning",
        defaultMessage: "<b>This can\u2019t be undone.</b>"
    },
    removeConfirmationDialogTitle: {
        id: "bulk-permissions.space.remove.confirmation-dialog",
        defaultMessage: "Remove {principalName} from all spaces?"
    },
    removeAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> (excluding personal) on your site."
    },
    removeAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-all.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> on your site."
    },
    removeAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all personal spaces</b> on your site."
    },
    cancelButtonText: {
        id: "bulk-permissions.space.cancel-button-text",
        defaultMessage: "Cancel"
    },
    addButtonText: {
        id: "bulk-permissions.space.add-button-text",
        defaultMessage: "Add to all"
    },
    removeButtonText: {
        id: "bulk-permissions.space.remove-button-text",
        defaultMessage: "Remove access"
    }
});
const $d771d120872e42c7$var$ConfirmatonSubSection = (0, $ecnYn.xcss)({
    paddingTop: 'space.300'
});
const $d771d120872e42c7$var$boldString = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks);
const $d771d120872e42c7$export$6daa4510cb54b507 = ({ principalName: principalName, isRemoval: isRemoval, spaceSelection: spaceSelection, roleName: roleName, onConfirm: onConfirm, onCancel: onCancel })=>{
    const getConfirmationDialogDescription = ()=>{
        if (isRemoval) switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $d771d120872e42c7$var$i18n.removeAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $d771d120872e42c7$var$i18n.removeAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $d771d120872e42c7$var$i18n.removeAllPersonalConfirmationDialogDescription;
        }
        else switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $d771d120872e42c7$var$i18n.addAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $d771d120872e42c7$var$i18n.addAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $d771d120872e42c7$var$i18n.addAllPersonalConfirmationDialogDescription;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $67Foi.ScreenEvent), {
        name: "bulk-access-dialog",
        id: "bulk-access-dialog",
        attributes: {
            action: isRemoval ? 'remove' : 'add',
            spaceType: spaceSelection
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d8eRd.default), {
        appearance: isRemoval ? 'warning' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...isRemoval ? $d771d120872e42c7$var$i18n.removeConfirmationDialogTitle : $d771d120872e42c7$var$i18n.addConfirmationDialogTitle,
        values: {
            principalName: principalName
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...getConfirmationDialogDescription(),
        values: {
            b: $d771d120872e42c7$var$boldString,
            roleName: roleName
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $d771d120872e42c7$var$ConfirmatonSubSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$d771d120872e42c7$var$i18n.confirmationDialogWarning,
        values: {
            b: $d771d120872e42c7$var$boldString
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $d771d120872e42c7$var$i18n.cancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        testId: "confirmation-dialog-confirm-button",
        appearance: isRemoval ? 'warning' : 'primary',
        onClick: onConfirm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), isRemoval ? $d771d120872e42c7$var$i18n.removeButtonText : $d771d120872e42c7$var$i18n.addButtonText))));
};

});


parcelRegister("i0aiC", function(module, exports) {

$parcel$export(module.exports, "useBulkRoleSetAssignment", () => $754fc52bc3b4de65$export$667fffd9e35f2dcd);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $1KmJq = parcelRequire("1KmJq");

var $4Kj5T = parcelRequire("4Kj5T");
const $754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation = (0, $d2LG0.default)`mutation useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation($principalId:ID!$principalType:RoleAssignmentPrincipalType!$roleId:ID!$spaceTypes:[BulkRoleAssignmentSpaceType]!){bulkSetRoleAssignmentToSpaces(input:{roleAssignment:{principal:{principalId:$principalId principalType:$principalType}roleId:$roleId}spaceTypes:$spaceTypes}){taskId success errors{message}}}`;
const $754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation = (0, $d2LG0.default)`mutation useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation($principalId:ID!$principalType:RoleAssignmentPrincipalType!$spaceTypes:[BulkRoleAssignmentSpaceType]!){bulkRemoveRoleAssignmentFromSpaces(input:{principal:{principalId:$principalId principalType:$principalType}spaceTypes:$spaceTypes}){taskId success errors{message}}}`;
const $754fc52bc3b4de65$export$667fffd9e35f2dcd = ({ closeDialog: closeDialog, flags: flags })=>{
    const { showErrorFlag: showErrorFlag, showProcessingFlag: showProcessingFlag } = (0, $4Kj5T.useBulkRoleFlags)({
        flags: flags
    });
    const onMutationErrored = (0, $gwFzn.useCallback)(()=>{
        closeDialog();
        showErrorFlag();
    }, [
        closeDialog,
        showErrorFlag
    ]);
    const onAsyncMutationSubmitted = (0, $gwFzn.useCallback)((data)=>{
        closeDialog();
        /**
     * The backend is counting the mutation as a success for some exceptions
     * but returning an error in the mutation response.  We need to check for
     * these here.
     */ if (data?.bulkSetRoleAssignmentToSpaces?.errors?.length > 0 || data?.bulkRemoveRoleAssignmentFromSpaces?.errors?.length > 0) onMutationErrored();
        else if (data.bulkSetRoleAssignmentToSpaces?.taskId || data.bulkRemoveRoleAssignmentFromSpaces?.taskId) // show the progress flag
        showProcessingFlag();
    }, [
        closeDialog,
        showProcessingFlag,
        onMutationErrored
    ]);
    const [bulkSetRoleAssignmentToSpaces, { data: bulkAssignmentData }] = (0, $1KmJq.useMutation)($754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation, {
        onCompleted: onAsyncMutationSubmitted,
        onError: ()=>{
            closeDialog();
            onMutationErrored();
        }
    });
    const [bulkRemoveRoleAssignment, { data: bulkRemoveAssignmentData }] = (0, $1KmJq.useMutation)($754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation, {
        onCompleted: onAsyncMutationSubmitted,
        onError: ()=>{
            closeDialog();
            onMutationErrored();
        }
    });
    return {
        bulkSetRoleAssignmentToSpaces: bulkSetRoleAssignmentToSpaces,
        bulkRemoveRoleAssignment: bulkRemoveRoleAssignment,
        bulkAssignmentData: bulkAssignmentData,
        bulkRemoveAssignmentData: bulkRemoveAssignmentData
    };
};

});
parcelRegister("4Kj5T", function(module, exports) {

$parcel$export(module.exports, "useBulkRoleFlags", () => $5b8a2a030512dd5e$export$4b081a83cd5f1b6f);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $9hlns = parcelRequire("9hlns");
const $5b8a2a030512dd5e$var$i18n = (0, $2nPZH.defineMessages)({
    errorIconLabel: {
        id: "bulk-permissions.flag-message.error-icon-label",
        defaultMessage: "Error"
    },
    processingFlagTitle: {
        id: "bulk-permissions.flag-message.processing",
        defaultMessage: "Bulk permissions change processing"
    },
    processingFlagContent: {
        id: "bulk-permissions.flag-message.processing-content",
        defaultMessage: "These changes can take a while. We\u2019ll notify you when it\u2019s finished."
    },
    errorFlagTitle: {
        id: "bulk-permissions.flag-message.error",
        defaultMessage: "Bulk access change failed"
    },
    errorFlagContent: {
        id: "bulk-permissions.flag-message.error-content",
        defaultMessage: "We ran into a problem completing your bulk access change. Try again."
    }
});
const $5b8a2a030512dd5e$export$4b081a83cd5f1b6f = ({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const showErrorFlag = ()=>flags.showErrorFlag({
            id: `error-${Date.now()}`,
            title: formatMessage($5b8a2a030512dd5e$var$i18n.errorFlagTitle),
            description: formatMessage($5b8a2a030512dd5e$var$i18n.errorFlagContent),
            isAutoDismiss: true
        });
    const showProcessingFlag = ()=>flags.showCustomFlag({
            id: `processing-${Date.now()}`,
            title: formatMessage($5b8a2a030512dd5e$var$i18n.processingFlagTitle),
            description: formatMessage($5b8a2a030512dd5e$var$i18n.processingFlagContent),
            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
                testId: "spinner",
                size: "small",
                label: "spinner"
            })
        });
    return {
        showErrorFlag: showErrorFlag,
        showProcessingFlag: showProcessingFlag
    };
};

});




parcelRegister("5LPzP", function(module, exports) {

let $433959a62a98158e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $433959a62a98158e$var$load("fXI14").then(()=>parcelRequire('6TPcn'));

});


parcelRegister("crxmG", function(module, exports) {

$parcel$export(module.exports, "BulkAccessManagementPage", () => $fe2917192dc4f6b9$export$db2035bfb5892b74);

var $jmjWc = parcelRequire("jmjWc");


const $fe2917192dc4f6b9$export$db2035bfb5892b74 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VMbza",
    loader: async ()=>(await Promise.resolve((parcelRequire("kAGh9")))).BulkAccessManagementPage,
    name: 'BulkAccessManagementPage'
});

});


parcelRegister("9SC9O", function(module, exports) {

$parcel$export(module.exports, "AdminTeamCalendarsRoute", () => $d1361d4d835db3f1$export$5164e66822dc5aec);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");
parcelRequire("bDjCi");
var $e8WZK = parcelRequire("e8WZK");
var $bDjCi = parcelRequire("bDjCi");
const $d1361d4d835db3f1$export$5164e66822dc5aec = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (edition !== (0, $euL71.ConfluenceEdition).PREMIUM) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bDjCi.LazyTeamCalendarSiteSettingsPage), null);
};
$d1361d4d835db3f1$export$5164e66822dc5aec.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $e8WZK.ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});
parcelRegister("bDjCi", function(module, exports) {

$parcel$export(module.exports, "LazyHomepageCard", () => $0fe83f4fb6168025$export$9bc5a864d70a9980);
$parcel$export(module.exports, "LazyTeamCalendarSiteSettingsPage", () => $0fe83f4fb6168025$export$85a8d72151ca049b);
$parcel$export(module.exports, "ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE", () => (parcelRequire("e8WZK")).ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE);

var $jmjWc = parcelRequire("jmjWc");

var $e8WZK = parcelRequire("e8WZK");

const $0fe83f4fb6168025$export$9bc5a864d70a9980 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "DHsKy",
    name: "LazyHomepageCard",
    loader: async ()=>(await (parcelRequire("kQFpi"))).HomepageCard
});

const $0fe83f4fb6168025$export$85a8d72151ca049b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sxt9o",
    name: "LazyTeamCalendarSiteSettingsPage",
    loader: async ()=>(await (parcelRequire("hYWWk"))).TeamCalendarSiteSettingsPage
});

});
parcelRegister("e8WZK", function(module, exports) {

$parcel$export(module.exports, "ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE", () => $5e4945ce4960200f$export$c0e43f82fc27fe04);
const $5e4945ce4960200f$export$c0e43f82fc27fe04 = 'adminTeamCalendars';

});

parcelRegister("kQFpi", function(module, exports) {

let $f2d8c89202987877$var$load = (parcelRequire("lhnSv"))(5);



module.exports = Promise.all([
    $f2d8c89202987877$var$load("kFF5s"),
    $f2d8c89202987877$var$load("gWoEm"),
    (parcelRequire("di5rn"))((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve("3g2Oe"), 5)),
    $f2d8c89202987877$var$load("5oU5X"),
    $f2d8c89202987877$var$load("5B8F6"),
    $f2d8c89202987877$var$load("2tDVK"),
    $f2d8c89202987877$var$load("do9PF"),
    $f2d8c89202987877$var$load("kjZZD"),
    $f2d8c89202987877$var$load("ffEVr"),
    $f2d8c89202987877$var$load("3orE4")
]).then(()=>parcelRequire('IdTEh'));

});

parcelRegister("hYWWk", function(module, exports) {

let $d175c27e423c1023$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d175c27e423c1023$var$load("5oU5X"),
    $d175c27e423c1023$var$load("9g1FS")
]).then(()=>parcelRequire('4GncZ'));

});



parcelRegister("blAko", function(module, exports) {

$parcel$export(module.exports, "AdminConfigurationRoute", () => $daea30cdb73fa105$export$9a9547459861b1d);

var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $daea30cdb73fa105$export$9a9547459861b1d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyConfigurationPage), null);
$daea30cdb73fa105$export$9a9547459861b1d.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_CONFIGURATION_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});

parcelRegister("6as7N", function(module, exports) {

$parcel$export(module.exports, "AdminDefaultSpaceLogoConfigRoute", () => $cf2a30228181ae7a$export$12cd952fb663f2a5);

var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $cf2a30228181ae7a$export$12cd952fb663f2a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyDefaultSpaceLogoConfigPage), null);
$cf2a30228181ae7a$export$12cd952fb663f2a5.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_DEFAULT_SPACE_LOGO_CONFIG_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});

parcelRegister("g1wzK", function(module, exports) {

$parcel$export(module.exports, "AdminHeaderAndFooterRoute", () => $d9d1782c5d23f713$export$66aaa3e4fa4fb446);

var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $d9d1782c5d23f713$export$66aaa3e4fa4fb446 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyHeaderAndFooterPage), null);
$d9d1782c5d23f713$export$66aaa3e4fa4fb446.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});

parcelRegister("eo6PJ", function(module, exports) {

$parcel$export(module.exports, "AdminTemplatesAndBlueprintsRoute", () => $3de5f90ca85ac387$export$fb8cddd2e05884ff);

var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $3de5f90ca85ac387$export$fb8cddd2e05884ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyTemplatesAndBlueprintsPage), null);
$3de5f90ca85ac387$export$fb8cddd2e05884ff.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});

parcelRegister("br3iV", function(module, exports) {

$parcel$export(module.exports, "AdminNotificationsRoute", () => $5035325f0c8b9a13$export$65794158c09a379);
/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $2eKSp = parcelRequire("2eKSp");
const $5035325f0c8b9a13$export$65794158c09a379 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2eKSp.LazyNotificationsSiteSettingsPageLoader), null);
$5035325f0c8b9a13$export$65794158c09a379.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $2eKSp.ADMIN_NOTIFICATIONS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});

parcelRegister("7YL3H", function(module, exports) {

$parcel$export(module.exports, "AdminSpaceReportsRoute", () => $ba2c2ff5f89f0551$export$2667c61817b129fd);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");
parcelRequire("hVdsk");
var $i6ccO = parcelRequire("i6ccO");
var $hVdsk = parcelRequire("hVdsk");
const $ba2c2ff5f89f0551$export$2667c61817b129fd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hVdsk.LazySpaceReportsSiteSettings), null);
$ba2c2ff5f89f0551$export$2667c61817b129fd.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $i6ccO.ADMIN_SPACE_REPORT_SCREEN)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});
parcelRegister("hVdsk", function(module, exports) {

$parcel$export(module.exports, "LazySpaceReportsSiteSettings", () => $13b2a397a1cc2782$export$bac0713ec898bd76);
$parcel$export(module.exports, "ADMIN_SPACE_REPORT_SCREEN", () => (parcelRequire("i6ccO")).ADMIN_SPACE_REPORT_SCREEN);

var $jmjWc = parcelRequire("jmjWc");

var $i6ccO = parcelRequire("i6ccO");

const $13b2a397a1cc2782$export$bac0713ec898bd76 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CRbee",
    name: "LazySpaceReportsSiteSettings",
    loader: async ()=>(await (parcelRequire("i8ACF"))).SpaceReports
});

});
parcelRegister("i6ccO", function(module, exports) {

$parcel$export(module.exports, "ADMIN_SPACE_REPORT_SCREEN", () => $5030b4f7b6082c77$export$40d649ebb84b67da);
const $5030b4f7b6082c77$export$40d649ebb84b67da = 'spaceReportsSiteSettings';

});

parcelRegister("i8ACF", function(module, exports) {

let $d34561d5cc1731da$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d34561d5cc1731da$var$load("dH2J7"),
    $d34561d5cc1731da$var$load("iQ0Jm"),
    $d34561d5cc1731da$var$load("ffEVr"),
    $d34561d5cc1731da$var$load("krOJz")
]).then(()=>parcelRequire('lMhQj'));

});



parcelRegister("5anXn", function(module, exports) {

$parcel$export(module.exports, "AdminCodeMacroConfigurationRoute", () => $2e9a50b174f89446$export$761483e0f415164e);

var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $2e9a50b174f89446$export$761483e0f415164e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyCodeMacroConfigurationPage), null);
$2e9a50b174f89446$export$761483e0f415164e.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});

parcelRegister("iWY3L", function(module, exports) {

$parcel$export(module.exports, "AdminColorSchemeRoute", () => $0fb617f0ce9f4007$export$8984debadcec9d93);

var $gwFzn = parcelRequire("gwFzn");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");
const $0fb617f0ce9f4007$export$8984debadcec9d93 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name
    });
$0fb617f0ce9f4007$export$8984debadcec9d93.NAVIGATION_PARAMS = ()=>false;

});

parcelRegister("fX9iO", function(module, exports) {

$parcel$export(module.exports, "AdminSecurityConfigurationRoute", () => $7fe52c8ec8c71cab$export$b882bc9c4e633e9b);

var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $7fe52c8ec8c71cab$export$b882bc9c4e633e9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazySecurityConfigurationPage), null);
$7fe52c8ec8c71cab$export$b882bc9c4e633e9b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});

parcelRegister("eeFAx", function(module, exports) {

$parcel$export(module.exports, "AdminApplicationNavigatorRoute", () => $98f73671c286928d$export$55ff18e8dde17771);

var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $98f73671c286928d$export$55ff18e8dde17771 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyApplicationNavigatorPage), null);
$98f73671c286928d$export$55ff18e8dde17771.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});

parcelRegister("gNmMt", function(module, exports) {

$parcel$export(module.exports, "AdminMacroUsageRoute", () => $2395a25321aca708$export$1e71122b3eac56e4);

var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $2395a25321aca708$export$1e71122b3eac56e4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyMacroUsagePage), null);
$2395a25321aca708$export$1e71122b3eac56e4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_MACRO_USAGE_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});

parcelRegister("a7Ld6", function(module, exports) {

$parcel$export(module.exports, "AdminTrashedSpacesRoute", () => $b9260b374d11ae03$export$154b40ed25137a69);

var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $b9260b374d11ae03$export$154b40ed25137a69 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyTrashedSpacesPage), null);
$b9260b374d11ae03$export$154b40ed25137a69.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});

parcelRegister("9IOVR", function(module, exports) {

$parcel$export(module.exports, "AdminImportSpacesRoute", () => $d9481fcbb25a62a6$export$6078cc5c61cdb00c);

var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $d9481fcbb25a62a6$export$6078cc5c61cdb00c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyImportSpacesPage), null);
$d9481fcbb25a62a6$export$6078cc5c61cdb00c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});

parcelRegister("xgs7O", function(module, exports) {

$parcel$export(module.exports, "AdminJiraMacroRepairRoute", () => $3ed31ec1d64e85a3$export$1162e5a60ee7576b);

var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $3ed31ec1d64e85a3$export$1162e5a60ee7576b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyJiraMacroRepairPage), null);
$3ed31ec1d64e85a3$export$1162e5a60ee7576b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});

parcelRegister("3rtEO", function(module, exports) {

$parcel$export(module.exports, "AdminThemesRoute", () => $95678b1264993b8d$export$cdc2bb4346e935c9);

var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $95678b1264993b8d$export$cdc2bb4346e935c9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyThemesPage), null);
$95678b1264993b8d$export$cdc2bb4346e935c9.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_THEMES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});

parcelRegister("1jVVc", function(module, exports) {

$parcel$export(module.exports, "AdminPdfExportRoute", () => $d726f64aa7b98b71$export$81e12ffb7d442c0c);

var $gwFzn = parcelRequire("gwFzn");

var $49LNg = parcelRequire("49LNg");

var $4l6Wo = parcelRequire("4l6Wo");
const $d726f64aa7b98b71$export$81e12ffb7d442c0c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyPdfExportPage), null);
$d726f64aa7b98b71$export$81e12ffb7d442c0c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_PDF_EXPORT_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});

parcelRegister("hgiBo", function(module, exports) {

$parcel$export(module.exports, "AdminWorkflowsRoute", () => $3cf65e45646e5c33$export$471cbe8a2659b8c5);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $dTQgb = parcelRequire("dTQgb");
const $3cf65e45646e5c33$export$471cbe8a2659b8c5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dTQgb.WorkflowsLoader), null);
$3cf65e45646e5c33$export$471cbe8a2659b8c5.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'workflowsAdminScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});
parcelRegister("dTQgb", function(module, exports) {

$parcel$export(module.exports, "WorkflowsLoader", () => $e47e098edb382ee6$export$5078a97f36c3dee4);

var $jmjWc = parcelRequire("jmjWc");

const $e47e098edb382ee6$export$5078a97f36c3dee4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9b7TL",
    name: "WorkflowsLoader",
    loader: async ()=>(await (parcelRequire("bHF3w"))).WorkflowAccessWrapper
});

});
parcelRegister("bHF3w", function(module, exports) {

let $88538eb04e1e7319$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $88538eb04e1e7319$var$load("joJy8"),
    $88538eb04e1e7319$var$load("aHE9G"),
    $88538eb04e1e7319$var$load("ffEVr"),
    $88538eb04e1e7319$var$load("lCdlK")
]).then(()=>parcelRequire('d2onE'));

});



parcelRegister("i9drS", function(module, exports) {

$parcel$export(module.exports, "SpaceManagerRoute", () => $244c44f585122129$export$986d179bc3f7f637);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $8Nhaa = parcelRequire("8Nhaa");
var $5rCbt = parcelRequire("5rCbt");
const $244c44f585122129$export$986d179bc3f7f637 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5rCbt.SpaceManagerLoader), null);
$244c44f585122129$export$986d179bc3f7f637.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $8Nhaa.SPACE_MANAGER_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});
parcelRegister("5rCbt", function(module, exports) {

$parcel$export(module.exports, "SpaceManagerLoader", () => $b39b3b8c8cb41baf$export$9334d2c8540310e3);

var $jmjWc = parcelRequire("jmjWc");

const $b39b3b8c8cb41baf$export$9334d2c8540310e3 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ge6Hg",
    name: "SpaceManagerLoader",
    loader: async ()=>(await (parcelRequire("4FOCn"))).SpaceManager
});

});
parcelRegister("4FOCn", function(module, exports) {

let $36724170ea6455d2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $36724170ea6455d2$var$load("1giye"),
    $36724170ea6455d2$var$load("kFF5s"),
    $36724170ea6455d2$var$load("gWoEm"),
    $36724170ea6455d2$var$load("3Zr7p"),
    $36724170ea6455d2$var$load("dH2J7"),
    $36724170ea6455d2$var$load("joJy8"),
    $36724170ea6455d2$var$load("aHE9G"),
    $36724170ea6455d2$var$load("ffEVr"),
    $36724170ea6455d2$var$load("2YlyO")
]).then(()=>parcelRequire('753aK'));

});



parcelRegister("fwL0r", function(module, exports) {

$parcel$export(module.exports, "SpaceMembersRoute", () => $f9fff28badc7670c$export$214350c926cc60f2);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $daSdG = parcelRequire("daSdG");

var $4l6Wo = parcelRequire("4l6Wo");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");
const $f9fff28badc7670c$export$214350c926cc60f2 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $9wGTI.fg)('cc_perms_exp_rbac_fe_milestone_2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $daSdG.SpaceRoleManagementScreen), {
        spaceKey: spaceKey
    });
};
$f9fff28badc7670c$export$214350c926cc60f2.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'spaceMembersScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });

});
parcelRegister("daSdG", function(module, exports) {

$parcel$export(module.exports, "SpaceRoleManagementScreen", () => $94454e5f287d76d5$export$a9d78c41686becfd);

var $jmjWc = parcelRequire("jmjWc");

const $94454e5f287d76d5$export$a9d78c41686becfd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "2UE21",
    loader: async ()=>(await (parcelRequire("lrDli"))).SpaceRoleManagementPage,
    name: 'SpaceRoleManagementPage'
});

});
parcelRegister("lrDli", function(module, exports) {

let $f9caa32b419ec088$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f9caa32b419ec088$var$load("94fpj"),
    $f9caa32b419ec088$var$load("ll4CQ"),
    $f9caa32b419ec088$var$load("1kY5y"),
    $f9caa32b419ec088$var$load("e1z0Z"),
    $f9caa32b419ec088$var$load("YlVRj"),
    $f9caa32b419ec088$var$load("dA1E5"),
    $f9caa32b419ec088$var$load("kPQBd"),
    $f9caa32b419ec088$var$load("joJy8"),
    $f9caa32b419ec088$var$load("aHE9G"),
    $f9caa32b419ec088$var$load("bU3dV"),
    $f9caa32b419ec088$var$load("ffEVr"),
    $f9caa32b419ec088$var$load("96X3r")
]).then(()=>parcelRequire('9FcLT'));

});



parcelRegister("fOd6C", function(module, exports) {

$parcel$export(module.exports, "AdminSiteSpacePermissionsRoute", () => $d3d38e453fe82603$export$6b4028c8cfa4e9e1);
/* eslint react/prop-types:0 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $d3d38e453fe82603$var$LazyDefaultSpacePermissionsPage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9HaD7",
    name: "LazyDefaultSpacePermissionsPage",
    loader: async ()=>(await (parcelRequire("2DkzK"))).DefaultSpacePermissionsPage
});
const $d3d38e453fe82603$export$6b4028c8cfa4e9e1 = (routeMatch)=>{
    const { params: { tab: tab } } = routeMatch;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d3d38e453fe82603$var$LazyDefaultSpacePermissionsPage, {
        activeTab: tab
    });
};
$d3d38e453fe82603$export$6b4028c8cfa4e9e1.NAVIGATION_PARAMS = (routeMatch)=>({
        Screen: {
            screenEvent: {
                name: 'siteSpacePermissionsScreen',
                attributes: {
                    tab: routeMatch.params.tab
                }
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});
parcelRegister("2DkzK", function(module, exports) {

let $1eaf2f303e508174$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1eaf2f303e508174$var$load("94fpj"),
    $1eaf2f303e508174$var$load("5cXIN"),
    $1eaf2f303e508174$var$load("ffEVr"),
    $1eaf2f303e508174$var$load("6gpUD")
]).then(()=>parcelRequire('dTw2J'));

});


parcelRegister("94xqy", function(module, exports) {

$parcel$export(module.exports, "RedirectToSpaceOverview", () => $09759410f0cf9b55$export$e7dd35a659f967b8);

var $gwFzn = parcelRequire("gwFzn");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");
function $09759410f0cf9b55$export$e7dd35a659f967b8({ params: { key: key, spaceKey: spaceKey }, query: query }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: key || spaceKey,
            query: query
        }
    });
}
$09759410f0cf9b55$export$e7dd35a659f967b8.NAVIGATION_PARAMS = ()=>false;

});

parcelRegister("ixCU2", function(module, exports) {

$parcel$export(module.exports, "RedirectToHomeWithQuery", () => $26b63860644dba7c$export$7bc70d297bcfbf4f);

var $gwFzn = parcelRequire("gwFzn");

var $kE2cJ = parcelRequire("kE2cJ");

var $1NBp8 = parcelRequire("1NBp8");
function $26b63860644dba7c$export$7bc70d297bcfbf4f(extra) {
    const redirectComponent = ({ query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.HOME).name,
            params: {
                query: {
                    ...query,
                    ...extra
                }
            }
        });
    redirectComponent.NAVIGATION_PARAMS = ()=>false;
    return redirectComponent;
}

});

parcelRegister("4AQPd", function(module, exports) {

$parcel$export(module.exports, "ActionRedirectLegacyRoute", () => $7cf8f51aa88b9ccf$export$df2de76576f721a1);

var $gwFzn = parcelRequire("gwFzn");

var $kE2cJ = parcelRequire("kE2cJ");

var $7Snc9 = parcelRequire("7Snc9");
const $7cf8f51aa88b9ccf$export$df2de76576f721a1 = ({ pathname: pathname, search: search, query: query })=>{
    if (query['unmatched-route']) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7Snc9.NotFound), null);
    search = search.startsWith('?') ? `${search}&unmatched-route=true` : `?unmatched-route=true`;
    return(//Redirect for .action pages that forces a full page reload
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        href: `${pathname}${search}`,
        forceReload: true
    }));
};
$7cf8f51aa88b9ccf$export$df2de76576f721a1.NAVIGATION_PARAMS = ()=>false;

});
parcelRegister("7Snc9", function(module, exports) {

$parcel$export(module.exports, "NotFound", () => $1cae7e3e681988dd$export$271f9f08425019c7);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $iJ8K8 = parcelRequire("iJ8K8");

var $5gmpn = parcelRequire("5gmpn");

var $4H46k = parcelRequire("4H46k");
function $1cae7e3e681988dd$export$271f9f08425019c7() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iJ8K8.Screen), {
        screenEvent: {
            name: 'notFoundScreen'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5gmpn.MainLayout), {
        navView: (0, $4l6Wo.PRODUCT_HOME_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyConfluenceNotFound), null)));
}

});


parcelRegister("l7qKm", function(module, exports) {

$parcel$export(module.exports, "ResumeDraftLegacyRoute", () => $0a13ad86816c36c0$export$cdc5cf7d787e5e31);

var $gwFzn = parcelRequire("gwFzn");

var $kE2cJ = parcelRequire("kE2cJ");

var $1NBp8 = parcelRequire("1NBp8");
const $0a13ad86816c36c0$export$cdc5cf7d787e5e31 = ({ pathname: pathname, search: search, query: query })=>{
    const { draftId: draftId } = query;
    if (typeof draftId !== 'string' || !/^[0-9]+$/.test(draftId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.WIKI).name
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        href: `${pathname}${search}`,
        forceReload: true
    });
};
$0a13ad86816c36c0$export$cdc5cf7d787e5e31.NAVIGATION_PARAMS = ()=>false;

});

parcelRegister("fUWTS", function(module, exports) {

$parcel$export(module.exports, "WhiteboardRoute", () => $09a888bb83dd7791$export$d584a39bdee41574);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $d73E7 = parcelRequire("d73E7");
const $09a888bb83dd7791$export$d584a39bdee41574 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d73E7.WhiteboardRouteComponentLoader), {
        spaceKey: spaceKey,
        contentId: contentId
    });
$09a888bb83dd7791$export$d584a39bdee41574.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'whiteboardScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'whiteboard',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });

});
parcelRegister("d73E7", function(module, exports) {

$parcel$export(module.exports, "WhiteboardRouteComponentLoader", () => $61e340fdd81a37ab$export$eb67fd6afe5bdfc8);

var $jmjWc = parcelRequire("jmjWc");

const $61e340fdd81a37ab$export$eb67fd6afe5bdfc8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "X7rQv",
    name: "WhiteboardRouteComponentLoader",
    loader: ()=>(parcelRequire("86LB2"))
});

});
parcelRegister("86LB2", function(module, exports) {

let $5e73cdea0462b8d9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $5e73cdea0462b8d9$var$load("6Tuw7"),
    $5e73cdea0462b8d9$var$load("1Zo7q"),
    $5e73cdea0462b8d9$var$load("eI3Gm"),
    $5e73cdea0462b8d9$var$load("i3TSs"),
    $5e73cdea0462b8d9$var$load("58UdM"),
    $5e73cdea0462b8d9$var$load("4Qstt"),
    $5e73cdea0462b8d9$var$load("5odbj"),
    $5e73cdea0462b8d9$var$load("affRy"),
    $5e73cdea0462b8d9$var$load("i5Fj1"),
    $5e73cdea0462b8d9$var$load("dH2J7"),
    $5e73cdea0462b8d9$var$load("2u53D"),
    $5e73cdea0462b8d9$var$load("dLkMK"),
    $5e73cdea0462b8d9$var$load("3hm97"),
    $5e73cdea0462b8d9$var$load("emd3r"),
    $5e73cdea0462b8d9$var$load("8NLae"),
    $5e73cdea0462b8d9$var$load("4tWDP"),
    $5e73cdea0462b8d9$var$load("ePOyH"),
    $5e73cdea0462b8d9$var$load("2F69B"),
    $5e73cdea0462b8d9$var$load("daCl8"),
    $5e73cdea0462b8d9$var$load("leIbB"),
    $5e73cdea0462b8d9$var$load("joJy8"),
    $5e73cdea0462b8d9$var$load("aHE9G"),
    $5e73cdea0462b8d9$var$load("dTsOE"),
    $5e73cdea0462b8d9$var$load("7jSfd"),
    $5e73cdea0462b8d9$var$load("4HZlX"),
    $5e73cdea0462b8d9$var$load("kDqHr"),
    $5e73cdea0462b8d9$var$load("kjZZD"),
    $5e73cdea0462b8d9$var$load("5i7Tn"),
    $5e73cdea0462b8d9$var$load("c6MKV"),
    $5e73cdea0462b8d9$var$load("ZJtkJ"),
    $5e73cdea0462b8d9$var$load("6qah4"),
    $5e73cdea0462b8d9$var$load("aZinD"),
    $5e73cdea0462b8d9$var$load("kFF5s"),
    $5e73cdea0462b8d9$var$load("gWoEm"),
    $5e73cdea0462b8d9$var$load("ffEVr"),
    $5e73cdea0462b8d9$var$load("3v5bN"),
    $5e73cdea0462b8d9$var$load("cx5X5"),
    $5e73cdea0462b8d9$var$load("7ylp3"),
    $5e73cdea0462b8d9$var$load("kIPUL"),
    $5e73cdea0462b8d9$var$load("aodp5"),
    $5e73cdea0462b8d9$var$load("6zHfc"),
    $5e73cdea0462b8d9$var$load("c0RpY"),
    $5e73cdea0462b8d9$var$load("6Z8WE"),
    $5e73cdea0462b8d9$var$load("jZkQK")
]).then(()=>parcelRequire('ib0d9'));

});



parcelRegister("eQpkq", function(module, exports) {

$parcel$export(module.exports, "SpaceJiraProjectBoardRoute", () => $b6c9bc2bdd6b7233$export$dfdc537122102d50);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $iqZzD = parcelRequire("iqZzD");

var $4H46k = parcelRequire("4H46k");
const $b6c9bc2bdd6b7233$export$dfdc537122102d50 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyJiraProjectBoard), {
        spaceKey: spaceKey
    }));
};
$b6c9bc2bdd6b7233$export$dfdc537122102d50.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'jiraProjectBoardScreen'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });

});

parcelRegister("gX83r", function(module, exports) {

$parcel$export(module.exports, "FolderViewRoute", () => $6e131d5d0e81b5af$export$110a009c083fc1fc);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $3wNc0 = parcelRequire("3wNc0");
const $6e131d5d0e81b5af$export$110a009c083fc1fc = ({ params: { contentId: contentId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3wNc0.FolderRedirectLoader), {
        contentId: contentId
    });
$6e131d5d0e81b5af$export$110a009c083fc1fc.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'folderScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'folder',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });

});
parcelRegister("3wNc0", function(module, exports) {

$parcel$export(module.exports, "FolderRedirectLoader", () => $18b64a781b16c69e$export$e1e87cd6ad2f9497);

var $jmjWc = parcelRequire("jmjWc");

const $18b64a781b16c69e$export$e1e87cd6ad2f9497 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yFgQP",
    name: "FolderRedirectLoader",
    loader: async ()=>(await (parcelRequire("dqTQx"))).FolderRedirect
});

});
parcelRegister("dqTQx", function(module, exports) {

let $9c790604783f380c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9c790604783f380c$var$load("c0RpY"),
    $9c790604783f380c$var$load("aZDAn")
]).then(()=>parcelRequire('72p3J'));

});



parcelRegister("9eYom", function(module, exports) {

$parcel$export(module.exports, "EmbedViewRoute", () => $a86e8bdaaaef979c$export$1a870b21a11af9ae);

var $gwFzn = parcelRequire("gwFzn");

var $dpPtd = parcelRequire("dpPtd");

var $f7bbm = parcelRequire("f7bbm");

var $4l6Wo = parcelRequire("4l6Wo");

var $iqZzD = parcelRequire("iqZzD");

var $4H46k = parcelRequire("4H46k");
const $a86e8bdaaaef979c$export$1a870b21a11af9ae = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f7bbm.EmbedRouteLoader), {
        contentId: contentId,
        spaceKey: spaceKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "EmbedViewRoute"
    }));
$a86e8bdaaaef979c$export$1a870b21a11af9ae.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'smartLinkEmbedPageScreen',
                id: contentId,
                attributes: {
                    contentId: contentId,
                    contentType: 'embed'
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'embed',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });

});
parcelRegister("f7bbm", function(module, exports) {

$parcel$export(module.exports, "EmbedRouteLoader", () => $1f4e11c8ff1e70c5$export$e1cd63b567cc2910);

var $jmjWc = parcelRequire("jmjWc");

const $1f4e11c8ff1e70c5$export$e1cd63b567cc2910 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LWjU2",
    name: "EmbedRouteLoader",
    loader: async ()=>(await (parcelRequire("jJvGy"))).EmbedContainer
});

});
parcelRegister("jJvGy", function(module, exports) {

let $e5dacc5484a36835$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e5dacc5484a36835$var$load("kFF5s"),
    $e5dacc5484a36835$var$load("gWoEm"),
    $e5dacc5484a36835$var$load("2HlAY"),
    $e5dacc5484a36835$var$load("jCu7l"),
    $e5dacc5484a36835$var$load("6ZETc"),
    $e5dacc5484a36835$var$load("ePOyH"),
    $e5dacc5484a36835$var$load("2F69B"),
    $e5dacc5484a36835$var$load("i73Fi"),
    $e5dacc5484a36835$var$load("4Bp5z"),
    $e5dacc5484a36835$var$load("ahCWk"),
    $e5dacc5484a36835$var$load("3GZyc"),
    $e5dacc5484a36835$var$load("avCUM"),
    $e5dacc5484a36835$var$load("aZinD"),
    $e5dacc5484a36835$var$load("c0JsV"),
    $e5dacc5484a36835$var$load("joJy8"),
    $e5dacc5484a36835$var$load("aHE9G"),
    $e5dacc5484a36835$var$load("dTsOE"),
    $e5dacc5484a36835$var$load("kjZZD"),
    $e5dacc5484a36835$var$load("ffEVr"),
    $e5dacc5484a36835$var$load("5i7Tn"),
    $e5dacc5484a36835$var$load("c6MKV"),
    $e5dacc5484a36835$var$load("c0RpY"),
    $e5dacc5484a36835$var$load("6Z8WE"),
    $e5dacc5484a36835$var$load("i0gb6"),
    $e5dacc5484a36835$var$load("g7QTt"),
    $e5dacc5484a36835$var$load("kZzff")
]).then(()=>parcelRequire('2rALa'));

});



parcelRegister("4Qsqj", function(module, exports) {

$parcel$export(module.exports, "DatabaseViewRoute", () => $b443bc65ee980e3b$export$2b633aba04c212bb);

var $gwFzn = parcelRequire("gwFzn");

var $4DKVH = parcelRequire("4DKVH");

var $4l6Wo = parcelRequire("4l6Wo");

var $bwC5h = parcelRequire("bwC5h");

var $4H46k = parcelRequire("4H46k");
const $b443bc65ee980e3b$export$2b633aba04c212bb = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bwC5h.default), {
        spaceKey: spaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4DKVH.DatabaseContainerLoader), {
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "DatabaseViewRoute"
    }));
$b443bc65ee980e3b$export$2b633aba04c212bb.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'databaseScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'database',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });

});
parcelRegister("4DKVH", function(module, exports) {

$parcel$export(module.exports, "DatabaseContainerLoader", () => $ff966974ac17a8ae$export$d5b2cc659cf7a894);

var $jmjWc = parcelRequire("jmjWc");

const $ff966974ac17a8ae$export$d5b2cc659cf7a894 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "K1tWi",
    name: "DatabaseContainerLoader",
    loader: async ()=>(await (parcelRequire("1nlaU"))).DatabaseContainer
});

});
parcelRegister("1nlaU", function(module, exports) {

let $10085d55b45a7bc5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $10085d55b45a7bc5$var$load("4tWDP"),
    $10085d55b45a7bc5$var$load("3v5bN"),
    $10085d55b45a7bc5$var$load("cx5X5"),
    $10085d55b45a7bc5$var$load("6Tuw7"),
    $10085d55b45a7bc5$var$load("1Zo7q"),
    $10085d55b45a7bc5$var$load("i3TSs"),
    $10085d55b45a7bc5$var$load("58UdM"),
    $10085d55b45a7bc5$var$load("4Qstt"),
    $10085d55b45a7bc5$var$load("5odbj"),
    $10085d55b45a7bc5$var$load("affRy"),
    $10085d55b45a7bc5$var$load("i5Fj1"),
    $10085d55b45a7bc5$var$load("dH2J7"),
    $10085d55b45a7bc5$var$load("ePOyH"),
    $10085d55b45a7bc5$var$load("2F69B"),
    $10085d55b45a7bc5$var$load("leIbB"),
    $10085d55b45a7bc5$var$load("joJy8"),
    $10085d55b45a7bc5$var$load("aHE9G"),
    $10085d55b45a7bc5$var$load("dTsOE"),
    $10085d55b45a7bc5$var$load("kjZZD"),
    $10085d55b45a7bc5$var$load("ffEVr"),
    $10085d55b45a7bc5$var$load("5i7Tn"),
    $10085d55b45a7bc5$var$load("ZJtkJ"),
    $10085d55b45a7bc5$var$load("6qah4"),
    $10085d55b45a7bc5$var$load("aZinD"),
    $10085d55b45a7bc5$var$load("aodp5"),
    $10085d55b45a7bc5$var$load("6zHfc"),
    $10085d55b45a7bc5$var$load("c0RpY"),
    $10085d55b45a7bc5$var$load("bT0I9")
]).then(()=>parcelRequire('1hCZf'));

});


parcelRegister("bwC5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $864039964f3f4398$export$2e2bcd8739ae039);

var $fppBw = parcelRequire("fppBw");

var $gwFzn = parcelRequire("gwFzn");

var $4b4iP = parcelRequire("4b4iP");
const $864039964f3f4398$var$SpaceRestriction = ({ spaceKey: spaceKey, children: children })=>{
    if (!spaceKey) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4b4iP.SpaceRestrictionHandler), {
        spaceKey: spaceKey
    }, children);
};
$864039964f3f4398$var$SpaceRestriction.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).node.isRequired
};
var $864039964f3f4398$export$2e2bcd8739ae039 = $864039964f3f4398$var$SpaceRestriction;

});


parcelRegister("8MIZj", function(module, exports) {

$parcel$export(module.exports, "SpaceIndexRoute", () => $88d3e4eaff5b722d$export$4c4704aeef10cf08);

var $gwFzn = parcelRequire("gwFzn");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");
parcelRequire("6v2ig");
var $4lJOK = parcelRequire("4lJOK");
const $88d3e4eaff5b722d$export$4c4704aeef10cf08 = (0, $4lJOK.getSpaceOverviewRoute)(({ spaceKey: spaceKey, query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: spaceKey,
            query: query
        }
    }));

});

parcelRegister("lC063", function(module, exports) {

$parcel$export(module.exports, "CreateContentRoute", () => $4da47b9dcf27590f$export$9af206dbb2b6a483);

var $gwFzn = parcelRequire("gwFzn");

var $4F5vw = parcelRequire("4F5vw");

var $eXODy = parcelRequire("eXODy");

var $4l6Wo = parcelRequire("4l6Wo");

var $iufgB = parcelRequire("iufgB");

var $5vi32 = parcelRequire("5vi32");

var $4DKVH = parcelRequire("4DKVH");

var $f7bbm = parcelRequire("f7bbm");

var $6CEg5 = parcelRequire("6CEg5");

var $d73E7 = parcelRequire("d73E7");
const $4da47b9dcf27590f$export$9af206dbb2b6a483 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iufgB.CreateContentRouteComponentLoader), {
        preloadWhiteboardRouteComponent: (0, $d73E7.WhiteboardRouteComponentLoader).preload,
        preloadDatabaseRouteComponent: (0, $4DKVH.DatabaseContainerLoader).preload,
        preloadPageAndBlogRouteComponent: (0, $4F5vw.LazyLoader).preload,
        preloadSmartLinkEmbedRouteComponent: (0, $f7bbm.EmbedRouteLoader).preload
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6CEg5.PerformanceStart), {
        subject: "PageTree",
        subjectId: "newContentRendered"
    }));
$4da47b9dcf27590f$export$9af206dbb2b6a483.NAVIGATION_PARAMS = ({ name: routeName, params: { spaceKey: spaceKey, contentType: createRouteTypeParam }, query: query })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    // spaceKey comes from query object while on creation route
    const currentSpaceKey = spaceKey || query?.spaceKey;
    const isPageLikeContent = createRouteTypeParam === 'page' || createRouteTypeParam === 'blog';
    return {
        Screen: {
            screenEvent: {
                name: 'createContentScreen'
            },
            pageState: {
                spaceKey: currentSpaceKey,
                routeName: routeName
            },
            showPremiumOnboarding: isPageLikeContent ? showPremiumOnboarding : false
        },
        MainLayout: {
            // CREATE_CONTENT route can return an undefined spaceKey during creation so we render a loading screen
            navView: query.spaceKey ? (0, $4l6Wo.CONTAINER_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_LOADING_ID),
            spaceKey: currentSpaceKey,
            editorPreloader: isPageLikeContent ? (0, $eXODy.getEditorPreloader) : undefined,
            disableMinWidth: true,
            isViewPage: true,
            isEdit: true
        }
    };
};

});
parcelRegister("4F5vw", function(module, exports) {

$parcel$export(module.exports, "LazyLoader", () => $79a774581f86de14$export$e7975a21b41d4767);

var $jmjWc = parcelRequire("jmjWc");

const $79a774581f86de14$export$e7975a21b41d4767 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "hYSgM",
    name: "LazyLoader",
    loader: ()=>(parcelRequire("eDPHu"))
});

});
parcelRegister("eDPHu", function(module, exports) {

let $aa8ccfdb2e21401e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $aa8ccfdb2e21401e$var$load("hmUGS").then(()=>parcelRequire('1azj7'));

});


parcelRegister("iufgB", function(module, exports) {

$parcel$export(module.exports, "CreateContentRouteComponentLoader", () => $ef29e49aacc3ecbc$export$80e55c7cff6cb8a);

var $jmjWc = parcelRequire("jmjWc");

const $ef29e49aacc3ecbc$export$80e55c7cff6cb8a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "IPyzb",
    name: "CreateContentRouteComponentLoader",
    loader: async ()=>(await (parcelRequire("2j7oh"))).CreateContentRouteComponentWrapper
});

});
parcelRegister("2j7oh", function(module, exports) {

let $1ae316b8335b1c24$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1ae316b8335b1c24$var$load("aodp5"),
    $1ae316b8335b1c24$var$load("6zHfc"),
    $1ae316b8335b1c24$var$load("4NgYy"),
    $1ae316b8335b1c24$var$load("16ht2"),
    $1ae316b8335b1c24$var$load("5i7Tn"),
    $1ae316b8335b1c24$var$load("c6MKV"),
    $1ae316b8335b1c24$var$load("ZJtkJ"),
    $1ae316b8335b1c24$var$load("ffEVr"),
    $1ae316b8335b1c24$var$load("6qah4"),
    $1ae316b8335b1c24$var$load("aZinD"),
    $1ae316b8335b1c24$var$load("aodrz"),
    $1ae316b8335b1c24$var$load("kFF5s"),
    $1ae316b8335b1c24$var$load("gWoEm"),
    $1ae316b8335b1c24$var$load("lzaHa"),
    $1ae316b8335b1c24$var$load("lrKPf")
]).then(()=>parcelRequire('79aVL'));

});



parcelRegister("gFtFZ", function(module, exports) {

$parcel$export(module.exports, "ViewPageOrBlogRoute", () => $7a7b7faa4141aa1d$export$51ff3cc323c1250d);

var $gwFzn = parcelRequire("gwFzn");

var $eXODy = parcelRequire("eXODy");

var $9wGTI = parcelRequire("9wGTI");

var $1NBp8 = parcelRequire("1NBp8");

var $8dwdz = parcelRequire("8dwdz");

var $5vi32 = parcelRequire("5vi32");

var $78QFu = parcelRequire("78QFu");

var $4l6Wo = parcelRequire("4l6Wo");

var $ko9Ek = parcelRequire("ko9Ek");

var $cwMOd = parcelRequire("cwMOd");
function $7a7b7faa4141aa1d$var$isLite(query) {
    return Boolean(query?.lite);
}
function $7a7b7faa4141aa1d$var$parseContentSlugFromSSR() {
    if (!(0, $9wGTI.fg)('confluence_skip_ssr_redirect_incorrect_slug')) return '';
    return window?.__SSR_RENDERED__ && window?.__DELAYED_CONTENT_REDIRECTION__?.contentSlug || '';
}
const $7a7b7faa4141aa1d$export$51ff3cc323c1250d = (props)=>{
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { name: name, params: params, query: query } = props;
    const { contentId: contentId, spaceKey: spaceKey } = params;
    const isViewPage = name === (0, $1NBp8.VIEW_PAGE).name;
    if ($7a7b7faa4141aa1d$var$isLite(query)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cwMOd.ViewPageLiteRoute), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ko9Ek.ViewPageRouteComponentLoader), {
        spaceKey: spaceKey,
        contentId: contentId,
        isMobile: isMobile,
        isPage: isViewPage,
        isEmbeddedConfluence: isEmbeddedConfluence
    }));
};
$7a7b7faa4141aa1d$export$51ff3cc323c1250d.NAVIGATION_PARAMS = ({ name: name, params: params, query: query })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    const { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } = params;
    const isViewBlog = name === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name || name === (0, $1NBp8.VIEW_BLOG).name;
    const contentType = isViewBlog ? 'blogpost' : 'page';
    if ($7a7b7faa4141aa1d$var$isLite(query)) return false;
    // Use contentSlug from SSR delayed-redirection if available
    const correctContentSlug = $7a7b7faa4141aa1d$var$parseContentSlugFromSSR() || contentSlug || '';
    return {
        Screen: {
            screenEvent: {
                name: 'viewPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: false,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                objectType: contentType,
                objectId: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: contentType,
                contentSlug: correctContentSlug
            },
            showPremiumOnboarding: showPremiumOnboarding
        },
        MainLayout: {
            navView: isViewBlog ? (0, $4l6Wo.CONTAINER_BLOG_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            editorPreloader: (0, $eXODy.getEditorPreloader),
            isViewPage: true
        }
    };
};

});
parcelRegister("cwMOd", function(module, exports) {

$parcel$export(module.exports, "ViewPageLiteRoute", () => $92d3732f6f6decb7$export$e537bc4c45dc607c);

var $gwFzn = parcelRequire("gwFzn");

var $78QFu = parcelRequire("78QFu");

var $iJ8K8 = parcelRequire("iJ8K8");

var $1NBp8 = parcelRequire("1NBp8");

var $dIouf = parcelRequire("dIouf");

var $a9BSL = parcelRequire("a9BSL");

var $6Evf5 = parcelRequire("6Evf5");

var $f5aR2 = parcelRequire("f5aR2");

var $iqZzD = parcelRequire("iqZzD");

var $4H46k = parcelRequire("4H46k");
const $92d3732f6f6decb7$export$e537bc4c45dc607c = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } })=>{
    const isPage = routeName === (0, $1NBp8.VIEW_PAGE).name;
    const isBlog = routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name || routeName === (0, $1NBp8.VIEW_BLOG).name;
    let contentType;
    // any one of VIEW_BLOG_DATE_LEGACY, VIEW_BLOG or VIEW_PAGE route can end up here from ViewPageOrBlogRoute
    if (isBlog) contentType = 'blogpost';
    else if (isPage) contentType = 'page';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iJ8K8.Screen), {
        showPremiumOnboarding: false,
        screenEvent: {
            name: 'viewPageScreen',
            id: contentId,
            attributes: {
                isPublicView: false,
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            },
            objectType: contentType,
            objectId: contentId
        },
        pageState: {
            contentId: contentId,
            spaceKey: spaceKey,
            routeName: routeName,
            contentSlug: contentSlug,
            isLite: true,
            contentType: contentType
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a9BSL.ViewPageLiteHeaderLoader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a9BSL.ViewPageLiteLoader), {
        spaceKey: spaceKey,
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6Evf5.default), {
        pageType: contentType
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "ViewPageLiteRoute"
    }));
};

});


parcelRegister("lp83g", function(module, exports) {

$parcel$export(module.exports, "TopicsRoute", () => $ad7e3274b7fede14$export$54f890efdb9a624);

var $gwFzn = parcelRequire("gwFzn");

var $iy4wp = parcelRequire("iy4wp");

var $4l6Wo = parcelRequire("4l6Wo");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");

var $9wGTI = parcelRequire("9wGTI");
const $ad7e3274b7fede14$export$54f890efdb9a624 = ({ params: { topicId: topicId } })=>{
    const topicsEnabled = (0, $9wGTI.fg)('confluence_enable_ai_topics_homepage');
    if (!topicsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iy4wp.TopicHomepage), {
        topicId: topicId
    });
};
$ad7e3274b7fede14$export$54f890efdb9a624.NAVIGATION_PARAMS = ({ params: { topicId: topicId } })=>({
        Screen: {
            screenEvent: {
                name: 'topicsScreen'
            },
            pageState: {
                topicId: topicId
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID),
            topicId: topicId
        }
    });

});
parcelRegister("iy4wp", function(module, exports) {

$parcel$export(module.exports, "TopicHomepage", () => $674c97fafa39ddaa$export$c8774699c65926c8);

var $jmjWc = parcelRequire("jmjWc");

const $674c97fafa39ddaa$export$c8774699c65926c8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "djuV7",
    name: "TopicHomepage",
    loader: async ()=>(await (parcelRequire("bYCMH"))).TopicHomepageComponent
});

});
parcelRegister("bYCMH", function(module, exports) {

let $8b836216a5a1ccbb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8b836216a5a1ccbb$var$load("kFF5s"),
    $8b836216a5a1ccbb$var$load("gWoEm"),
    $8b836216a5a1ccbb$var$load("ffEVr"),
    $8b836216a5a1ccbb$var$load("iCuQy")
]).then(()=>parcelRequire('4Shbp'));

});



parcelRegister("d7BQI", function(module, exports) {

$parcel$export(module.exports, "QuestionsRoute", () => $44ff6e33806985ff$export$384dd5b6b76557b1);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $44ff6e33806985ff$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ULKKd",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("9RZdh"))
});
const $44ff6e33806985ff$export$384dd5b6b76557b1 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($44ff6e33806985ff$var$QuestionsRouteComponent, {
        spaceKey: spaceKey
    });
};
$44ff6e33806985ff$export$384dd5b6b76557b1.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'questionsScreen'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });

});
parcelRegister("9RZdh", function(module, exports) {

let $72f88bf6f31facc1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $72f88bf6f31facc1$var$load("ckx79").then(()=>parcelRequire('eGJ8h'));

});


parcelRegister("jPkZL", function(module, exports) {

$parcel$export(module.exports, "QuestionRoute", () => $281ce5bf20714bdc$export$aea18e9fd89afe15);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $4H46k = parcelRequire("4H46k");
function $281ce5bf20714bdc$export$aea18e9fd89afe15({ params: { spaceKey: spaceKey, questionId: questionId } }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4H46k.LazyQuestions), {
        spaceKey: spaceKey,
        questionId: questionId
    });
}
$281ce5bf20714bdc$export$aea18e9fd89afe15.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, questionId: questionId } })=>({
        Screen: {
            screenEvent: {
                name: 'questionScreen',
                questionId: questionId
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });

});

parcelRegister("g2ENM", function(module, exports) {

$parcel$export(module.exports, "SiteAnalyticsRoute", () => $63dcc013c61b21bf$export$ccfda76403f5bd22);

var $gwFzn = parcelRequire("gwFzn");

var $bnIxr = parcelRequire("bnIxr");

var $4l6Wo = parcelRequire("4l6Wo");
const $63dcc013c61b21bf$export$ccfda76403f5bd22 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bnIxr.SiteAnalyticsPageLoader), null);
};
$63dcc013c61b21bf$export$ccfda76403f5bd22.NAVIGATION_PARAMS = ({ name: name, params: { tab: tab } })=>{
    return {
        Screen: {
            // screenEvent will be handled in the page components
            pageState: {
                routeName: name,
                tab: tab
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    };
};

});

parcelRegister("bNttk", function(module, exports) {

$parcel$export(module.exports, "SiteAnalyticsPermissionsRoute", () => $2dd41eaa3836b7ed$export$7ed59daacefa1324);

var $gwFzn = parcelRequire("gwFzn");

var $blHIE = parcelRequire("blHIE");

var $bnIxr = parcelRequire("bnIxr");

var $4l6Wo = parcelRequire("4l6Wo");
const $2dd41eaa3836b7ed$export$7ed59daacefa1324 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bnIxr.SitePermissionsPageLoader), null);
};
$2dd41eaa3836b7ed$export$7ed59daacefa1324.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $blHIE.SITE_ANALYTICS_PERMISSIONS_EVENTS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});

parcelRegister("4GGFl", function(module, exports) {

$parcel$export(module.exports, "PageAnalyticsRoute", () => $2ddeeae61cd450c5$export$77b30b491c5d0ee0);

var $gwFzn = parcelRequire("gwFzn");

var $bnIxr = parcelRequire("bnIxr");

var $4l6Wo = parcelRequire("4l6Wo");
const $2ddeeae61cd450c5$export$77b30b491c5d0ee0 = ({ params: { contentId: contentId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bnIxr.PageAnalyticsPageLoader), {
        contentId: contentId
    });
};
$2ddeeae61cd450c5$export$77b30b491c5d0ee0.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, contentId: contentId, tab: tab } })=>({
        Screen: {
            // screenEvent will be handled in the page components
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId,
                tab: tab
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    });

});

parcelRegister("7mgbk", function(module, exports) {

$parcel$export(module.exports, "SpaceAnalyticsRoute", () => $e76c2474e57ea114$export$af7907eff44c835f);

var $gwFzn = parcelRequire("gwFzn");

var $bnIxr = parcelRequire("bnIxr");

var $4l6Wo = parcelRequire("4l6Wo");

var $iqZzD = parcelRequire("iqZzD");
const $e76c2474e57ea114$export$af7907eff44c835f = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bnIxr.SpaceAnalyticsPageLoader), {
        spaceKey: spaceKey
    }));
};
$e76c2474e57ea114$export$af7907eff44c835f.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, tab: tab } }, isNav4Enabled)=>({
        Screen: {
            // screenEvent will be handled in the page components
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                tab: tab
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    });

});

parcelRegister("lDUJq", function(module, exports) {

$parcel$export(module.exports, "SpaceAnalyticsPermissionsRoute", () => $4a724484ea837e6c$export$703d82918dc06325);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $blHIE = parcelRequire("blHIE");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");
const $4a724484ea837e6c$export$703d82918dc06325 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
            spaceKey: spaceKey,
            tab: 'analytics'
        })
    });
$4a724484ea837e6c$export$703d82918dc06325.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: (0, $blHIE.SPACE_ANALYTICS_PERMISSIONS_EVENTS_SOURCE),
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    });

});

parcelRegister("6pqj5", function(module, exports) {

$parcel$export(module.exports, "UserAccessRoute", () => $c4bba5ee88869a52$export$45dbe3e1239d2b94);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $49LNg = parcelRequire("49LNg");
const $c4bba5ee88869a52$export$45dbe3e1239d2b94 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49LNg.LazyUserAccessPage), null);
$c4bba5ee88869a52$export$45dbe3e1239d2b94.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $49LNg.ADMIN_USER_ACCESS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    });

});

parcelRegister("jZAYF", function(module, exports) {

$parcel$export(module.exports, "WorkflowsRoute", () => $9bccec1d57ac1fa9$export$5343fffe319eadf6);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $dTQgb = parcelRequire("dTQgb");
const $9bccec1d57ac1fa9$export$5343fffe319eadf6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dTQgb.WorkflowsLoader), null);
$9bccec1d57ac1fa9$export$5343fffe319eadf6.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'workflowsScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    });

});

parcelRegister("8tCRO", function(module, exports) {

$parcel$export(module.exports, "LazyExportSpaceRoute", () => $69b9df17dc76bcc3$export$4d1bd2808cfd2f38);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $jmjWc = parcelRequire("jmjWc");

var $fppBw = parcelRequire("fppBw");

var $4l6Wo = parcelRequire("4l6Wo");

var $kE2cJ = parcelRequire("kE2cJ");

var $1NBp8 = parcelRequire("1NBp8");
const $69b9df17dc76bcc3$export$31b05ec87f8c8c11 = 'confluence-fe-space-settings-enable-afm-pdf';

const $69b9df17dc76bcc3$var$LazyExportSpaceRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EoQbw",
    name: "LazyExportSpaceRouteComponent",
    loader: async ()=>(await (parcelRequire("5yf3x"))).ExportSpaceRouteComponent
});
const $69b9df17dc76bcc3$export$4d1bd2808cfd2f38 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $dh538.fg)($69b9df17dc76bcc3$export$31b05ec87f8c8c11)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.LEGACY_SPACE_PDF_EXPORT).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($69b9df17dc76bcc3$var$LazyExportSpaceRouteComponent, {
        spaceKey: spaceKey
    });
};
$69b9df17dc76bcc3$export$4d1bd2808cfd2f38.propTypes = {
    params: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).shape({
        spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired
    }).isRequired
};
$69b9df17dc76bcc3$export$4d1bd2808cfd2f38.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } }, isNav4Enabled)=>({
        Screen: {
            screenEvent: {
                name: 'ExportSpaceScreen'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: isNav4Enabled ? (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID) : (0, $4l6Wo.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });

});
parcelRegister("5yf3x", function(module, exports) {

let $40abce921cbeb38e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $40abce921cbeb38e$var$load("kbzD1").then(()=>parcelRequire('aFOyu'));

});


parcelRegister("b4Fyf", function(module, exports) {

$parcel$export(module.exports, "GlobalQuestionsRoute", () => $8e1d38472579226f$export$6cff3d6e80ecc64);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $8e1d38472579226f$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yT4rd",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("9RZdh"))
});
const $8e1d38472579226f$export$6cff3d6e80ecc64 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8e1d38472579226f$var$QuestionsRouteComponent, {
        isGlobalPage: true
    });
};
$8e1d38472579226f$export$6cff3d6e80ecc64.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'globalQuestionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    });

});

parcelRegister("2Kk8c", function(module, exports) {

$parcel$export(module.exports, "GlobalQuestionRoute", () => $a488bad1e68dd6a7$export$5c0c86e79c0609bd);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $jmjWc = parcelRequire("jmjWc");

const $a488bad1e68dd6a7$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "6VNHf",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("9RZdh"))
});
const $a488bad1e68dd6a7$export$5c0c86e79c0609bd = ({ params: { questionId: questionId, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($a488bad1e68dd6a7$var$QuestionsRouteComponent, {
        questionId: questionId,
        isGlobalPage: true,
        spaceKey: spaceKey
    });
};
$a488bad1e68dd6a7$export$5c0c86e79c0609bd.NAVIGATION_PARAMS = ({ params: { questionId: questionId } })=>({
        Screen: {
            screenEvent: {
                name: 'globalQuestionScreen',
                questionId: questionId
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.PRODUCT_HOME_ID)
        }
    });

});

parcelRegister("8YXSL", function(module, exports) {

$parcel$export(module.exports, "SmartCreateRoute", () => $f6f49145b6f2d1ff$export$70efe747345ffd1f);

var $gwFzn = parcelRequire("gwFzn");

var $4o0Kp = parcelRequire("4o0Kp");

var $4l6Wo = parcelRequire("4l6Wo");

var $9wGTI = parcelRequire("9wGTI");
const $f6f49145b6f2d1ff$export$70efe747345ffd1f = (routeMatch)=>{
    if (!(0, $9wGTI.fg)('confluence_ai_create_menu_item')) return;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4o0Kp.SmartCreatePromptLoader), {
        spaceKey: routeMatch?.query?.spaceKey || ''
    });
};
$f6f49145b6f2d1ff$export$70efe747345ffd1f.NAVIGATION_PARAMS = (routeMatch)=>{
    const spaceKey = routeMatch?.query?.spaceKey ?? '';
    return {
        Screen: {
            screenEvent: {
                name: 'smartCreatePromptScreen'
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: routeMatch.name
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    };
};

});
parcelRegister("4o0Kp", function(module, exports) {

$parcel$export(module.exports, "SmartCreatePromptLoader", () => $bbdc62a401f33c5d$export$2135677046c2be56);

var $jmjWc = parcelRequire("jmjWc");

const $bbdc62a401f33c5d$export$2135677046c2be56 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "M3kPP",
    name: 'SmartCreatePromptLoader',
    loader: async ()=>(await (parcelRequire("2GRL8"))).SmartCreatePrompt
});

});
parcelRegister("2GRL8", function(module, exports) {

let $1f59347e840956de$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1f59347e840956de$var$load("4tWDP"),
    $1f59347e840956de$var$load("7vwsA"),
    $1f59347e840956de$var$load("aodp5"),
    $1f59347e840956de$var$load("6zHfc"),
    $1f59347e840956de$var$load("emd3r"),
    $1f59347e840956de$var$load("joJy8"),
    $1f59347e840956de$var$load("aHE9G"),
    $1f59347e840956de$var$load("dTsOE"),
    $1f59347e840956de$var$load("7jSfd"),
    $1f59347e840956de$var$load("4HZlX"),
    $1f59347e840956de$var$load("kDqHr"),
    $1f59347e840956de$var$load("kjZZD"),
    $1f59347e840956de$var$load("5i7Tn"),
    $1f59347e840956de$var$load("c6MKV"),
    $1f59347e840956de$var$load("ZJtkJ"),
    $1f59347e840956de$var$load("6qah4"),
    $1f59347e840956de$var$load("aZinD"),
    $1f59347e840956de$var$load("kFF5s"),
    $1f59347e840956de$var$load("gWoEm"),
    $1f59347e840956de$var$load("ffEVr"),
    $1f59347e840956de$var$load("iPz8n"),
    $1f59347e840956de$var$load("6Z8WE"),
    $1f59347e840956de$var$load("6NuFa")
]).then(()=>parcelRequire('ftgYc'));

});



parcelRegister("5aYM8", function(module, exports) {

$parcel$export(module.exports, "PremiumAdminFeaturesRoute", () => $d159621a32e8ccb1$export$400e9e9431ca8a0);

var $gwFzn = parcelRequire("gwFzn");

var $4l6Wo = parcelRequire("4l6Wo");

var $4eSZU = parcelRequire("4eSZU");

var $bQm3c = parcelRequire("bQm3c");
const $d159621a32e8ccb1$export$400e9e9431ca8a0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4eSZU.PremiumAdminFeaturesPageLoader), null);
$d159621a32e8ccb1$export$400e9e9431ca8a0.NAVIGATION_PARAMS = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return {
        Screen: {
            screenEvent: {
                name: 'premiumAdminFeaturesScreen',
                attributes: {
                    edition: edition
                }
            }
        },
        MainLayout: {
            navView: (0, $4l6Wo.ADMIN_HOME_ID)
        }
    };
};

});
parcelRegister("4eSZU", function(module, exports) {

$parcel$export(module.exports, "PremiumAdminFeaturesPageLoader", () => $9ab50fb164cbfbde$export$dd9490b68a84a0bc);

var $jmjWc = parcelRequire("jmjWc");

const $9ab50fb164cbfbde$export$dd9490b68a84a0bc = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "nwZgf",
    name: "PremiumAdminFeaturesPageLoader",
    loader: async ()=>(await (parcelRequire("eApxh"))).PremiumAdminFeaturesPage
});

});
parcelRegister("eApxh", function(module, exports) {

let $a9e83c56bccb1fb3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a9e83c56bccb1fb3$var$load("7niKq").then(()=>parcelRequire('2O6Yo'));

});



parcelRegister("4ipZd", function(module, exports) {

$parcel$export(module.exports, "SmartCreateSessionRoute", () => $34b167dbf36a3476$export$e5aba8e833bde761);

var $gwFzn = parcelRequire("gwFzn");

var $1u0ou = parcelRequire("1u0ou");

var $4l6Wo = parcelRequire("4l6Wo");

var $9wGTI = parcelRequire("9wGTI");
const $34b167dbf36a3476$export$e5aba8e833bde761 = (routeMatch)=>{
    if (!(0, $9wGTI.fg)('confluence_ai_create_menu_item')) return;
    const sessionId = routeMatch?.params?.sessionId;
    const spaceKey = routeMatch?.query?.spaceKey || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1u0ou.SmartCreateSessionLoader), {
        spaceKey: spaceKey,
        sessionId: sessionId
    });
};
$34b167dbf36a3476$export$e5aba8e833bde761.NAVIGATION_PARAMS = (routeMatch)=>{
    const spaceKey = routeMatch?.query?.spaceKey ?? '';
    const sessionId = routeMatch?.params?.sessionId ?? '';
    return {
        Screen: {
            screenEvent: {
                name: 'smartCreateSessionScreen'
            },
            pageState: {
                spaceKey: spaceKey,
                sessionId: sessionId,
                routeName: routeMatch.name
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: (0, $4l6Wo.CONTAINER_HOME_ID)
        }
    };
};

});
parcelRegister("1u0ou", function(module, exports) {

$parcel$export(module.exports, "SmartCreateSessionLoader", () => $89890ffd0e65684a$export$5db89f273a075771);

var $jmjWc = parcelRequire("jmjWc");

const $89890ffd0e65684a$export$5db89f273a075771 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "q5hy0",
    name: 'SmartCreateSession',
    loader: async ()=>(await (parcelRequire("39Hxr"))).SmartCreateSession
});

});
parcelRegister("39Hxr", function(module, exports) {

let $24c3fc2d72a46246$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $24c3fc2d72a46246$var$load("buFAk").then(()=>parcelRequire('dNbOB'));

});






//# sourceMappingURL=tinyEditorComponentsPreloader.a61a7b56.js.map
